(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["calliaui"] = factory();
	else
		root["calliaui"] = factory();
})((typeof self !== 'undefined' ? self : this), function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "fb15");
/******/ })
/************************************************************************/
/******/ ({

/***/ "021b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_7_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_7_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_Cal_Img_vue_vue_type_style_index_0_id_2a3f6274_prod_scoped_true_lang_css__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("0b1d");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_7_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_7_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_Cal_Img_vue_vue_type_style_index_0_id_2a3f6274_prod_scoped_true_lang_css__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_7_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_7_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_Cal_Img_vue_vue_type_style_index_0_id_2a3f6274_prod_scoped_true_lang_css__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "02fd":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "0b1d":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "15f5":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "818a":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_7_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_7_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_Image_Carousel_vue_vue_type_style_index_0_id_ecb32b94_prod_lang_css__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("fe30");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_7_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_7_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_Image_Carousel_vue_vue_type_style_index_0_id_ecb32b94_prod_lang_css__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_7_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_7_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_Image_Carousel_vue_vue_type_style_index_0_id_ecb32b94_prod_lang_css__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "8875":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;// addapted from the document.currentScript polyfill by Adam Miller
// MIT license
// source: https://github.com/amiller-gh/currentScript-polyfill

// added support for Firefox https://bugzilla.mozilla.org/show_bug.cgi?id=1620505

(function (root, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else {}
}(typeof self !== 'undefined' ? self : this, function () {
  function getCurrentScript () {
    var descriptor = Object.getOwnPropertyDescriptor(document, 'currentScript')
    // for chrome
    if (!descriptor && 'currentScript' in document && document.currentScript) {
      return document.currentScript
    }

    // for other browsers with native support for currentScript
    if (descriptor && descriptor.get !== getCurrentScript && document.currentScript) {
      return document.currentScript
    }
  
    // IE 8-10 support script readyState
    // IE 11+ & Firefox support stack trace
    try {
      throw new Error();
    }
    catch (err) {
      // Find the second match for the "at" string to get file src url from stack.
      var ieStackRegExp = /.*at [^(]*\((.*):(.+):(.+)\)$/ig,
        ffStackRegExp = /@([^@]*):(\d+):(\d+)\s*$/ig,
        stackDetails = ieStackRegExp.exec(err.stack) || ffStackRegExp.exec(err.stack),
        scriptLocation = (stackDetails && stackDetails[1]) || false,
        line = (stackDetails && stackDetails[2]) || false,
        currentLocation = document.location.href.replace(document.location.hash, ''),
        pageSource,
        inlineScriptSourceRegExp,
        inlineScriptSource,
        scripts = document.getElementsByTagName('script'); // Live NodeList collection
  
      if (scriptLocation === currentLocation) {
        pageSource = document.documentElement.outerHTML;
        inlineScriptSourceRegExp = new RegExp('(?:[^\\n]+?\\n){0,' + (line - 2) + '}[^<]*<script>([\\d\\D]*?)<\\/script>[\\d\\D]*', 'i');
        inlineScriptSource = pageSource.replace(inlineScriptSourceRegExp, '$1').trim();
      }
  
      for (var i = 0; i < scripts.length; i++) {
        // If ready state is interactive, return the script tag
        if (scripts[i].readyState === 'interactive') {
          return scripts[i];
        }
  
        // If src matches, return the script tag
        if (scripts[i].src === scriptLocation) {
          return scripts[i];
        }
  
        // If inline source matches, return the script tag
        if (
          scriptLocation === currentLocation &&
          scripts[i].innerHTML &&
          scripts[i].innerHTML.trim() === inlineScriptSource
        ) {
          return scripts[i];
        }
      }
  
      // If no match, return null
      return null;
    }
  };

  return getCurrentScript
}));


/***/ }),

/***/ "becb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_7_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_7_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_Cal_Video_vue_vue_type_style_index_0_id_5fd6bc21_prod_scoped_true_lang_css__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("02fd");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_7_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_7_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_Cal_Video_vue_vue_type_style_index_0_id_5fd6bc21_prod_scoped_true_lang_css__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_7_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_7_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_Cal_Video_vue_vue_type_style_index_0_id_5fd6bc21_prod_scoped_true_lang_css__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "c8b5":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/*! Hammer.JS - v2.0.7 - 2016-04-22
 * http://hammerjs.github.io/
 *
 * Copyright (c) 2016 Jorik Tangelder;
 * Licensed under the MIT license */
(function(window, document, exportName, undefined) {
  'use strict';

var VENDOR_PREFIXES = ['', 'webkit', 'Moz', 'MS', 'ms', 'o'];
var TEST_ELEMENT = document.createElement('div');

var TYPE_FUNCTION = 'function';

var round = Math.round;
var abs = Math.abs;
var now = Date.now;

/**
 * set a timeout with a given scope
 * @param {Function} fn
 * @param {Number} timeout
 * @param {Object} context
 * @returns {number}
 */
function setTimeoutContext(fn, timeout, context) {
    return setTimeout(bindFn(fn, context), timeout);
}

/**
 * if the argument is an array, we want to execute the fn on each entry
 * if it aint an array we don't want to do a thing.
 * this is used by all the methods that accept a single and array argument.
 * @param {*|Array} arg
 * @param {String} fn
 * @param {Object} [context]
 * @returns {Boolean}
 */
function invokeArrayArg(arg, fn, context) {
    if (Array.isArray(arg)) {
        each(arg, context[fn], context);
        return true;
    }
    return false;
}

/**
 * walk objects and arrays
 * @param {Object} obj
 * @param {Function} iterator
 * @param {Object} context
 */
function each(obj, iterator, context) {
    var i;

    if (!obj) {
        return;
    }

    if (obj.forEach) {
        obj.forEach(iterator, context);
    } else if (obj.length !== undefined) {
        i = 0;
        while (i < obj.length) {
            iterator.call(context, obj[i], i, obj);
            i++;
        }
    } else {
        for (i in obj) {
            obj.hasOwnProperty(i) && iterator.call(context, obj[i], i, obj);
        }
    }
}

/**
 * wrap a method with a deprecation warning and stack trace
 * @param {Function} method
 * @param {String} name
 * @param {String} message
 * @returns {Function} A new function wrapping the supplied method.
 */
function deprecate(method, name, message) {
    var deprecationMessage = 'DEPRECATED METHOD: ' + name + '\n' + message + ' AT \n';
    return function() {
        var e = new Error('get-stack-trace');
        var stack = e && e.stack ? e.stack.replace(/^[^\(]+?[\n$]/gm, '')
            .replace(/^\s+at\s+/gm, '')
            .replace(/^Object.<anonymous>\s*\(/gm, '{anonymous}()@') : 'Unknown Stack Trace';

        var log = window.console && (window.console.warn || window.console.log);
        if (log) {
            log.call(window.console, deprecationMessage, stack);
        }
        return method.apply(this, arguments);
    };
}

/**
 * extend object.
 * means that properties in dest will be overwritten by the ones in src.
 * @param {Object} target
 * @param {...Object} objects_to_assign
 * @returns {Object} target
 */
var assign;
if (typeof Object.assign !== 'function') {
    assign = function assign(target) {
        if (target === undefined || target === null) {
            throw new TypeError('Cannot convert undefined or null to object');
        }

        var output = Object(target);
        for (var index = 1; index < arguments.length; index++) {
            var source = arguments[index];
            if (source !== undefined && source !== null) {
                for (var nextKey in source) {
                    if (source.hasOwnProperty(nextKey)) {
                        output[nextKey] = source[nextKey];
                    }
                }
            }
        }
        return output;
    };
} else {
    assign = Object.assign;
}

/**
 * extend object.
 * means that properties in dest will be overwritten by the ones in src.
 * @param {Object} dest
 * @param {Object} src
 * @param {Boolean} [merge=false]
 * @returns {Object} dest
 */
var extend = deprecate(function extend(dest, src, merge) {
    var keys = Object.keys(src);
    var i = 0;
    while (i < keys.length) {
        if (!merge || (merge && dest[keys[i]] === undefined)) {
            dest[keys[i]] = src[keys[i]];
        }
        i++;
    }
    return dest;
}, 'extend', 'Use `assign`.');

/**
 * merge the values from src in the dest.
 * means that properties that exist in dest will not be overwritten by src
 * @param {Object} dest
 * @param {Object} src
 * @returns {Object} dest
 */
var merge = deprecate(function merge(dest, src) {
    return extend(dest, src, true);
}, 'merge', 'Use `assign`.');

/**
 * simple class inheritance
 * @param {Function} child
 * @param {Function} base
 * @param {Object} [properties]
 */
function inherit(child, base, properties) {
    var baseP = base.prototype,
        childP;

    childP = child.prototype = Object.create(baseP);
    childP.constructor = child;
    childP._super = baseP;

    if (properties) {
        assign(childP, properties);
    }
}

/**
 * simple function bind
 * @param {Function} fn
 * @param {Object} context
 * @returns {Function}
 */
function bindFn(fn, context) {
    return function boundFn() {
        return fn.apply(context, arguments);
    };
}

/**
 * let a boolean value also be a function that must return a boolean
 * this first item in args will be used as the context
 * @param {Boolean|Function} val
 * @param {Array} [args]
 * @returns {Boolean}
 */
function boolOrFn(val, args) {
    if (typeof val == TYPE_FUNCTION) {
        return val.apply(args ? args[0] || undefined : undefined, args);
    }
    return val;
}

/**
 * use the val2 when val1 is undefined
 * @param {*} val1
 * @param {*} val2
 * @returns {*}
 */
function ifUndefined(val1, val2) {
    return (val1 === undefined) ? val2 : val1;
}

/**
 * addEventListener with multiple events at once
 * @param {EventTarget} target
 * @param {String} types
 * @param {Function} handler
 */
function addEventListeners(target, types, handler) {
    each(splitStr(types), function(type) {
        target.addEventListener(type, handler, false);
    });
}

/**
 * removeEventListener with multiple events at once
 * @param {EventTarget} target
 * @param {String} types
 * @param {Function} handler
 */
function removeEventListeners(target, types, handler) {
    each(splitStr(types), function(type) {
        target.removeEventListener(type, handler, false);
    });
}

/**
 * find if a node is in the given parent
 * @method hasParent
 * @param {HTMLElement} node
 * @param {HTMLElement} parent
 * @return {Boolean} found
 */
function hasParent(node, parent) {
    while (node) {
        if (node == parent) {
            return true;
        }
        node = node.parentNode;
    }
    return false;
}

/**
 * small indexOf wrapper
 * @param {String} str
 * @param {String} find
 * @returns {Boolean} found
 */
function inStr(str, find) {
    return str.indexOf(find) > -1;
}

/**
 * split string on whitespace
 * @param {String} str
 * @returns {Array} words
 */
function splitStr(str) {
    return str.trim().split(/\s+/g);
}

/**
 * find if a array contains the object using indexOf or a simple polyFill
 * @param {Array} src
 * @param {String} find
 * @param {String} [findByKey]
 * @return {Boolean|Number} false when not found, or the index
 */
function inArray(src, find, findByKey) {
    if (src.indexOf && !findByKey) {
        return src.indexOf(find);
    } else {
        var i = 0;
        while (i < src.length) {
            if ((findByKey && src[i][findByKey] == find) || (!findByKey && src[i] === find)) {
                return i;
            }
            i++;
        }
        return -1;
    }
}

/**
 * convert array-like objects to real arrays
 * @param {Object} obj
 * @returns {Array}
 */
function toArray(obj) {
    return Array.prototype.slice.call(obj, 0);
}

/**
 * unique array with objects based on a key (like 'id') or just by the array's value
 * @param {Array} src [{id:1},{id:2},{id:1}]
 * @param {String} [key]
 * @param {Boolean} [sort=False]
 * @returns {Array} [{id:1},{id:2}]
 */
function uniqueArray(src, key, sort) {
    var results = [];
    var values = [];
    var i = 0;

    while (i < src.length) {
        var val = key ? src[i][key] : src[i];
        if (inArray(values, val) < 0) {
            results.push(src[i]);
        }
        values[i] = val;
        i++;
    }

    if (sort) {
        if (!key) {
            results = results.sort();
        } else {
            results = results.sort(function sortUniqueArray(a, b) {
                return a[key] > b[key];
            });
        }
    }

    return results;
}

/**
 * get the prefixed property
 * @param {Object} obj
 * @param {String} property
 * @returns {String|Undefined} prefixed
 */
function prefixed(obj, property) {
    var prefix, prop;
    var camelProp = property[0].toUpperCase() + property.slice(1);

    var i = 0;
    while (i < VENDOR_PREFIXES.length) {
        prefix = VENDOR_PREFIXES[i];
        prop = (prefix) ? prefix + camelProp : property;

        if (prop in obj) {
            return prop;
        }
        i++;
    }
    return undefined;
}

/**
 * get a unique id
 * @returns {number} uniqueId
 */
var _uniqueId = 1;
function uniqueId() {
    return _uniqueId++;
}

/**
 * get the window object of an element
 * @param {HTMLElement} element
 * @returns {DocumentView|Window}
 */
function getWindowForElement(element) {
    var doc = element.ownerDocument || element;
    return (doc.defaultView || doc.parentWindow || window);
}

var MOBILE_REGEX = /mobile|tablet|ip(ad|hone|od)|android/i;

var SUPPORT_TOUCH = ('ontouchstart' in window);
var SUPPORT_POINTER_EVENTS = prefixed(window, 'PointerEvent') !== undefined;
var SUPPORT_ONLY_TOUCH = SUPPORT_TOUCH && MOBILE_REGEX.test(navigator.userAgent);

var INPUT_TYPE_TOUCH = 'touch';
var INPUT_TYPE_PEN = 'pen';
var INPUT_TYPE_MOUSE = 'mouse';
var INPUT_TYPE_KINECT = 'kinect';

var COMPUTE_INTERVAL = 25;

var INPUT_START = 1;
var INPUT_MOVE = 2;
var INPUT_END = 4;
var INPUT_CANCEL = 8;

var DIRECTION_NONE = 1;
var DIRECTION_LEFT = 2;
var DIRECTION_RIGHT = 4;
var DIRECTION_UP = 8;
var DIRECTION_DOWN = 16;

var DIRECTION_HORIZONTAL = DIRECTION_LEFT | DIRECTION_RIGHT;
var DIRECTION_VERTICAL = DIRECTION_UP | DIRECTION_DOWN;
var DIRECTION_ALL = DIRECTION_HORIZONTAL | DIRECTION_VERTICAL;

var PROPS_XY = ['x', 'y'];
var PROPS_CLIENT_XY = ['clientX', 'clientY'];

/**
 * create new input type manager
 * @param {Manager} manager
 * @param {Function} callback
 * @returns {Input}
 * @constructor
 */
function Input(manager, callback) {
    var self = this;
    this.manager = manager;
    this.callback = callback;
    this.element = manager.element;
    this.target = manager.options.inputTarget;

    // smaller wrapper around the handler, for the scope and the enabled state of the manager,
    // so when disabled the input events are completely bypassed.
    this.domHandler = function(ev) {
        if (boolOrFn(manager.options.enable, [manager])) {
            self.handler(ev);
        }
    };

    this.init();

}

Input.prototype = {
    /**
     * should handle the inputEvent data and trigger the callback
     * @virtual
     */
    handler: function() { },

    /**
     * bind the events
     */
    init: function() {
        this.evEl && addEventListeners(this.element, this.evEl, this.domHandler);
        this.evTarget && addEventListeners(this.target, this.evTarget, this.domHandler);
        this.evWin && addEventListeners(getWindowForElement(this.element), this.evWin, this.domHandler);
    },

    /**
     * unbind the events
     */
    destroy: function() {
        this.evEl && removeEventListeners(this.element, this.evEl, this.domHandler);
        this.evTarget && removeEventListeners(this.target, this.evTarget, this.domHandler);
        this.evWin && removeEventListeners(getWindowForElement(this.element), this.evWin, this.domHandler);
    }
};

/**
 * create new input type manager
 * called by the Manager constructor
 * @param {Hammer} manager
 * @returns {Input}
 */
function createInputInstance(manager) {
    var Type;
    var inputClass = manager.options.inputClass;

    if (inputClass) {
        Type = inputClass;
    } else if (SUPPORT_POINTER_EVENTS) {
        Type = PointerEventInput;
    } else if (SUPPORT_ONLY_TOUCH) {
        Type = TouchInput;
    } else if (!SUPPORT_TOUCH) {
        Type = MouseInput;
    } else {
        Type = TouchMouseInput;
    }
    return new (Type)(manager, inputHandler);
}

/**
 * handle input events
 * @param {Manager} manager
 * @param {String} eventType
 * @param {Object} input
 */
function inputHandler(manager, eventType, input) {
    var pointersLen = input.pointers.length;
    var changedPointersLen = input.changedPointers.length;
    var isFirst = (eventType & INPUT_START && (pointersLen - changedPointersLen === 0));
    var isFinal = (eventType & (INPUT_END | INPUT_CANCEL) && (pointersLen - changedPointersLen === 0));

    input.isFirst = !!isFirst;
    input.isFinal = !!isFinal;

    if (isFirst) {
        manager.session = {};
    }

    // source event is the normalized value of the domEvents
    // like 'touchstart, mouseup, pointerdown'
    input.eventType = eventType;

    // compute scale, rotation etc
    computeInputData(manager, input);

    // emit secret event
    manager.emit('hammer.input', input);

    manager.recognize(input);
    manager.session.prevInput = input;
}

/**
 * extend the data with some usable properties like scale, rotate, velocity etc
 * @param {Object} manager
 * @param {Object} input
 */
function computeInputData(manager, input) {
    var session = manager.session;
    var pointers = input.pointers;
    var pointersLength = pointers.length;

    // store the first input to calculate the distance and direction
    if (!session.firstInput) {
        session.firstInput = simpleCloneInputData(input);
    }

    // to compute scale and rotation we need to store the multiple touches
    if (pointersLength > 1 && !session.firstMultiple) {
        session.firstMultiple = simpleCloneInputData(input);
    } else if (pointersLength === 1) {
        session.firstMultiple = false;
    }

    var firstInput = session.firstInput;
    var firstMultiple = session.firstMultiple;
    var offsetCenter = firstMultiple ? firstMultiple.center : firstInput.center;

    var center = input.center = getCenter(pointers);
    input.timeStamp = now();
    input.deltaTime = input.timeStamp - firstInput.timeStamp;

    input.angle = getAngle(offsetCenter, center);
    input.distance = getDistance(offsetCenter, center);

    computeDeltaXY(session, input);
    input.offsetDirection = getDirection(input.deltaX, input.deltaY);

    var overallVelocity = getVelocity(input.deltaTime, input.deltaX, input.deltaY);
    input.overallVelocityX = overallVelocity.x;
    input.overallVelocityY = overallVelocity.y;
    input.overallVelocity = (abs(overallVelocity.x) > abs(overallVelocity.y)) ? overallVelocity.x : overallVelocity.y;

    input.scale = firstMultiple ? getScale(firstMultiple.pointers, pointers) : 1;
    input.rotation = firstMultiple ? getRotation(firstMultiple.pointers, pointers) : 0;

    input.maxPointers = !session.prevInput ? input.pointers.length : ((input.pointers.length >
        session.prevInput.maxPointers) ? input.pointers.length : session.prevInput.maxPointers);

    computeIntervalInputData(session, input);

    // find the correct target
    var target = manager.element;
    if (hasParent(input.srcEvent.target, target)) {
        target = input.srcEvent.target;
    }
    input.target = target;
}

function computeDeltaXY(session, input) {
    var center = input.center;
    var offset = session.offsetDelta || {};
    var prevDelta = session.prevDelta || {};
    var prevInput = session.prevInput || {};

    if (input.eventType === INPUT_START || prevInput.eventType === INPUT_END) {
        prevDelta = session.prevDelta = {
            x: prevInput.deltaX || 0,
            y: prevInput.deltaY || 0
        };

        offset = session.offsetDelta = {
            x: center.x,
            y: center.y
        };
    }

    input.deltaX = prevDelta.x + (center.x - offset.x);
    input.deltaY = prevDelta.y + (center.y - offset.y);
}

/**
 * velocity is calculated every x ms
 * @param {Object} session
 * @param {Object} input
 */
function computeIntervalInputData(session, input) {
    var last = session.lastInterval || input,
        deltaTime = input.timeStamp - last.timeStamp,
        velocity, velocityX, velocityY, direction;

    if (input.eventType != INPUT_CANCEL && (deltaTime > COMPUTE_INTERVAL || last.velocity === undefined)) {
        var deltaX = input.deltaX - last.deltaX;
        var deltaY = input.deltaY - last.deltaY;

        var v = getVelocity(deltaTime, deltaX, deltaY);
        velocityX = v.x;
        velocityY = v.y;
        velocity = (abs(v.x) > abs(v.y)) ? v.x : v.y;
        direction = getDirection(deltaX, deltaY);

        session.lastInterval = input;
    } else {
        // use latest velocity info if it doesn't overtake a minimum period
        velocity = last.velocity;
        velocityX = last.velocityX;
        velocityY = last.velocityY;
        direction = last.direction;
    }

    input.velocity = velocity;
    input.velocityX = velocityX;
    input.velocityY = velocityY;
    input.direction = direction;
}

/**
 * create a simple clone from the input used for storage of firstInput and firstMultiple
 * @param {Object} input
 * @returns {Object} clonedInputData
 */
function simpleCloneInputData(input) {
    // make a simple copy of the pointers because we will get a reference if we don't
    // we only need clientXY for the calculations
    var pointers = [];
    var i = 0;
    while (i < input.pointers.length) {
        pointers[i] = {
            clientX: round(input.pointers[i].clientX),
            clientY: round(input.pointers[i].clientY)
        };
        i++;
    }

    return {
        timeStamp: now(),
        pointers: pointers,
        center: getCenter(pointers),
        deltaX: input.deltaX,
        deltaY: input.deltaY
    };
}

/**
 * get the center of all the pointers
 * @param {Array} pointers
 * @return {Object} center contains `x` and `y` properties
 */
function getCenter(pointers) {
    var pointersLength = pointers.length;

    // no need to loop when only one touch
    if (pointersLength === 1) {
        return {
            x: round(pointers[0].clientX),
            y: round(pointers[0].clientY)
        };
    }

    var x = 0, y = 0, i = 0;
    while (i < pointersLength) {
        x += pointers[i].clientX;
        y += pointers[i].clientY;
        i++;
    }

    return {
        x: round(x / pointersLength),
        y: round(y / pointersLength)
    };
}

/**
 * calculate the velocity between two points. unit is in px per ms.
 * @param {Number} deltaTime
 * @param {Number} x
 * @param {Number} y
 * @return {Object} velocity `x` and `y`
 */
function getVelocity(deltaTime, x, y) {
    return {
        x: x / deltaTime || 0,
        y: y / deltaTime || 0
    };
}

/**
 * get the direction between two points
 * @param {Number} x
 * @param {Number} y
 * @return {Number} direction
 */
function getDirection(x, y) {
    if (x === y) {
        return DIRECTION_NONE;
    }

    if (abs(x) >= abs(y)) {
        return x < 0 ? DIRECTION_LEFT : DIRECTION_RIGHT;
    }
    return y < 0 ? DIRECTION_UP : DIRECTION_DOWN;
}

/**
 * calculate the absolute distance between two points
 * @param {Object} p1 {x, y}
 * @param {Object} p2 {x, y}
 * @param {Array} [props] containing x and y keys
 * @return {Number} distance
 */
function getDistance(p1, p2, props) {
    if (!props) {
        props = PROPS_XY;
    }
    var x = p2[props[0]] - p1[props[0]],
        y = p2[props[1]] - p1[props[1]];

    return Math.sqrt((x * x) + (y * y));
}

/**
 * calculate the angle between two coordinates
 * @param {Object} p1
 * @param {Object} p2
 * @param {Array} [props] containing x and y keys
 * @return {Number} angle
 */
function getAngle(p1, p2, props) {
    if (!props) {
        props = PROPS_XY;
    }
    var x = p2[props[0]] - p1[props[0]],
        y = p2[props[1]] - p1[props[1]];
    return Math.atan2(y, x) * 180 / Math.PI;
}

/**
 * calculate the rotation degrees between two pointersets
 * @param {Array} start array of pointers
 * @param {Array} end array of pointers
 * @return {Number} rotation
 */
function getRotation(start, end) {
    return getAngle(end[1], end[0], PROPS_CLIENT_XY) + getAngle(start[1], start[0], PROPS_CLIENT_XY);
}

/**
 * calculate the scale factor between two pointersets
 * no scale is 1, and goes down to 0 when pinched together, and bigger when pinched out
 * @param {Array} start array of pointers
 * @param {Array} end array of pointers
 * @return {Number} scale
 */
function getScale(start, end) {
    return getDistance(end[0], end[1], PROPS_CLIENT_XY) / getDistance(start[0], start[1], PROPS_CLIENT_XY);
}

var MOUSE_INPUT_MAP = {
    mousedown: INPUT_START,
    mousemove: INPUT_MOVE,
    mouseup: INPUT_END
};

var MOUSE_ELEMENT_EVENTS = 'mousedown';
var MOUSE_WINDOW_EVENTS = 'mousemove mouseup';

/**
 * Mouse events input
 * @constructor
 * @extends Input
 */
function MouseInput() {
    this.evEl = MOUSE_ELEMENT_EVENTS;
    this.evWin = MOUSE_WINDOW_EVENTS;

    this.pressed = false; // mousedown state

    Input.apply(this, arguments);
}

inherit(MouseInput, Input, {
    /**
     * handle mouse events
     * @param {Object} ev
     */
    handler: function MEhandler(ev) {
        var eventType = MOUSE_INPUT_MAP[ev.type];

        // on start we want to have the left mouse button down
        if (eventType & INPUT_START && ev.button === 0) {
            this.pressed = true;
        }

        if (eventType & INPUT_MOVE && ev.which !== 1) {
            eventType = INPUT_END;
        }

        // mouse must be down
        if (!this.pressed) {
            return;
        }

        if (eventType & INPUT_END) {
            this.pressed = false;
        }

        this.callback(this.manager, eventType, {
            pointers: [ev],
            changedPointers: [ev],
            pointerType: INPUT_TYPE_MOUSE,
            srcEvent: ev
        });
    }
});

var POINTER_INPUT_MAP = {
    pointerdown: INPUT_START,
    pointermove: INPUT_MOVE,
    pointerup: INPUT_END,
    pointercancel: INPUT_CANCEL,
    pointerout: INPUT_CANCEL
};

// in IE10 the pointer types is defined as an enum
var IE10_POINTER_TYPE_ENUM = {
    2: INPUT_TYPE_TOUCH,
    3: INPUT_TYPE_PEN,
    4: INPUT_TYPE_MOUSE,
    5: INPUT_TYPE_KINECT // see https://twitter.com/jacobrossi/status/480596438489890816
};

var POINTER_ELEMENT_EVENTS = 'pointerdown';
var POINTER_WINDOW_EVENTS = 'pointermove pointerup pointercancel';

// IE10 has prefixed support, and case-sensitive
if (window.MSPointerEvent && !window.PointerEvent) {
    POINTER_ELEMENT_EVENTS = 'MSPointerDown';
    POINTER_WINDOW_EVENTS = 'MSPointerMove MSPointerUp MSPointerCancel';
}

/**
 * Pointer events input
 * @constructor
 * @extends Input
 */
function PointerEventInput() {
    this.evEl = POINTER_ELEMENT_EVENTS;
    this.evWin = POINTER_WINDOW_EVENTS;

    Input.apply(this, arguments);

    this.store = (this.manager.session.pointerEvents = []);
}

inherit(PointerEventInput, Input, {
    /**
     * handle mouse events
     * @param {Object} ev
     */
    handler: function PEhandler(ev) {
        var store = this.store;
        var removePointer = false;

        var eventTypeNormalized = ev.type.toLowerCase().replace('ms', '');
        var eventType = POINTER_INPUT_MAP[eventTypeNormalized];
        var pointerType = IE10_POINTER_TYPE_ENUM[ev.pointerType] || ev.pointerType;

        var isTouch = (pointerType == INPUT_TYPE_TOUCH);

        // get index of the event in the store
        var storeIndex = inArray(store, ev.pointerId, 'pointerId');

        // start and mouse must be down
        if (eventType & INPUT_START && (ev.button === 0 || isTouch)) {
            if (storeIndex < 0) {
                store.push(ev);
                storeIndex = store.length - 1;
            }
        } else if (eventType & (INPUT_END | INPUT_CANCEL)) {
            removePointer = true;
        }

        // it not found, so the pointer hasn't been down (so it's probably a hover)
        if (storeIndex < 0) {
            return;
        }

        // update the event in the store
        store[storeIndex] = ev;

        this.callback(this.manager, eventType, {
            pointers: store,
            changedPointers: [ev],
            pointerType: pointerType,
            srcEvent: ev
        });

        if (removePointer) {
            // remove from the store
            store.splice(storeIndex, 1);
        }
    }
});

var SINGLE_TOUCH_INPUT_MAP = {
    touchstart: INPUT_START,
    touchmove: INPUT_MOVE,
    touchend: INPUT_END,
    touchcancel: INPUT_CANCEL
};

var SINGLE_TOUCH_TARGET_EVENTS = 'touchstart';
var SINGLE_TOUCH_WINDOW_EVENTS = 'touchstart touchmove touchend touchcancel';

/**
 * Touch events input
 * @constructor
 * @extends Input
 */
function SingleTouchInput() {
    this.evTarget = SINGLE_TOUCH_TARGET_EVENTS;
    this.evWin = SINGLE_TOUCH_WINDOW_EVENTS;
    this.started = false;

    Input.apply(this, arguments);
}

inherit(SingleTouchInput, Input, {
    handler: function TEhandler(ev) {
        var type = SINGLE_TOUCH_INPUT_MAP[ev.type];

        // should we handle the touch events?
        if (type === INPUT_START) {
            this.started = true;
        }

        if (!this.started) {
            return;
        }

        var touches = normalizeSingleTouches.call(this, ev, type);

        // when done, reset the started state
        if (type & (INPUT_END | INPUT_CANCEL) && touches[0].length - touches[1].length === 0) {
            this.started = false;
        }

        this.callback(this.manager, type, {
            pointers: touches[0],
            changedPointers: touches[1],
            pointerType: INPUT_TYPE_TOUCH,
            srcEvent: ev
        });
    }
});

/**
 * @this {TouchInput}
 * @param {Object} ev
 * @param {Number} type flag
 * @returns {undefined|Array} [all, changed]
 */
function normalizeSingleTouches(ev, type) {
    var all = toArray(ev.touches);
    var changed = toArray(ev.changedTouches);

    if (type & (INPUT_END | INPUT_CANCEL)) {
        all = uniqueArray(all.concat(changed), 'identifier', true);
    }

    return [all, changed];
}

var TOUCH_INPUT_MAP = {
    touchstart: INPUT_START,
    touchmove: INPUT_MOVE,
    touchend: INPUT_END,
    touchcancel: INPUT_CANCEL
};

var TOUCH_TARGET_EVENTS = 'touchstart touchmove touchend touchcancel';

/**
 * Multi-user touch events input
 * @constructor
 * @extends Input
 */
function TouchInput() {
    this.evTarget = TOUCH_TARGET_EVENTS;
    this.targetIds = {};

    Input.apply(this, arguments);
}

inherit(TouchInput, Input, {
    handler: function MTEhandler(ev) {
        var type = TOUCH_INPUT_MAP[ev.type];
        var touches = getTouches.call(this, ev, type);
        if (!touches) {
            return;
        }

        this.callback(this.manager, type, {
            pointers: touches[0],
            changedPointers: touches[1],
            pointerType: INPUT_TYPE_TOUCH,
            srcEvent: ev
        });
    }
});

/**
 * @this {TouchInput}
 * @param {Object} ev
 * @param {Number} type flag
 * @returns {undefined|Array} [all, changed]
 */
function getTouches(ev, type) {
    var allTouches = toArray(ev.touches);
    var targetIds = this.targetIds;

    // when there is only one touch, the process can be simplified
    if (type & (INPUT_START | INPUT_MOVE) && allTouches.length === 1) {
        targetIds[allTouches[0].identifier] = true;
        return [allTouches, allTouches];
    }

    var i,
        targetTouches,
        changedTouches = toArray(ev.changedTouches),
        changedTargetTouches = [],
        target = this.target;

    // get target touches from touches
    targetTouches = allTouches.filter(function(touch) {
        return hasParent(touch.target, target);
    });

    // collect touches
    if (type === INPUT_START) {
        i = 0;
        while (i < targetTouches.length) {
            targetIds[targetTouches[i].identifier] = true;
            i++;
        }
    }

    // filter changed touches to only contain touches that exist in the collected target ids
    i = 0;
    while (i < changedTouches.length) {
        if (targetIds[changedTouches[i].identifier]) {
            changedTargetTouches.push(changedTouches[i]);
        }

        // cleanup removed touches
        if (type & (INPUT_END | INPUT_CANCEL)) {
            delete targetIds[changedTouches[i].identifier];
        }
        i++;
    }

    if (!changedTargetTouches.length) {
        return;
    }

    return [
        // merge targetTouches with changedTargetTouches so it contains ALL touches, including 'end' and 'cancel'
        uniqueArray(targetTouches.concat(changedTargetTouches), 'identifier', true),
        changedTargetTouches
    ];
}

/**
 * Combined touch and mouse input
 *
 * Touch has a higher priority then mouse, and while touching no mouse events are allowed.
 * This because touch devices also emit mouse events while doing a touch.
 *
 * @constructor
 * @extends Input
 */

var DEDUP_TIMEOUT = 2500;
var DEDUP_DISTANCE = 25;

function TouchMouseInput() {
    Input.apply(this, arguments);

    var handler = bindFn(this.handler, this);
    this.touch = new TouchInput(this.manager, handler);
    this.mouse = new MouseInput(this.manager, handler);

    this.primaryTouch = null;
    this.lastTouches = [];
}

inherit(TouchMouseInput, Input, {
    /**
     * handle mouse and touch events
     * @param {Hammer} manager
     * @param {String} inputEvent
     * @param {Object} inputData
     */
    handler: function TMEhandler(manager, inputEvent, inputData) {
        var isTouch = (inputData.pointerType == INPUT_TYPE_TOUCH),
            isMouse = (inputData.pointerType == INPUT_TYPE_MOUSE);

        if (isMouse && inputData.sourceCapabilities && inputData.sourceCapabilities.firesTouchEvents) {
            return;
        }

        // when we're in a touch event, record touches to  de-dupe synthetic mouse event
        if (isTouch) {
            recordTouches.call(this, inputEvent, inputData);
        } else if (isMouse && isSyntheticEvent.call(this, inputData)) {
            return;
        }

        this.callback(manager, inputEvent, inputData);
    },

    /**
     * remove the event listeners
     */
    destroy: function destroy() {
        this.touch.destroy();
        this.mouse.destroy();
    }
});

function recordTouches(eventType, eventData) {
    if (eventType & INPUT_START) {
        this.primaryTouch = eventData.changedPointers[0].identifier;
        setLastTouch.call(this, eventData);
    } else if (eventType & (INPUT_END | INPUT_CANCEL)) {
        setLastTouch.call(this, eventData);
    }
}

function setLastTouch(eventData) {
    var touch = eventData.changedPointers[0];

    if (touch.identifier === this.primaryTouch) {
        var lastTouch = {x: touch.clientX, y: touch.clientY};
        this.lastTouches.push(lastTouch);
        var lts = this.lastTouches;
        var removeLastTouch = function() {
            var i = lts.indexOf(lastTouch);
            if (i > -1) {
                lts.splice(i, 1);
            }
        };
        setTimeout(removeLastTouch, DEDUP_TIMEOUT);
    }
}

function isSyntheticEvent(eventData) {
    var x = eventData.srcEvent.clientX, y = eventData.srcEvent.clientY;
    for (var i = 0; i < this.lastTouches.length; i++) {
        var t = this.lastTouches[i];
        var dx = Math.abs(x - t.x), dy = Math.abs(y - t.y);
        if (dx <= DEDUP_DISTANCE && dy <= DEDUP_DISTANCE) {
            return true;
        }
    }
    return false;
}

var PREFIXED_TOUCH_ACTION = prefixed(TEST_ELEMENT.style, 'touchAction');
var NATIVE_TOUCH_ACTION = PREFIXED_TOUCH_ACTION !== undefined;

// magical touchAction value
var TOUCH_ACTION_COMPUTE = 'compute';
var TOUCH_ACTION_AUTO = 'auto';
var TOUCH_ACTION_MANIPULATION = 'manipulation'; // not implemented
var TOUCH_ACTION_NONE = 'none';
var TOUCH_ACTION_PAN_X = 'pan-x';
var TOUCH_ACTION_PAN_Y = 'pan-y';
var TOUCH_ACTION_MAP = getTouchActionProps();

/**
 * Touch Action
 * sets the touchAction property or uses the js alternative
 * @param {Manager} manager
 * @param {String} value
 * @constructor
 */
function TouchAction(manager, value) {
    this.manager = manager;
    this.set(value);
}

TouchAction.prototype = {
    /**
     * set the touchAction value on the element or enable the polyfill
     * @param {String} value
     */
    set: function(value) {
        // find out the touch-action by the event handlers
        if (value == TOUCH_ACTION_COMPUTE) {
            value = this.compute();
        }

        if (NATIVE_TOUCH_ACTION && this.manager.element.style && TOUCH_ACTION_MAP[value]) {
            this.manager.element.style[PREFIXED_TOUCH_ACTION] = value;
        }
        this.actions = value.toLowerCase().trim();
    },

    /**
     * just re-set the touchAction value
     */
    update: function() {
        this.set(this.manager.options.touchAction);
    },

    /**
     * compute the value for the touchAction property based on the recognizer's settings
     * @returns {String} value
     */
    compute: function() {
        var actions = [];
        each(this.manager.recognizers, function(recognizer) {
            if (boolOrFn(recognizer.options.enable, [recognizer])) {
                actions = actions.concat(recognizer.getTouchAction());
            }
        });
        return cleanTouchActions(actions.join(' '));
    },

    /**
     * this method is called on each input cycle and provides the preventing of the browser behavior
     * @param {Object} input
     */
    preventDefaults: function(input) {
        var srcEvent = input.srcEvent;
        var direction = input.offsetDirection;

        // if the touch action did prevented once this session
        if (this.manager.session.prevented) {
            srcEvent.preventDefault();
            return;
        }

        var actions = this.actions;
        var hasNone = inStr(actions, TOUCH_ACTION_NONE) && !TOUCH_ACTION_MAP[TOUCH_ACTION_NONE];
        var hasPanY = inStr(actions, TOUCH_ACTION_PAN_Y) && !TOUCH_ACTION_MAP[TOUCH_ACTION_PAN_Y];
        var hasPanX = inStr(actions, TOUCH_ACTION_PAN_X) && !TOUCH_ACTION_MAP[TOUCH_ACTION_PAN_X];

        if (hasNone) {
            //do not prevent defaults if this is a tap gesture

            var isTapPointer = input.pointers.length === 1;
            var isTapMovement = input.distance < 2;
            var isTapTouchTime = input.deltaTime < 250;

            if (isTapPointer && isTapMovement && isTapTouchTime) {
                return;
            }
        }

        if (hasPanX && hasPanY) {
            // `pan-x pan-y` means browser handles all scrolling/panning, do not prevent
            return;
        }

        if (hasNone ||
            (hasPanY && direction & DIRECTION_HORIZONTAL) ||
            (hasPanX && direction & DIRECTION_VERTICAL)) {
            return this.preventSrc(srcEvent);
        }
    },

    /**
     * call preventDefault to prevent the browser's default behavior (scrolling in most cases)
     * @param {Object} srcEvent
     */
    preventSrc: function(srcEvent) {
        this.manager.session.prevented = true;
        srcEvent.preventDefault();
    }
};

/**
 * when the touchActions are collected they are not a valid value, so we need to clean things up. *
 * @param {String} actions
 * @returns {*}
 */
function cleanTouchActions(actions) {
    // none
    if (inStr(actions, TOUCH_ACTION_NONE)) {
        return TOUCH_ACTION_NONE;
    }

    var hasPanX = inStr(actions, TOUCH_ACTION_PAN_X);
    var hasPanY = inStr(actions, TOUCH_ACTION_PAN_Y);

    // if both pan-x and pan-y are set (different recognizers
    // for different directions, e.g. horizontal pan but vertical swipe?)
    // we need none (as otherwise with pan-x pan-y combined none of these
    // recognizers will work, since the browser would handle all panning
    if (hasPanX && hasPanY) {
        return TOUCH_ACTION_NONE;
    }

    // pan-x OR pan-y
    if (hasPanX || hasPanY) {
        return hasPanX ? TOUCH_ACTION_PAN_X : TOUCH_ACTION_PAN_Y;
    }

    // manipulation
    if (inStr(actions, TOUCH_ACTION_MANIPULATION)) {
        return TOUCH_ACTION_MANIPULATION;
    }

    return TOUCH_ACTION_AUTO;
}

function getTouchActionProps() {
    if (!NATIVE_TOUCH_ACTION) {
        return false;
    }
    var touchMap = {};
    var cssSupports = window.CSS && window.CSS.supports;
    ['auto', 'manipulation', 'pan-y', 'pan-x', 'pan-x pan-y', 'none'].forEach(function(val) {

        // If css.supports is not supported but there is native touch-action assume it supports
        // all values. This is the case for IE 10 and 11.
        touchMap[val] = cssSupports ? window.CSS.supports('touch-action', val) : true;
    });
    return touchMap;
}

/**
 * Recognizer flow explained; *
 * All recognizers have the initial state of POSSIBLE when a input session starts.
 * The definition of a input session is from the first input until the last input, with all it's movement in it. *
 * Example session for mouse-input: mousedown -> mousemove -> mouseup
 *
 * On each recognizing cycle (see Manager.recognize) the .recognize() method is executed
 * which determines with state it should be.
 *
 * If the recognizer has the state FAILED, CANCELLED or RECOGNIZED (equals ENDED), it is reset to
 * POSSIBLE to give it another change on the next cycle.
 *
 *               Possible
 *                  |
 *            +-----+---------------+
 *            |                     |
 *      +-----+-----+               |
 *      |           |               |
 *   Failed      Cancelled          |
 *                          +-------+------+
 *                          |              |
 *                      Recognized       Began
 *                                         |
 *                                      Changed
 *                                         |
 *                                  Ended/Recognized
 */
var STATE_POSSIBLE = 1;
var STATE_BEGAN = 2;
var STATE_CHANGED = 4;
var STATE_ENDED = 8;
var STATE_RECOGNIZED = STATE_ENDED;
var STATE_CANCELLED = 16;
var STATE_FAILED = 32;

/**
 * Recognizer
 * Every recognizer needs to extend from this class.
 * @constructor
 * @param {Object} options
 */
function Recognizer(options) {
    this.options = assign({}, this.defaults, options || {});

    this.id = uniqueId();

    this.manager = null;

    // default is enable true
    this.options.enable = ifUndefined(this.options.enable, true);

    this.state = STATE_POSSIBLE;

    this.simultaneous = {};
    this.requireFail = [];
}

Recognizer.prototype = {
    /**
     * @virtual
     * @type {Object}
     */
    defaults: {},

    /**
     * set options
     * @param {Object} options
     * @return {Recognizer}
     */
    set: function(options) {
        assign(this.options, options);

        // also update the touchAction, in case something changed about the directions/enabled state
        this.manager && this.manager.touchAction.update();
        return this;
    },

    /**
     * recognize simultaneous with an other recognizer.
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    recognizeWith: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'recognizeWith', this)) {
            return this;
        }

        var simultaneous = this.simultaneous;
        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        if (!simultaneous[otherRecognizer.id]) {
            simultaneous[otherRecognizer.id] = otherRecognizer;
            otherRecognizer.recognizeWith(this);
        }
        return this;
    },

    /**
     * drop the simultaneous link. it doesnt remove the link on the other recognizer.
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    dropRecognizeWith: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'dropRecognizeWith', this)) {
            return this;
        }

        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        delete this.simultaneous[otherRecognizer.id];
        return this;
    },

    /**
     * recognizer can only run when an other is failing
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    requireFailure: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'requireFailure', this)) {
            return this;
        }

        var requireFail = this.requireFail;
        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        if (inArray(requireFail, otherRecognizer) === -1) {
            requireFail.push(otherRecognizer);
            otherRecognizer.requireFailure(this);
        }
        return this;
    },

    /**
     * drop the requireFailure link. it does not remove the link on the other recognizer.
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    dropRequireFailure: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'dropRequireFailure', this)) {
            return this;
        }

        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        var index = inArray(this.requireFail, otherRecognizer);
        if (index > -1) {
            this.requireFail.splice(index, 1);
        }
        return this;
    },

    /**
     * has require failures boolean
     * @returns {boolean}
     */
    hasRequireFailures: function() {
        return this.requireFail.length > 0;
    },

    /**
     * if the recognizer can recognize simultaneous with an other recognizer
     * @param {Recognizer} otherRecognizer
     * @returns {Boolean}
     */
    canRecognizeWith: function(otherRecognizer) {
        return !!this.simultaneous[otherRecognizer.id];
    },

    /**
     * You should use `tryEmit` instead of `emit` directly to check
     * that all the needed recognizers has failed before emitting.
     * @param {Object} input
     */
    emit: function(input) {
        var self = this;
        var state = this.state;

        function emit(event) {
            self.manager.emit(event, input);
        }

        // 'panstart' and 'panmove'
        if (state < STATE_ENDED) {
            emit(self.options.event + stateStr(state));
        }

        emit(self.options.event); // simple 'eventName' events

        if (input.additionalEvent) { // additional event(panleft, panright, pinchin, pinchout...)
            emit(input.additionalEvent);
        }

        // panend and pancancel
        if (state >= STATE_ENDED) {
            emit(self.options.event + stateStr(state));
        }
    },

    /**
     * Check that all the require failure recognizers has failed,
     * if true, it emits a gesture event,
     * otherwise, setup the state to FAILED.
     * @param {Object} input
     */
    tryEmit: function(input) {
        if (this.canEmit()) {
            return this.emit(input);
        }
        // it's failing anyway
        this.state = STATE_FAILED;
    },

    /**
     * can we emit?
     * @returns {boolean}
     */
    canEmit: function() {
        var i = 0;
        while (i < this.requireFail.length) {
            if (!(this.requireFail[i].state & (STATE_FAILED | STATE_POSSIBLE))) {
                return false;
            }
            i++;
        }
        return true;
    },

    /**
     * update the recognizer
     * @param {Object} inputData
     */
    recognize: function(inputData) {
        // make a new copy of the inputData
        // so we can change the inputData without messing up the other recognizers
        var inputDataClone = assign({}, inputData);

        // is is enabled and allow recognizing?
        if (!boolOrFn(this.options.enable, [this, inputDataClone])) {
            this.reset();
            this.state = STATE_FAILED;
            return;
        }

        // reset when we've reached the end
        if (this.state & (STATE_RECOGNIZED | STATE_CANCELLED | STATE_FAILED)) {
            this.state = STATE_POSSIBLE;
        }

        this.state = this.process(inputDataClone);

        // the recognizer has recognized a gesture
        // so trigger an event
        if (this.state & (STATE_BEGAN | STATE_CHANGED | STATE_ENDED | STATE_CANCELLED)) {
            this.tryEmit(inputDataClone);
        }
    },

    /**
     * return the state of the recognizer
     * the actual recognizing happens in this method
     * @virtual
     * @param {Object} inputData
     * @returns {Const} STATE
     */
    process: function(inputData) { }, // jshint ignore:line

    /**
     * return the preferred touch-action
     * @virtual
     * @returns {Array}
     */
    getTouchAction: function() { },

    /**
     * called when the gesture isn't allowed to recognize
     * like when another is being recognized or it is disabled
     * @virtual
     */
    reset: function() { }
};

/**
 * get a usable string, used as event postfix
 * @param {Const} state
 * @returns {String} state
 */
function stateStr(state) {
    if (state & STATE_CANCELLED) {
        return 'cancel';
    } else if (state & STATE_ENDED) {
        return 'end';
    } else if (state & STATE_CHANGED) {
        return 'move';
    } else if (state & STATE_BEGAN) {
        return 'start';
    }
    return '';
}

/**
 * direction cons to string
 * @param {Const} direction
 * @returns {String}
 */
function directionStr(direction) {
    if (direction == DIRECTION_DOWN) {
        return 'down';
    } else if (direction == DIRECTION_UP) {
        return 'up';
    } else if (direction == DIRECTION_LEFT) {
        return 'left';
    } else if (direction == DIRECTION_RIGHT) {
        return 'right';
    }
    return '';
}

/**
 * get a recognizer by name if it is bound to a manager
 * @param {Recognizer|String} otherRecognizer
 * @param {Recognizer} recognizer
 * @returns {Recognizer}
 */
function getRecognizerByNameIfManager(otherRecognizer, recognizer) {
    var manager = recognizer.manager;
    if (manager) {
        return manager.get(otherRecognizer);
    }
    return otherRecognizer;
}

/**
 * This recognizer is just used as a base for the simple attribute recognizers.
 * @constructor
 * @extends Recognizer
 */
function AttrRecognizer() {
    Recognizer.apply(this, arguments);
}

inherit(AttrRecognizer, Recognizer, {
    /**
     * @namespace
     * @memberof AttrRecognizer
     */
    defaults: {
        /**
         * @type {Number}
         * @default 1
         */
        pointers: 1
    },

    /**
     * Used to check if it the recognizer receives valid input, like input.distance > 10.
     * @memberof AttrRecognizer
     * @param {Object} input
     * @returns {Boolean} recognized
     */
    attrTest: function(input) {
        var optionPointers = this.options.pointers;
        return optionPointers === 0 || input.pointers.length === optionPointers;
    },

    /**
     * Process the input and return the state for the recognizer
     * @memberof AttrRecognizer
     * @param {Object} input
     * @returns {*} State
     */
    process: function(input) {
        var state = this.state;
        var eventType = input.eventType;

        var isRecognized = state & (STATE_BEGAN | STATE_CHANGED);
        var isValid = this.attrTest(input);

        // on cancel input and we've recognized before, return STATE_CANCELLED
        if (isRecognized && (eventType & INPUT_CANCEL || !isValid)) {
            return state | STATE_CANCELLED;
        } else if (isRecognized || isValid) {
            if (eventType & INPUT_END) {
                return state | STATE_ENDED;
            } else if (!(state & STATE_BEGAN)) {
                return STATE_BEGAN;
            }
            return state | STATE_CHANGED;
        }
        return STATE_FAILED;
    }
});

/**
 * Pan
 * Recognized when the pointer is down and moved in the allowed direction.
 * @constructor
 * @extends AttrRecognizer
 */
function PanRecognizer() {
    AttrRecognizer.apply(this, arguments);

    this.pX = null;
    this.pY = null;
}

inherit(PanRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof PanRecognizer
     */
    defaults: {
        event: 'pan',
        threshold: 10,
        pointers: 1,
        direction: DIRECTION_ALL
    },

    getTouchAction: function() {
        var direction = this.options.direction;
        var actions = [];
        if (direction & DIRECTION_HORIZONTAL) {
            actions.push(TOUCH_ACTION_PAN_Y);
        }
        if (direction & DIRECTION_VERTICAL) {
            actions.push(TOUCH_ACTION_PAN_X);
        }
        return actions;
    },

    directionTest: function(input) {
        var options = this.options;
        var hasMoved = true;
        var distance = input.distance;
        var direction = input.direction;
        var x = input.deltaX;
        var y = input.deltaY;

        // lock to axis?
        if (!(direction & options.direction)) {
            if (options.direction & DIRECTION_HORIZONTAL) {
                direction = (x === 0) ? DIRECTION_NONE : (x < 0) ? DIRECTION_LEFT : DIRECTION_RIGHT;
                hasMoved = x != this.pX;
                distance = Math.abs(input.deltaX);
            } else {
                direction = (y === 0) ? DIRECTION_NONE : (y < 0) ? DIRECTION_UP : DIRECTION_DOWN;
                hasMoved = y != this.pY;
                distance = Math.abs(input.deltaY);
            }
        }
        input.direction = direction;
        return hasMoved && distance > options.threshold && direction & options.direction;
    },

    attrTest: function(input) {
        return AttrRecognizer.prototype.attrTest.call(this, input) &&
            (this.state & STATE_BEGAN || (!(this.state & STATE_BEGAN) && this.directionTest(input)));
    },

    emit: function(input) {

        this.pX = input.deltaX;
        this.pY = input.deltaY;

        var direction = directionStr(input.direction);

        if (direction) {
            input.additionalEvent = this.options.event + direction;
        }
        this._super.emit.call(this, input);
    }
});

/**
 * Pinch
 * Recognized when two or more pointers are moving toward (zoom-in) or away from each other (zoom-out).
 * @constructor
 * @extends AttrRecognizer
 */
function PinchRecognizer() {
    AttrRecognizer.apply(this, arguments);
}

inherit(PinchRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof PinchRecognizer
     */
    defaults: {
        event: 'pinch',
        threshold: 0,
        pointers: 2
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_NONE];
    },

    attrTest: function(input) {
        return this._super.attrTest.call(this, input) &&
            (Math.abs(input.scale - 1) > this.options.threshold || this.state & STATE_BEGAN);
    },

    emit: function(input) {
        if (input.scale !== 1) {
            var inOut = input.scale < 1 ? 'in' : 'out';
            input.additionalEvent = this.options.event + inOut;
        }
        this._super.emit.call(this, input);
    }
});

/**
 * Press
 * Recognized when the pointer is down for x ms without any movement.
 * @constructor
 * @extends Recognizer
 */
function PressRecognizer() {
    Recognizer.apply(this, arguments);

    this._timer = null;
    this._input = null;
}

inherit(PressRecognizer, Recognizer, {
    /**
     * @namespace
     * @memberof PressRecognizer
     */
    defaults: {
        event: 'press',
        pointers: 1,
        time: 251, // minimal time of the pointer to be pressed
        threshold: 9 // a minimal movement is ok, but keep it low
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_AUTO];
    },

    process: function(input) {
        var options = this.options;
        var validPointers = input.pointers.length === options.pointers;
        var validMovement = input.distance < options.threshold;
        var validTime = input.deltaTime > options.time;

        this._input = input;

        // we only allow little movement
        // and we've reached an end event, so a tap is possible
        if (!validMovement || !validPointers || (input.eventType & (INPUT_END | INPUT_CANCEL) && !validTime)) {
            this.reset();
        } else if (input.eventType & INPUT_START) {
            this.reset();
            this._timer = setTimeoutContext(function() {
                this.state = STATE_RECOGNIZED;
                this.tryEmit();
            }, options.time, this);
        } else if (input.eventType & INPUT_END) {
            return STATE_RECOGNIZED;
        }
        return STATE_FAILED;
    },

    reset: function() {
        clearTimeout(this._timer);
    },

    emit: function(input) {
        if (this.state !== STATE_RECOGNIZED) {
            return;
        }

        if (input && (input.eventType & INPUT_END)) {
            this.manager.emit(this.options.event + 'up', input);
        } else {
            this._input.timeStamp = now();
            this.manager.emit(this.options.event, this._input);
        }
    }
});

/**
 * Rotate
 * Recognized when two or more pointer are moving in a circular motion.
 * @constructor
 * @extends AttrRecognizer
 */
function RotateRecognizer() {
    AttrRecognizer.apply(this, arguments);
}

inherit(RotateRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof RotateRecognizer
     */
    defaults: {
        event: 'rotate',
        threshold: 0,
        pointers: 2
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_NONE];
    },

    attrTest: function(input) {
        return this._super.attrTest.call(this, input) &&
            (Math.abs(input.rotation) > this.options.threshold || this.state & STATE_BEGAN);
    }
});

/**
 * Swipe
 * Recognized when the pointer is moving fast (velocity), with enough distance in the allowed direction.
 * @constructor
 * @extends AttrRecognizer
 */
function SwipeRecognizer() {
    AttrRecognizer.apply(this, arguments);
}

inherit(SwipeRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof SwipeRecognizer
     */
    defaults: {
        event: 'swipe',
        threshold: 10,
        velocity: 0.3,
        direction: DIRECTION_HORIZONTAL | DIRECTION_VERTICAL,
        pointers: 1
    },

    getTouchAction: function() {
        return PanRecognizer.prototype.getTouchAction.call(this);
    },

    attrTest: function(input) {
        var direction = this.options.direction;
        var velocity;

        if (direction & (DIRECTION_HORIZONTAL | DIRECTION_VERTICAL)) {
            velocity = input.overallVelocity;
        } else if (direction & DIRECTION_HORIZONTAL) {
            velocity = input.overallVelocityX;
        } else if (direction & DIRECTION_VERTICAL) {
            velocity = input.overallVelocityY;
        }

        return this._super.attrTest.call(this, input) &&
            direction & input.offsetDirection &&
            input.distance > this.options.threshold &&
            input.maxPointers == this.options.pointers &&
            abs(velocity) > this.options.velocity && input.eventType & INPUT_END;
    },

    emit: function(input) {
        var direction = directionStr(input.offsetDirection);
        if (direction) {
            this.manager.emit(this.options.event + direction, input);
        }

        this.manager.emit(this.options.event, input);
    }
});

/**
 * A tap is ecognized when the pointer is doing a small tap/click. Multiple taps are recognized if they occur
 * between the given interval and position. The delay option can be used to recognize multi-taps without firing
 * a single tap.
 *
 * The eventData from the emitted event contains the property `tapCount`, which contains the amount of
 * multi-taps being recognized.
 * @constructor
 * @extends Recognizer
 */
function TapRecognizer() {
    Recognizer.apply(this, arguments);

    // previous time and center,
    // used for tap counting
    this.pTime = false;
    this.pCenter = false;

    this._timer = null;
    this._input = null;
    this.count = 0;
}

inherit(TapRecognizer, Recognizer, {
    /**
     * @namespace
     * @memberof PinchRecognizer
     */
    defaults: {
        event: 'tap',
        pointers: 1,
        taps: 1,
        interval: 300, // max time between the multi-tap taps
        time: 250, // max time of the pointer to be down (like finger on the screen)
        threshold: 9, // a minimal movement is ok, but keep it low
        posThreshold: 10 // a multi-tap can be a bit off the initial position
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_MANIPULATION];
    },

    process: function(input) {
        var options = this.options;

        var validPointers = input.pointers.length === options.pointers;
        var validMovement = input.distance < options.threshold;
        var validTouchTime = input.deltaTime < options.time;

        this.reset();

        if ((input.eventType & INPUT_START) && (this.count === 0)) {
            return this.failTimeout();
        }

        // we only allow little movement
        // and we've reached an end event, so a tap is possible
        if (validMovement && validTouchTime && validPointers) {
            if (input.eventType != INPUT_END) {
                return this.failTimeout();
            }

            var validInterval = this.pTime ? (input.timeStamp - this.pTime < options.interval) : true;
            var validMultiTap = !this.pCenter || getDistance(this.pCenter, input.center) < options.posThreshold;

            this.pTime = input.timeStamp;
            this.pCenter = input.center;

            if (!validMultiTap || !validInterval) {
                this.count = 1;
            } else {
                this.count += 1;
            }

            this._input = input;

            // if tap count matches we have recognized it,
            // else it has began recognizing...
            var tapCount = this.count % options.taps;
            if (tapCount === 0) {
                // no failing requirements, immediately trigger the tap event
                // or wait as long as the multitap interval to trigger
                if (!this.hasRequireFailures()) {
                    return STATE_RECOGNIZED;
                } else {
                    this._timer = setTimeoutContext(function() {
                        this.state = STATE_RECOGNIZED;
                        this.tryEmit();
                    }, options.interval, this);
                    return STATE_BEGAN;
                }
            }
        }
        return STATE_FAILED;
    },

    failTimeout: function() {
        this._timer = setTimeoutContext(function() {
            this.state = STATE_FAILED;
        }, this.options.interval, this);
        return STATE_FAILED;
    },

    reset: function() {
        clearTimeout(this._timer);
    },

    emit: function() {
        if (this.state == STATE_RECOGNIZED) {
            this._input.tapCount = this.count;
            this.manager.emit(this.options.event, this._input);
        }
    }
});

/**
 * Simple way to create a manager with a default set of recognizers.
 * @param {HTMLElement} element
 * @param {Object} [options]
 * @constructor
 */
function Hammer(element, options) {
    options = options || {};
    options.recognizers = ifUndefined(options.recognizers, Hammer.defaults.preset);
    return new Manager(element, options);
}

/**
 * @const {string}
 */
Hammer.VERSION = '2.0.7';

/**
 * default settings
 * @namespace
 */
Hammer.defaults = {
    /**
     * set if DOM events are being triggered.
     * But this is slower and unused by simple implementations, so disabled by default.
     * @type {Boolean}
     * @default false
     */
    domEvents: false,

    /**
     * The value for the touchAction property/fallback.
     * When set to `compute` it will magically set the correct value based on the added recognizers.
     * @type {String}
     * @default compute
     */
    touchAction: TOUCH_ACTION_COMPUTE,

    /**
     * @type {Boolean}
     * @default true
     */
    enable: true,

    /**
     * EXPERIMENTAL FEATURE -- can be removed/changed
     * Change the parent input target element.
     * If Null, then it is being set the to main element.
     * @type {Null|EventTarget}
     * @default null
     */
    inputTarget: null,

    /**
     * force an input class
     * @type {Null|Function}
     * @default null
     */
    inputClass: null,

    /**
     * Default recognizer setup when calling `Hammer()`
     * When creating a new Manager these will be skipped.
     * @type {Array}
     */
    preset: [
        // RecognizerClass, options, [recognizeWith, ...], [requireFailure, ...]
        [RotateRecognizer, {enable: false}],
        [PinchRecognizer, {enable: false}, ['rotate']],
        [SwipeRecognizer, {direction: DIRECTION_HORIZONTAL}],
        [PanRecognizer, {direction: DIRECTION_HORIZONTAL}, ['swipe']],
        [TapRecognizer],
        [TapRecognizer, {event: 'doubletap', taps: 2}, ['tap']],
        [PressRecognizer]
    ],

    /**
     * Some CSS properties can be used to improve the working of Hammer.
     * Add them to this method and they will be set when creating a new Manager.
     * @namespace
     */
    cssProps: {
        /**
         * Disables text selection to improve the dragging gesture. Mainly for desktop browsers.
         * @type {String}
         * @default 'none'
         */
        userSelect: 'none',

        /**
         * Disable the Windows Phone grippers when pressing an element.
         * @type {String}
         * @default 'none'
         */
        touchSelect: 'none',

        /**
         * Disables the default callout shown when you touch and hold a touch target.
         * On iOS, when you touch and hold a touch target such as a link, Safari displays
         * a callout containing information about the link. This property allows you to disable that callout.
         * @type {String}
         * @default 'none'
         */
        touchCallout: 'none',

        /**
         * Specifies whether zooming is enabled. Used by IE10>
         * @type {String}
         * @default 'none'
         */
        contentZooming: 'none',

        /**
         * Specifies that an entire element should be draggable instead of its contents. Mainly for desktop browsers.
         * @type {String}
         * @default 'none'
         */
        userDrag: 'none',

        /**
         * Overrides the highlight color shown when the user taps a link or a JavaScript
         * clickable element in iOS. This property obeys the alpha value, if specified.
         * @type {String}
         * @default 'rgba(0,0,0,0)'
         */
        tapHighlightColor: 'rgba(0,0,0,0)'
    }
};

var STOP = 1;
var FORCED_STOP = 2;

/**
 * Manager
 * @param {HTMLElement} element
 * @param {Object} [options]
 * @constructor
 */
function Manager(element, options) {
    this.options = assign({}, Hammer.defaults, options || {});

    this.options.inputTarget = this.options.inputTarget || element;

    this.handlers = {};
    this.session = {};
    this.recognizers = [];
    this.oldCssProps = {};

    this.element = element;
    this.input = createInputInstance(this);
    this.touchAction = new TouchAction(this, this.options.touchAction);

    toggleCssProps(this, true);

    each(this.options.recognizers, function(item) {
        var recognizer = this.add(new (item[0])(item[1]));
        item[2] && recognizer.recognizeWith(item[2]);
        item[3] && recognizer.requireFailure(item[3]);
    }, this);
}

Manager.prototype = {
    /**
     * set options
     * @param {Object} options
     * @returns {Manager}
     */
    set: function(options) {
        assign(this.options, options);

        // Options that need a little more setup
        if (options.touchAction) {
            this.touchAction.update();
        }
        if (options.inputTarget) {
            // Clean up existing event listeners and reinitialize
            this.input.destroy();
            this.input.target = options.inputTarget;
            this.input.init();
        }
        return this;
    },

    /**
     * stop recognizing for this session.
     * This session will be discarded, when a new [input]start event is fired.
     * When forced, the recognizer cycle is stopped immediately.
     * @param {Boolean} [force]
     */
    stop: function(force) {
        this.session.stopped = force ? FORCED_STOP : STOP;
    },

    /**
     * run the recognizers!
     * called by the inputHandler function on every movement of the pointers (touches)
     * it walks through all the recognizers and tries to detect the gesture that is being made
     * @param {Object} inputData
     */
    recognize: function(inputData) {
        var session = this.session;
        if (session.stopped) {
            return;
        }

        // run the touch-action polyfill
        this.touchAction.preventDefaults(inputData);

        var recognizer;
        var recognizers = this.recognizers;

        // this holds the recognizer that is being recognized.
        // so the recognizer's state needs to be BEGAN, CHANGED, ENDED or RECOGNIZED
        // if no recognizer is detecting a thing, it is set to `null`
        var curRecognizer = session.curRecognizer;

        // reset when the last recognizer is recognized
        // or when we're in a new session
        if (!curRecognizer || (curRecognizer && curRecognizer.state & STATE_RECOGNIZED)) {
            curRecognizer = session.curRecognizer = null;
        }

        var i = 0;
        while (i < recognizers.length) {
            recognizer = recognizers[i];

            // find out if we are allowed try to recognize the input for this one.
            // 1.   allow if the session is NOT forced stopped (see the .stop() method)
            // 2.   allow if we still haven't recognized a gesture in this session, or the this recognizer is the one
            //      that is being recognized.
            // 3.   allow if the recognizer is allowed to run simultaneous with the current recognized recognizer.
            //      this can be setup with the `recognizeWith()` method on the recognizer.
            if (session.stopped !== FORCED_STOP && ( // 1
                    !curRecognizer || recognizer == curRecognizer || // 2
                    recognizer.canRecognizeWith(curRecognizer))) { // 3
                recognizer.recognize(inputData);
            } else {
                recognizer.reset();
            }

            // if the recognizer has been recognizing the input as a valid gesture, we want to store this one as the
            // current active recognizer. but only if we don't already have an active recognizer
            if (!curRecognizer && recognizer.state & (STATE_BEGAN | STATE_CHANGED | STATE_ENDED)) {
                curRecognizer = session.curRecognizer = recognizer;
            }
            i++;
        }
    },

    /**
     * get a recognizer by its event name.
     * @param {Recognizer|String} recognizer
     * @returns {Recognizer|Null}
     */
    get: function(recognizer) {
        if (recognizer instanceof Recognizer) {
            return recognizer;
        }

        var recognizers = this.recognizers;
        for (var i = 0; i < recognizers.length; i++) {
            if (recognizers[i].options.event == recognizer) {
                return recognizers[i];
            }
        }
        return null;
    },

    /**
     * add a recognizer to the manager
     * existing recognizers with the same event name will be removed
     * @param {Recognizer} recognizer
     * @returns {Recognizer|Manager}
     */
    add: function(recognizer) {
        if (invokeArrayArg(recognizer, 'add', this)) {
            return this;
        }

        // remove existing
        var existing = this.get(recognizer.options.event);
        if (existing) {
            this.remove(existing);
        }

        this.recognizers.push(recognizer);
        recognizer.manager = this;

        this.touchAction.update();
        return recognizer;
    },

    /**
     * remove a recognizer by name or instance
     * @param {Recognizer|String} recognizer
     * @returns {Manager}
     */
    remove: function(recognizer) {
        if (invokeArrayArg(recognizer, 'remove', this)) {
            return this;
        }

        recognizer = this.get(recognizer);

        // let's make sure this recognizer exists
        if (recognizer) {
            var recognizers = this.recognizers;
            var index = inArray(recognizers, recognizer);

            if (index !== -1) {
                recognizers.splice(index, 1);
                this.touchAction.update();
            }
        }

        return this;
    },

    /**
     * bind event
     * @param {String} events
     * @param {Function} handler
     * @returns {EventEmitter} this
     */
    on: function(events, handler) {
        if (events === undefined) {
            return;
        }
        if (handler === undefined) {
            return;
        }

        var handlers = this.handlers;
        each(splitStr(events), function(event) {
            handlers[event] = handlers[event] || [];
            handlers[event].push(handler);
        });
        return this;
    },

    /**
     * unbind event, leave emit blank to remove all handlers
     * @param {String} events
     * @param {Function} [handler]
     * @returns {EventEmitter} this
     */
    off: function(events, handler) {
        if (events === undefined) {
            return;
        }

        var handlers = this.handlers;
        each(splitStr(events), function(event) {
            if (!handler) {
                delete handlers[event];
            } else {
                handlers[event] && handlers[event].splice(inArray(handlers[event], handler), 1);
            }
        });
        return this;
    },

    /**
     * emit event to the listeners
     * @param {String} event
     * @param {Object} data
     */
    emit: function(event, data) {
        // we also want to trigger dom events
        if (this.options.domEvents) {
            triggerDomEvent(event, data);
        }

        // no handlers, so skip it all
        var handlers = this.handlers[event] && this.handlers[event].slice();
        if (!handlers || !handlers.length) {
            return;
        }

        data.type = event;
        data.preventDefault = function() {
            data.srcEvent.preventDefault();
        };

        var i = 0;
        while (i < handlers.length) {
            handlers[i](data);
            i++;
        }
    },

    /**
     * destroy the manager and unbinds all events
     * it doesn't unbind dom events, that is the user own responsibility
     */
    destroy: function() {
        this.element && toggleCssProps(this, false);

        this.handlers = {};
        this.session = {};
        this.input.destroy();
        this.element = null;
    }
};

/**
 * add/remove the css properties as defined in manager.options.cssProps
 * @param {Manager} manager
 * @param {Boolean} add
 */
function toggleCssProps(manager, add) {
    var element = manager.element;
    if (!element.style) {
        return;
    }
    var prop;
    each(manager.options.cssProps, function(value, name) {
        prop = prefixed(element.style, name);
        if (add) {
            manager.oldCssProps[prop] = element.style[prop];
            element.style[prop] = value;
        } else {
            element.style[prop] = manager.oldCssProps[prop] || '';
        }
    });
    if (!add) {
        manager.oldCssProps = {};
    }
}

/**
 * trigger dom event
 * @param {String} event
 * @param {Object} data
 */
function triggerDomEvent(event, data) {
    var gestureEvent = document.createEvent('Event');
    gestureEvent.initEvent(event, true, true);
    gestureEvent.gesture = data;
    data.target.dispatchEvent(gestureEvent);
}

assign(Hammer, {
    INPUT_START: INPUT_START,
    INPUT_MOVE: INPUT_MOVE,
    INPUT_END: INPUT_END,
    INPUT_CANCEL: INPUT_CANCEL,

    STATE_POSSIBLE: STATE_POSSIBLE,
    STATE_BEGAN: STATE_BEGAN,
    STATE_CHANGED: STATE_CHANGED,
    STATE_ENDED: STATE_ENDED,
    STATE_RECOGNIZED: STATE_RECOGNIZED,
    STATE_CANCELLED: STATE_CANCELLED,
    STATE_FAILED: STATE_FAILED,

    DIRECTION_NONE: DIRECTION_NONE,
    DIRECTION_LEFT: DIRECTION_LEFT,
    DIRECTION_RIGHT: DIRECTION_RIGHT,
    DIRECTION_UP: DIRECTION_UP,
    DIRECTION_DOWN: DIRECTION_DOWN,
    DIRECTION_HORIZONTAL: DIRECTION_HORIZONTAL,
    DIRECTION_VERTICAL: DIRECTION_VERTICAL,
    DIRECTION_ALL: DIRECTION_ALL,

    Manager: Manager,
    Input: Input,
    TouchAction: TouchAction,

    TouchInput: TouchInput,
    MouseInput: MouseInput,
    PointerEventInput: PointerEventInput,
    TouchMouseInput: TouchMouseInput,
    SingleTouchInput: SingleTouchInput,

    Recognizer: Recognizer,
    AttrRecognizer: AttrRecognizer,
    Tap: TapRecognizer,
    Pan: PanRecognizer,
    Swipe: SwipeRecognizer,
    Pinch: PinchRecognizer,
    Rotate: RotateRecognizer,
    Press: PressRecognizer,

    on: addEventListeners,
    off: removeEventListeners,
    each: each,
    merge: merge,
    extend: extend,
    assign: assign,
    inherit: inherit,
    bindFn: bindFn,
    prefixed: prefixed
});

// this prevents errors when Hammer is loaded in the presence of an AMD
//  style loader but by script tag, not by the loader.
var freeGlobal = (typeof window !== 'undefined' ? window : (typeof self !== 'undefined' ? self : {})); // jshint ignore:line
freeGlobal.Hammer = Hammer;

if (true) {
    !(__WEBPACK_AMD_DEFINE_RESULT__ = (function() {
        return Hammer;
    }).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
} else {}

})(window, document, 'Hammer');


/***/ }),

/***/ "fb15":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, "Button", function() { return /* reexport */ Button; });
__webpack_require__.d(__webpack_exports__, "Link", function() { return /* reexport */ Link; });
__webpack_require__.d(__webpack_exports__, "Card", function() { return /* reexport */ Card; });
__webpack_require__.d(__webpack_exports__, "SocialMedia", function() { return /* reexport */ Social_Media; });
__webpack_require__.d(__webpack_exports__, "ReviewHeader", function() { return /* reexport */ Review_Header; });
__webpack_require__.d(__webpack_exports__, "HFeatureBlock", function() { return /* reexport */ H_Feature_Block; });
__webpack_require__.d(__webpack_exports__, "VFeatureBlock", function() { return /* reexport */ V_Feature_Block; });
__webpack_require__.d(__webpack_exports__, "HContentBlock", function() { return /* reexport */ H_Content_Block; });
__webpack_require__.d(__webpack_exports__, "HoverItem", function() { return /* reexport */ Hover_Item; });
__webpack_require__.d(__webpack_exports__, "FaqItem", function() { return /* reexport */ Faq_Item; });
__webpack_require__.d(__webpack_exports__, "Modal", function() { return /* reexport */ Modal; });
__webpack_require__.d(__webpack_exports__, "DatePicker", function() { return /* reexport */ Date_Picker; });
__webpack_require__.d(__webpack_exports__, "TextArea", function() { return /* reexport */ Text_Area; });
__webpack_require__.d(__webpack_exports__, "CardCarousel", function() { return /* reexport */ cal_card_carousel; });
__webpack_require__.d(__webpack_exports__, "ReviewCard", function() { return /* reexport */ cal_review_card; });
__webpack_require__.d(__webpack_exports__, "SlideCard", function() { return /* reexport */ cal_slide_card; });
__webpack_require__.d(__webpack_exports__, "ProductTile", function() { return /* reexport */ Product_Tile; });
__webpack_require__.d(__webpack_exports__, "ProductTileV2", function() { return /* reexport */ Product_Tile_V2; });
__webpack_require__.d(__webpack_exports__, "AddOn", function() { return /* reexport */ Add_On; });
__webpack_require__.d(__webpack_exports__, "SlideOver", function() { return /* reexport */ Slide_Over; });
__webpack_require__.d(__webpack_exports__, "ItemList", function() { return /* reexport */ Item_List; });
__webpack_require__.d(__webpack_exports__, "Item", function() { return /* reexport */ Item; });
__webpack_require__.d(__webpack_exports__, "HItem", function() { return /* reexport */ H_Item; });
__webpack_require__.d(__webpack_exports__, "Badge", function() { return /* reexport */ Badge; });
__webpack_require__.d(__webpack_exports__, "WeddingProductCard", function() { return /* reexport */ Wedding_Product_Card; });
__webpack_require__.d(__webpack_exports__, "ReadMore", function() { return /* reexport */ ReadMoreModal; });
__webpack_require__.d(__webpack_exports__, "SectionDivider", function() { return /* reexport */ Section_Divider; });
__webpack_require__.d(__webpack_exports__, "FullAddOn", function() { return /* reexport */ Full_Addon; });
__webpack_require__.d(__webpack_exports__, "AddonV2", function() { return /* reexport */ Add_On_V2; });
__webpack_require__.d(__webpack_exports__, "MarketingBadge", function() { return /* reexport */ Marketing_Badge; });
__webpack_require__.d(__webpack_exports__, "ErrorBanner", function() { return /* reexport */ Error_Banner; });
__webpack_require__.d(__webpack_exports__, "CalImg", function() { return /* reexport */ Cal_Img; });
__webpack_require__.d(__webpack_exports__, "CalVideo", function() { return /* reexport */ Cal_Video; });
__webpack_require__.d(__webpack_exports__, "Input", function() { return /* reexport */ Input; });
__webpack_require__.d(__webpack_exports__, "DateInput", function() { return /* reexport */ DateInput; });
__webpack_require__.d(__webpack_exports__, "TextAreaInput", function() { return /* reexport */ TextAreaInput; });
__webpack_require__.d(__webpack_exports__, "SelectInput", function() { return /* reexport */ SelectInput; });
__webpack_require__.d(__webpack_exports__, "SimpleSelectInput", function() { return /* reexport */ SimpleSelectInput; });
__webpack_require__.d(__webpack_exports__, "LovedBy", function() { return /* reexport */ Loved_By; });
__webpack_require__.d(__webpack_exports__, "MarketingShowcase", function() { return /* reexport */ Marketing_Showcase; });

// NAMESPACE OBJECT: ./src/vue-components/index.js
var vue_components_namespaceObject = {};
__webpack_require__.r(vue_components_namespaceObject);
__webpack_require__.d(vue_components_namespaceObject, "Button", function() { return Button; });
__webpack_require__.d(vue_components_namespaceObject, "Link", function() { return Link; });
__webpack_require__.d(vue_components_namespaceObject, "Card", function() { return Card; });
__webpack_require__.d(vue_components_namespaceObject, "SocialMedia", function() { return Social_Media; });
__webpack_require__.d(vue_components_namespaceObject, "ReviewHeader", function() { return Review_Header; });
__webpack_require__.d(vue_components_namespaceObject, "HFeatureBlock", function() { return H_Feature_Block; });
__webpack_require__.d(vue_components_namespaceObject, "VFeatureBlock", function() { return V_Feature_Block; });
__webpack_require__.d(vue_components_namespaceObject, "HContentBlock", function() { return H_Content_Block; });
__webpack_require__.d(vue_components_namespaceObject, "HoverItem", function() { return Hover_Item; });
__webpack_require__.d(vue_components_namespaceObject, "FaqItem", function() { return Faq_Item; });
__webpack_require__.d(vue_components_namespaceObject, "Modal", function() { return Modal; });
__webpack_require__.d(vue_components_namespaceObject, "DatePicker", function() { return Date_Picker; });
__webpack_require__.d(vue_components_namespaceObject, "TextArea", function() { return Text_Area; });
__webpack_require__.d(vue_components_namespaceObject, "CardCarousel", function() { return cal_card_carousel; });
__webpack_require__.d(vue_components_namespaceObject, "ReviewCard", function() { return cal_review_card; });
__webpack_require__.d(vue_components_namespaceObject, "SlideCard", function() { return cal_slide_card; });
__webpack_require__.d(vue_components_namespaceObject, "ProductTile", function() { return Product_Tile; });
__webpack_require__.d(vue_components_namespaceObject, "ProductTileV2", function() { return Product_Tile_V2; });
__webpack_require__.d(vue_components_namespaceObject, "AddOn", function() { return Add_On; });
__webpack_require__.d(vue_components_namespaceObject, "SlideOver", function() { return Slide_Over; });
__webpack_require__.d(vue_components_namespaceObject, "ItemList", function() { return Item_List; });
__webpack_require__.d(vue_components_namespaceObject, "Item", function() { return Item; });
__webpack_require__.d(vue_components_namespaceObject, "HItem", function() { return H_Item; });
__webpack_require__.d(vue_components_namespaceObject, "Badge", function() { return Badge; });
__webpack_require__.d(vue_components_namespaceObject, "WeddingProductCard", function() { return Wedding_Product_Card; });
__webpack_require__.d(vue_components_namespaceObject, "ReadMore", function() { return ReadMoreModal; });
__webpack_require__.d(vue_components_namespaceObject, "SectionDivider", function() { return Section_Divider; });
__webpack_require__.d(vue_components_namespaceObject, "FullAddOn", function() { return Full_Addon; });
__webpack_require__.d(vue_components_namespaceObject, "AddonV2", function() { return Add_On_V2; });
__webpack_require__.d(vue_components_namespaceObject, "MarketingBadge", function() { return Marketing_Badge; });
__webpack_require__.d(vue_components_namespaceObject, "ErrorBanner", function() { return Error_Banner; });
__webpack_require__.d(vue_components_namespaceObject, "CalImg", function() { return Cal_Img; });
__webpack_require__.d(vue_components_namespaceObject, "CalVideo", function() { return Cal_Video; });
__webpack_require__.d(vue_components_namespaceObject, "Input", function() { return Input; });
__webpack_require__.d(vue_components_namespaceObject, "DateInput", function() { return DateInput; });
__webpack_require__.d(vue_components_namespaceObject, "TextAreaInput", function() { return TextAreaInput; });
__webpack_require__.d(vue_components_namespaceObject, "SelectInput", function() { return SelectInput; });
__webpack_require__.d(vue_components_namespaceObject, "SimpleSelectInput", function() { return SimpleSelectInput; });
__webpack_require__.d(vue_components_namespaceObject, "LovedBy", function() { return Loved_By; });
__webpack_require__.d(vue_components_namespaceObject, "MarketingShowcase", function() { return Marketing_Showcase; });

// CONCATENATED MODULE: ./node_modules/@vue/cli-service/lib/commands/build/setPublicPath.js
// This file is imported into lib/wc client bundles.

if (typeof window !== 'undefined') {
  var currentScript = window.document.currentScript
  if (true) {
    var getCurrentScript = __webpack_require__("8875")
    currentScript = getCurrentScript()

    // for backward compatibility, because previously we directly included the polyfill
    if (!('currentScript' in document)) {
      Object.defineProperty(document, 'currentScript', { get: getCurrentScript })
    }
  }

  var src = currentScript && currentScript.src.match(/(.+\/)[^/]+\.js(\?.*)?$/)
  if (src) {
    __webpack_require__.p = src[1] // eslint-disable-line
  }
}

// Indicate to webpack that this file can be concatenated
/* harmony default export */ var setPublicPath = (null);

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"9d9ca11a-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/vue-components/button/Button.vue?vue&type=template&id=9a51f2da
var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"cal-btn",class:[_vm.curved ? `${'cal-btn-curved'}` : '', _vm.type],style:({ 'font-size': _vm.fontSize || '' }),attrs:{"disabled":_vm.isDisabled},on:{"click":function($event){return _vm.callback($event)}}},[_vm._v(" "+_vm._s(_vm.btnText)+" ")])
}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/vue-components/button/Button.vue?vue&type=template&id=9a51f2da

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/vue-components/button/Button.vue?vue&type=script&lang=js

/* harmony default export */ var Buttonvue_type_script_lang_js = ({
  name: "cal-button",
  data() {
    return {};
  },
  props: ["isDisabled", "btnText", "type", "curved", "fontSize"],
  methods: {
    callback(e) {
      this.$emit("click", e);
    },
  },
});

// CONCATENATED MODULE: ./src/vue-components/button/Button.vue?vue&type=script&lang=js
 /* harmony default export */ var button_Buttonvue_type_script_lang_js = (Buttonvue_type_script_lang_js); 
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

function normalizeComponent(
  scriptExports,
  render,
  staticRenderFns,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */,
  shadowMode /* vue-cli only */
) {
  // Vue.extend constructor export interop
  var options =
    typeof scriptExports === 'function' ? scriptExports.options : scriptExports

  // render functions
  if (render) {
    options.render = render
    options.staticRenderFns = staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = 'data-v-' + scopeId
  }

  var hook
  if (moduleIdentifier) {
    // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = shadowMode
      ? function () {
          injectStyles.call(
            this,
            (options.functional ? this.parent : this).$root.$options.shadowRoot
          )
        }
      : injectStyles
  }

  if (hook) {
    if (options.functional) {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functional component in vue file
      var originalRender = options.render
      options.render = function renderWithStyleInjection(h, context) {
        hook.call(context)
        return originalRender(h, context)
      }
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate
      options.beforeCreate = existing ? [].concat(existing, hook) : [hook]
    }
  }

  return {
    exports: scriptExports,
    options: options
  }
}

// CONCATENATED MODULE: ./src/vue-components/button/Button.vue





/* normalize component */

var component = normalizeComponent(
  button_Buttonvue_type_script_lang_js,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var Button = (component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"9d9ca11a-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/vue-components/button/Link.vue?vue&type=template&id=2c01bb14
var Linkvue_type_template_id_2c01bb14_render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.linkPath)?_c('div',[_c('ul',{staticClass:"cal-link"},[_c('li',{class:[
          _vm.iconOrientation == 'end' || _vm.iconOrientation == 'right'
            ? 'cal-link-img-order-1'
            : 'cal-link-img-order-2',
        ]},[_c('a',{staticClass:"cal-link-text",attrs:{"href":_vm.linkPath}},[_vm._v(" "+_vm._s(_vm.linkText)+" ")])]),_c('li',{staticClass:"cal-link-img-conatiner",class:[
          _vm.iconOrientation == 'end' || _vm.iconOrientation == 'right'
            ? 'cal-link-img-order-2'
            : 'cal-link-img-order-1',
        ]},[_c('a',{attrs:{"href":_vm.linkPath}},[_c('cal-img',{staticClass:"cal-link-img",attrs:{"src":_vm.icon,"alt":"link icon","width":_vm.width,"height":_vm.height}})],1)])])]):_vm._e(),(_vm.router)?_c('div',[_c('ul',{staticClass:"cal-link"},[_c('li',{class:[
          _vm.iconOrientation == 'end' || _vm.iconOrientation == 'right'
            ? 'cal-link-img-order-1'
            : 'cal-link-img-order-2',
        ]},[_c('NuxtLink',{staticClass:"cal-link-text",attrs:{"to":_vm.router}},[_vm._v(" "+_vm._s(_vm.linkText)+" ")])],1),_c('li',{staticClass:"cal-link-img-conatiner",class:[
          _vm.iconOrientation == 'end' || _vm.iconOrientation == 'right'
            ? 'cal-link-img-order-2'
            : 'cal-link-img-order-1',
        ]},[_c('NuxtLink',{attrs:{"to":_vm.router}},[_c('cal-img',{staticClass:"cal-link-img",attrs:{"src":_vm.icon,"alt":"link icon","width":_vm.width,"height":_vm.height}})],1)],1)])]):_vm._e()])
}
var Linkvue_type_template_id_2c01bb14_staticRenderFns = []


// CONCATENATED MODULE: ./src/vue-components/button/Link.vue?vue&type=template&id=2c01bb14

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"9d9ca11a-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/vue-components/callia-image/Cal-Img.vue?vue&type=template&id=2a3f6274&scoped=true
var Cal_Imgvue_type_template_id_2a3f6274_scoped_true_render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{class:_vm.customClass,style:(_vm.inlineStyles),attrs:{"src":_vm.optimizedSrc,"alt":_vm.alt,"width":_vm.width,"height":_vm.height}})
}
var Cal_Imgvue_type_template_id_2a3f6274_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/vue-components/callia-image/Cal-Img.vue?vue&type=template&id=2a3f6274&scoped=true

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/vue-components/callia-image/Cal-Img.vue?vue&type=script&lang=js

/* harmony default export */ var Cal_Imgvue_type_script_lang_js = ({
  name: "cal-img",
  data() {
    return {
      observer: null,
      intersected: false,
    };
  },
  props: {
    src: {
      type: String,
      required: true,
    },
    alt: String,
    customClass: {
      type: String,
      default: "cal-responsive-img",
    },
    inlineStyles: String,
    width: Number,
    height: Number,
  },
  computed: {
    optimizedSrc() {
      return this.intersected ? this.src : "";
    },
  },
  mounted() {
    this.setupIntersectionObserver();
  },
  destroyed() {
    this.disconnectObserver();
  },
  methods: {
    setupIntersectionObserver() {
      this.observer = new IntersectionObserver((entries) => {
        const image = entries[0];
        if (image.isIntersecting) {
          this.intersected = true;
          this.observer.disconnect();
        }
      });

      this.observer.observe(this.$el);
    },
    disconnectObserver() {
      if (this.observer) {
        this.observer.disconnect();
      }
    },
  },
});

// CONCATENATED MODULE: ./src/vue-components/callia-image/Cal-Img.vue?vue&type=script&lang=js
 /* harmony default export */ var callia_image_Cal_Imgvue_type_script_lang_js = (Cal_Imgvue_type_script_lang_js); 
// EXTERNAL MODULE: ./src/vue-components/callia-image/Cal-Img.vue?vue&type=style&index=0&id=2a3f6274&prod&scoped=true&lang=css
var Cal_Imgvue_type_style_index_0_id_2a3f6274_prod_scoped_true_lang_css = __webpack_require__("021b");

// CONCATENATED MODULE: ./src/vue-components/callia-image/Cal-Img.vue






/* normalize component */

var Cal_Img_component = normalizeComponent(
  callia_image_Cal_Imgvue_type_script_lang_js,
  Cal_Imgvue_type_template_id_2a3f6274_scoped_true_render,
  Cal_Imgvue_type_template_id_2a3f6274_scoped_true_staticRenderFns,
  false,
  null,
  "2a3f6274",
  null
  
)

/* harmony default export */ var Cal_Img = (Cal_Img_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/vue-components/button/Link.vue?vue&type=script&lang=js



/* harmony default export */ var Linkvue_type_script_lang_js = ({
  name: "cal-link",
  data() {
    return {};
  },
  components: {
    CalImg: Cal_Img,
  },
  props: ["linkPath", "linkText", "icon", "router", "iconOrientation", "width", "height"],
});

// CONCATENATED MODULE: ./src/vue-components/button/Link.vue?vue&type=script&lang=js
 /* harmony default export */ var button_Linkvue_type_script_lang_js = (Linkvue_type_script_lang_js); 
// CONCATENATED MODULE: ./src/vue-components/button/Link.vue





/* normalize component */

var Link_component = normalizeComponent(
  button_Linkvue_type_script_lang_js,
  Linkvue_type_template_id_2c01bb14_render,
  Linkvue_type_template_id_2c01bb14_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var Link = (Link_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"9d9ca11a-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/vue-components/card/Card.vue?vue&type=template&id=7ac52fd1
var Cardvue_type_template_id_7ac52fd1_render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cal-card"},[_c('div',{staticClass:"cal-card-img-wrapper"},[(_vm.is_video)?_c('div',[_c('cal-video',{attrs:{"src":_vm.video,"customClass":"cal-card-img"}})],1):_c('div',[_c('cal-img',{attrs:{"src":_vm.img,"alt":_vm.image_alt,"customClass":"cal-card-img","width":_vm.width,"height":_vm.height}})],1)]),_c('div',{staticClass:"cal-card-body-wrapper"},[_c('div',{class:_vm.is_video ? 'cal-card-video-body' : 'cal-card-body'},[_c('h3',{staticClass:"cal-card-header"},[_vm._v(" "+_vm._s(_vm.header)+" ")]),_c('div',{staticClass:"cal-card-content",domProps:{"innerHTML":_vm._s(_vm.content)}})])]),_c('div',{staticClass:"cal-card-bottom-wrapper"},[(_vm.btntext !== undefined)?_c('div',{staticClass:"cal-card-btn-wrapper"},[(_vm.isSMS)?_c('button',{staticClass:"cal-card-btn",on:{"click":function($event){return _vm.sendSMS($event)}}},[_vm._v(" "+_vm._s(_vm.btntext)+" ")]):_c('button',{staticClass:"cal-card-btn"},[_c('a',{attrs:{"href":_vm.btnpath}},[_vm._v(" "+_vm._s(_vm.btntext))])])]):_vm._e()]),(_vm.mice)?_c('div',{staticClass:"cal-card-mice"},[_vm._v(" "+_vm._s(_vm.mice)+" ")]):_vm._e()])
}
var Cardvue_type_template_id_7ac52fd1_staticRenderFns = []


// CONCATENATED MODULE: ./src/vue-components/card/Card.vue?vue&type=template&id=7ac52fd1

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"9d9ca11a-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/vue-components/callia-video/Cal-Video.vue?vue&type=template&id=5fd6bc21&scoped=true
var Cal_Videovue_type_template_id_5fd6bc21_scoped_true_render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('video',{ref:"calVidPlayer",class:_vm.customClass,attrs:{"src":_vm.optimizedSrc,"controls":"","muted":""},domProps:{"muted":true}})])
}
var Cal_Videovue_type_template_id_5fd6bc21_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/vue-components/callia-video/Cal-Video.vue?vue&type=template&id=5fd6bc21&scoped=true

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/vue-components/callia-video/Cal-Video.vue?vue&type=script&lang=js

/* harmony default export */ var Cal_Videovue_type_script_lang_js = ({
  name: "cal-video",
  props: {
    src: {
      type: String,
      required: true,
    },
    customClass: {
      type: String,
      default: "cal-responsive-vid",
    },
  },
  data() {
    return {
      observer: null,
    };
  },
  computed: {
    optimizedSrc() {
      return this.src;
    },
  },
  mounted() {
    if (!this.observer) {
      this.setupIntersectionObserver();
    }
  },
  beforeDestroy() {
    this.disconnectObserver();
  },
  methods: {
    setupIntersectionObserver() {
      this.observer = new IntersectionObserver(this.handleIntersection, {
        root: null,
        rootMargin: "0px",
        threshold: 0.5,
      });

      this.observer.observe(this.$refs.calVidPlayer);
    },
    disconnectObserver() {
      if (this.observer) {
        this.observer.disconnect();
      }
    },
    handleIntersection(entries) {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          this.$refs.calVidPlayer.pause();
        } else {
          //if video out of viewport stop video playing
          if (!this.$refs.calVidPlayer.paused) {
            this.$refs.calVidPlayer.pause();
          }
        }
      });
    },
  },
});

// CONCATENATED MODULE: ./src/vue-components/callia-video/Cal-Video.vue?vue&type=script&lang=js
 /* harmony default export */ var callia_video_Cal_Videovue_type_script_lang_js = (Cal_Videovue_type_script_lang_js); 
// EXTERNAL MODULE: ./src/vue-components/callia-video/Cal-Video.vue?vue&type=style&index=0&id=5fd6bc21&prod&scoped=true&lang=css
var Cal_Videovue_type_style_index_0_id_5fd6bc21_prod_scoped_true_lang_css = __webpack_require__("becb");

// CONCATENATED MODULE: ./src/vue-components/callia-video/Cal-Video.vue






/* normalize component */

var Cal_Video_component = normalizeComponent(
  callia_video_Cal_Videovue_type_script_lang_js,
  Cal_Videovue_type_template_id_5fd6bc21_scoped_true_render,
  Cal_Videovue_type_template_id_5fd6bc21_scoped_true_staticRenderFns,
  false,
  null,
  "5fd6bc21",
  null
  
)

/* harmony default export */ var Cal_Video = (Cal_Video_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/vue-components/card/Card.vue?vue&type=script&lang=js




/* harmony default export */ var Cardvue_type_script_lang_js = ({
  name: "cal-card",
  data() {
    return {};
  },
  components: {
    CalImg: Cal_Img,
    CalVideo: Cal_Video,
  },
  props: [
    "btntext",
    "btnpath",
    "img",
    "header",
    "content",
    "mice",
    "is_video",
    "video",
    "image_alt",
    "isSMS",
    "width",
    "height",
  ],
  methods: {
    sendSMS(e) {
      this.$emit("send-sms", e);
    },
  },
});

// CONCATENATED MODULE: ./src/vue-components/card/Card.vue?vue&type=script&lang=js
 /* harmony default export */ var card_Cardvue_type_script_lang_js = (Cardvue_type_script_lang_js); 
// CONCATENATED MODULE: ./src/vue-components/card/Card.vue





/* normalize component */

var Card_component = normalizeComponent(
  card_Cardvue_type_script_lang_js,
  Cardvue_type_template_id_7ac52fd1_render,
  Cardvue_type_template_id_7ac52fd1_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var Card = (Card_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"9d9ca11a-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/vue-components/social-media/Social-Media.vue?vue&type=template&id=522c8566
var Social_Mediavue_type_template_id_522c8566_render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"cal-social-icons"},_vm._l((_vm.socialMediaList),function(icon){return _c('a',{key:icon.name,attrs:{"href":icon.link,"target":"_blank"}},[(icon.name === 'instagram')?_c('svg',{staticClass:"social-icon text-primary feather feather-instagram",attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"2em","height":"2em","viewBox":"0 0 24 24","fill":"currentColor","stroke-width":"1","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M12 9.52A2.48 2.48 0 1 0 14.48 12A2.48 2.48 0 0 0 12 9.52Zm9.93-2.45a6.53 6.53 0 0 0-.42-2.26a4 4 0 0 0-2.32-2.32a6.53 6.53 0 0 0-2.26-.42C15.64 2 15.26 2 12 2s-3.64 0-4.93.07a6.53 6.53 0 0 0-2.26.42a4 4 0 0 0-2.32 2.32a6.53 6.53 0 0 0-.42 2.26C2 8.36 2 8.74 2 12s0 3.64.07 4.93a6.86 6.86 0 0 0 .42 2.27a3.94 3.94 0 0 0 .91 1.4a3.89 3.89 0 0 0 1.41.91a6.53 6.53 0 0 0 2.26.42C8.36 22 8.74 22 12 22s3.64 0 4.93-.07a6.53 6.53 0 0 0 2.26-.42a3.89 3.89 0 0 0 1.41-.91a3.94 3.94 0 0 0 .91-1.4a6.6 6.6 0 0 0 .42-2.27C22 15.64 22 15.26 22 12s0-3.64-.07-4.93Zm-2.54 8a5.73 5.73 0 0 1-.39 1.8A3.86 3.86 0 0 1 16.87 19a5.73 5.73 0 0 1-1.81.35H8.94A5.73 5.73 0 0 1 7.13 19a3.51 3.51 0 0 1-1.31-.86A3.51 3.51 0 0 1 5 16.87a5.49 5.49 0 0 1-.34-1.81V8.94A5.49 5.49 0 0 1 5 7.13a3.51 3.51 0 0 1 .86-1.31A3.59 3.59 0 0 1 7.13 5a5.73 5.73 0 0 1 1.81-.35h6.12a5.73 5.73 0 0 1 1.81.35a3.51 3.51 0 0 1 1.31.86A3.51 3.51 0 0 1 19 7.13a5.73 5.73 0 0 1 .35 1.81V12c0 2.06.07 2.27.04 3.06Zm-1.6-7.44a2.38 2.38 0 0 0-1.41-1.41A4 4 0 0 0 15 6H9a4 4 0 0 0-1.38.26a2.38 2.38 0 0 0-1.41 1.36A4.27 4.27 0 0 0 6 9v6a4.27 4.27 0 0 0 .26 1.38a2.38 2.38 0 0 0 1.41 1.41a4.27 4.27 0 0 0 1.33.26h6a4 4 0 0 0 1.38-.26a2.38 2.38 0 0 0 1.41-1.41a4 4 0 0 0 .26-1.38V9a3.78 3.78 0 0 0-.26-1.38ZM12 15.82A3.81 3.81 0 0 1 8.19 12A3.82 3.82 0 1 1 12 15.82Zm4-6.89a.9.9 0 0 1 0-1.79a.9.9 0 0 1 0 1.79Z"}})]):_vm._e(),(icon.name === 'twitter')?_c('svg',{staticClass:"social-icon text-primary feather feather-twitter",attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"2em","height":"2em","viewBox":"0 0 24 24","fill":"currentColor","stroke-width":"1","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M8.29 20.251c7.547 0 11.675-6.253 11.675-11.675 0-.178 0-.355-.012-.53A8.348 8.348 0 0022 5.92a8.19 8.19 0 01-2.357.646 4.118 4.118 0 001.804-2.27 8.224 8.224 0 01-2.605.996 4.107 4.107 0 00-6.993 3.743 11.65 11.65 0 01-8.457-4.287 4.106 4.106 0 001.27 5.477A4.072 4.072 0 012.8 9.713v.052a4.105 4.105 0 003.292 4.022 4.095 4.095 0 01-1.853.07 4.108 4.108 0 003.834 2.85A8.233 8.233 0 012 18.407a11.616 11.616 0 006.29 1.84"}})]):_vm._e(),(icon.name === 'facebook')?_c('svg',{staticClass:"social-icon text-primary feather feather-facebook",attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"2em","height":"2em","viewBox":"0 0 24 24","fill":"currentColor","stroke-width":"1","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.988C18.343 21.128 22 16.991 22 12z"}})]):_vm._e(),(icon.name === 'tiktok')?_c('svg',{staticClass:"social-icon text-primary feather feather-tiktok",attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"2em","height":"2em","viewBox":"0 0 24 24","fill":"currentColor","stroke-width":"1","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M16.6 5.82s.51.5 0 0A4.278 4.278 0 0 1 15.54 3h-3.09v12.4a2.592 2.592 0 0 1-2.59 2.5c-1.42 0-2.6-1.16-2.6-2.6c0-1.72 1.66-3.01 3.37-2.48V9.66c-3.45-.46-6.47 2.22-6.47 5.64c0 3.33 2.76 5.7 5.69 5.7c3.14 0 5.69-2.55 5.69-5.7V9.01a7.35 7.35 0 0 0 4.3 1.38V7.3s-1.88.09-3.24-1.48z"}})]):_vm._e()])}),0)])
}
var Social_Mediavue_type_template_id_522c8566_staticRenderFns = []


// CONCATENATED MODULE: ./src/vue-components/social-media/Social-Media.vue?vue&type=template&id=522c8566

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/vue-components/social-media/Social-Media.vue?vue&type=script&lang=js

/* harmony default export */ var Social_Mediavue_type_script_lang_js = ({
  name: "cal-social-media",
  props: {
    socialMediaList: {
      type: Array,
      default() {
        return [
          {
            name: "instagram",
            link: "https://www.instagram.com/calliaflowers/",
          },
          {
            name: "twitter",
            link: "https://twitter.com/calliaflowers",
          },
          {
            name: "facebook",
            link: "https://www.facebook.com/calliaflowers/",
          },
          {
            name: "tiktok",
            link: "https://www.tiktok.com/@calliaflowers",
          },
        ];
      },
    },
  },
});

// CONCATENATED MODULE: ./src/vue-components/social-media/Social-Media.vue?vue&type=script&lang=js
 /* harmony default export */ var social_media_Social_Mediavue_type_script_lang_js = (Social_Mediavue_type_script_lang_js); 
// CONCATENATED MODULE: ./src/vue-components/social-media/Social-Media.vue





/* normalize component */

var Social_Media_component = normalizeComponent(
  social_media_Social_Mediavue_type_script_lang_js,
  Social_Mediavue_type_template_id_522c8566_render,
  Social_Mediavue_type_template_id_522c8566_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var Social_Media = (Social_Media_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"9d9ca11a-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/vue-components/review/Review-Header.vue?vue&type=template&id=4446989c
var Review_Headervue_type_template_id_4446989c_render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"cal-review-block-header"},[_vm._v(" "+_vm._s(_vm.header)+" ")]),_c('div',{staticClass:"cal-review-block-body"},[_c('div',{staticClass:"cal-review-block-text"},[_vm._v(" "+_vm._s(_vm.count)+" ")]),_c('div',{staticClass:"cal-review-block-icons"},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24","fill":"currentColor","className":"w-6 h-6"}},[_c('path',{attrs:{"fillRule":"evenodd","d":"M10.788 3.21c.448-1.077 1.976-1.077 2.424 0l2.082 5.007 5.404.433c1.164.093 1.636 1.545.749 2.305l-4.117 3.527 1.257 5.273c.271 1.136-.964 2.033-1.96 1.425L12 18.354 7.373 21.18c-.996.608-2.231-.29-1.96-1.425l1.257-5.273-4.117-3.527c-.887-.76-.415-2.212.749-2.305l5.404-.433 2.082-5.006z","clipRule":"evenodd"}})]),_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24","fill":"currentColor","className":"w-6 h-6"}},[_c('path',{attrs:{"fillRule":"evenodd","d":"M10.788 3.21c.448-1.077 1.976-1.077 2.424 0l2.082 5.007 5.404.433c1.164.093 1.636 1.545.749 2.305l-4.117 3.527 1.257 5.273c.271 1.136-.964 2.033-1.96 1.425L12 18.354 7.373 21.18c-.996.608-2.231-.29-1.96-1.425l1.257-5.273-4.117-3.527c-.887-.76-.415-2.212.749-2.305l5.404-.433 2.082-5.006z","clipRule":"evenodd"}})]),_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24","fill":"currentColor","className":"w-6 h-6"}},[_c('path',{attrs:{"fillRule":"evenodd","d":"M10.788 3.21c.448-1.077 1.976-1.077 2.424 0l2.082 5.007 5.404.433c1.164.093 1.636 1.545.749 2.305l-4.117 3.527 1.257 5.273c.271 1.136-.964 2.033-1.96 1.425L12 18.354 7.373 21.18c-.996.608-2.231-.29-1.96-1.425l1.257-5.273-4.117-3.527c-.887-.76-.415-2.212.749-2.305l5.404-.433 2.082-5.006z","clipRule":"evenodd"}})]),_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24","fill":"currentColor","className":"w-6 h-6"}},[_c('path',{attrs:{"fillRule":"evenodd","d":"M10.788 3.21c.448-1.077 1.976-1.077 2.424 0l2.082 5.007 5.404.433c1.164.093 1.636 1.545.749 2.305l-4.117 3.527 1.257 5.273c.271 1.136-.964 2.033-1.96 1.425L12 18.354 7.373 21.18c-.996.608-2.231-.29-1.96-1.425l1.257-5.273-4.117-3.527c-.887-.76-.415-2.212.749-2.305l5.404-.433 2.082-5.006z","clipRule":"evenodd"}})]),_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24","fill":"currentColor","className":"w-6 h-6"}},[_c('path',{attrs:{"fillRule":"evenodd","d":"M10.788 3.21c.448-1.077 1.976-1.077 2.424 0l2.082 5.007 5.404.433c1.164.093 1.636 1.545.749 2.305l-4.117 3.527 1.257 5.273c.271 1.136-.964 2.033-1.96 1.425L12 18.354 7.373 21.18c-.996.608-2.231-.29-1.96-1.425l1.257-5.273-4.117-3.527c-.887-.76-.415-2.212.749-2.305l5.404-.433 2.082-5.006z","clipRule":"evenodd"}})])]),_c('div',{staticClass:"cal-review-block-text"},[_vm._v(" "+_vm._s(_vm.constant)+" ")])])])
}
var Review_Headervue_type_template_id_4446989c_staticRenderFns = []


// CONCATENATED MODULE: ./src/vue-components/review/Review-Header.vue?vue&type=template&id=4446989c

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/vue-components/review/Review-Header.vue?vue&type=script&lang=js

/* harmony default export */ var Review_Headervue_type_script_lang_js = ({
  name: "cal-review-header",
  props: ["header", "count", "constant"],
});

// CONCATENATED MODULE: ./src/vue-components/review/Review-Header.vue?vue&type=script&lang=js
 /* harmony default export */ var review_Review_Headervue_type_script_lang_js = (Review_Headervue_type_script_lang_js); 
// CONCATENATED MODULE: ./src/vue-components/review/Review-Header.vue





/* normalize component */

var Review_Header_component = normalizeComponent(
  review_Review_Headervue_type_script_lang_js,
  Review_Headervue_type_template_id_4446989c_render,
  Review_Headervue_type_template_id_4446989c_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var Review_Header = (Review_Header_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"9d9ca11a-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/vue-components/feature-block/H-Feature-Block.vue?vue&type=template&id=f8982a08
var H_Feature_Blockvue_type_template_id_f8982a08_render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cal-h-feature-block"},[_c('cal-img',{attrs:{"src":_vm.image,"alt":_vm.image_alt,"customClass":"cal-h-feature-block-img","width":_vm.width,"height":_vm.height}}),_c('div',[_c('div',{staticClass:"cal-h-feature-block-heading"},[_vm._v(" "+_vm._s(_vm.heading)+" ")]),_c('div',{staticClass:"cal-h-feature-block-para",domProps:{"innerHTML":_vm._s(_vm.paragraph)}})])],1)
}
var H_Feature_Blockvue_type_template_id_f8982a08_staticRenderFns = []


// CONCATENATED MODULE: ./src/vue-components/feature-block/H-Feature-Block.vue?vue&type=template&id=f8982a08

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/vue-components/feature-block/H-Feature-Block.vue?vue&type=script&lang=js



/* harmony default export */ var H_Feature_Blockvue_type_script_lang_js = ({
  name: "cal-h-feature-block",
  components: {
    CalImg: Cal_Img,
  },
  props: ["image", "image_alt", "heading", "paragraph", "width", "height"],
});

// CONCATENATED MODULE: ./src/vue-components/feature-block/H-Feature-Block.vue?vue&type=script&lang=js
 /* harmony default export */ var feature_block_H_Feature_Blockvue_type_script_lang_js = (H_Feature_Blockvue_type_script_lang_js); 
// CONCATENATED MODULE: ./src/vue-components/feature-block/H-Feature-Block.vue





/* normalize component */

var H_Feature_Block_component = normalizeComponent(
  feature_block_H_Feature_Blockvue_type_script_lang_js,
  H_Feature_Blockvue_type_template_id_f8982a08_render,
  H_Feature_Blockvue_type_template_id_f8982a08_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var H_Feature_Block = (H_Feature_Block_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"9d9ca11a-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/vue-components/feature-block/V-Feature-Block.vue?vue&type=template&id=446f9725
var V_Feature_Blockvue_type_template_id_446f9725_render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.box_size === 'md')?_c('div',{staticClass:"cal-v-feature-block"},[_c('div',{staticClass:"cal-v-feature-block-img"},[_c('cal-img',{attrs:{"src":_vm.image,"alt":_vm.image_alt,"width":_vm.width,"height":_vm.height}})],1),_c('div',{staticClass:"cal-v-feature-block-heading"},[_vm._v(" "+_vm._s(_vm.heading)+" ")]),_c('div',{staticClass:"cal-v-feature-block-para",domProps:{"innerHTML":_vm._s(_vm.paragraph)}})]):(_vm.box_size === 'lg')?_c('div',{staticClass:"cal-v-feature-block cal-v-feature-block-lg"},[_c('div',{staticClass:"cal-v-feature-block-img-lg"},[_c('cal-img',{attrs:{"src":_vm.image,"alt":_vm.image_alt,"width":_vm.width,"height":_vm.height}})],1),_c('div',{staticClass:"cal-v-feature-block-body"},[_c('div',{staticClass:"cal-v-feature-block-heading cal-v-feature-block-heading-lg"},[_vm._v(" "+_vm._s(_vm.heading)+" ")]),_c('div',{staticClass:"cal-v-feature-block-para cal-v-feature-block-para-lg",domProps:{"innerHTML":_vm._s(_vm.paragraph)}})])]):_vm._e()])
}
var V_Feature_Blockvue_type_template_id_446f9725_staticRenderFns = []


// CONCATENATED MODULE: ./src/vue-components/feature-block/V-Feature-Block.vue?vue&type=template&id=446f9725

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/vue-components/feature-block/V-Feature-Block.vue?vue&type=script&lang=js



/* harmony default export */ var V_Feature_Blockvue_type_script_lang_js = ({
  name: "cal-v-feature-block",
  components: {
    CalImg: Cal_Img,
  },
  props: {
    box_size: {
      default: "md",
      type: String,
    },
    image: {
      default: "",
      type: String,
    },
    image_alt: {
      default: "",
      type: String,
    },
    heading: {
      default: "",
      type: String,
    },
    paragraph: {
      default: "",
      type: String,
    },
    width: {
      type: Number,
    },
    height: {
      type: Number,
    },
  },
});

// CONCATENATED MODULE: ./src/vue-components/feature-block/V-Feature-Block.vue?vue&type=script&lang=js
 /* harmony default export */ var feature_block_V_Feature_Blockvue_type_script_lang_js = (V_Feature_Blockvue_type_script_lang_js); 
// CONCATENATED MODULE: ./src/vue-components/feature-block/V-Feature-Block.vue





/* normalize component */

var V_Feature_Block_component = normalizeComponent(
  feature_block_V_Feature_Blockvue_type_script_lang_js,
  V_Feature_Blockvue_type_template_id_446f9725_render,
  V_Feature_Blockvue_type_template_id_446f9725_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var V_Feature_Block = (V_Feature_Block_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"9d9ca11a-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/vue-components/content-block/H-Content-Block.vue?vue&type=template&id=51b9e9be
var H_Content_Blockvue_type_template_id_51b9e9be_render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cal-content-block",class:{ 'cal-content-block-overlap': _vm.overlap }},[(_vm.is_video)?_c('div',{staticClass:"cal-content-block-img",class:{
      'cal-content-block-img-order-last': _vm.image_position === 'right',
      'cal-content-block-img-overlap': _vm.overlap,
    }},[_c('cal-video',{attrs:{"src":_vm.image}})],1):_c('div',{staticClass:"cal-content-block-img",class:{
      'cal-content-block-img-order-last': _vm.image_position === 'right',
      'cal-content-block-img-overlap': _vm.overlap,
    }},[_c('cal-img',{attrs:{"src":_vm.image,"alt":_vm.image_alt,"width":_vm.width,"height":_vm.height}})],1),_c('div',{staticClass:"cal-content-block-text",class:{
      'cal-content-block-img-overlap': _vm.overlap,
      'cal-content-block-text-right': _vm.image_position === 'right',
    }},[_c('div',{staticClass:"cal-content-block-heading-wrapper"},[(_vm.subheading)?_c('h5',{staticClass:"cal-content-block-subheading"},[_vm._v(" "+_vm._s(_vm.subheading)+" ")]):_vm._e()]),_c('div',{staticClass:"cal-content-block-heading-wrapper"},[_c('h3',{staticClass:"cal-content-block-heading",class:{ 'cal-content-block-heading-overlap': _vm.overlap }},[_vm._v(" "+_vm._s(_vm.heading)+" ")])]),_c('div',{staticClass:"cal-content-block-content",domProps:{"innerHTML":_vm._s(_vm.paragraph)}}),_c('div',[(_vm.button_text)?_c('button',{staticClass:"cal-btn",on:{"click":function($event){return _vm.navigateToRoute(_vm.button_route)}}},[_vm._v(" "+_vm._s(_vm.button_text)+" ")]):_vm._e()])])])
}
var H_Content_Blockvue_type_template_id_51b9e9be_staticRenderFns = []


// CONCATENATED MODULE: ./src/vue-components/content-block/H-Content-Block.vue?vue&type=template&id=51b9e9be

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/vue-components/content-block/H-Content-Block.vue?vue&type=script&lang=js




/* harmony default export */ var H_Content_Blockvue_type_script_lang_js = ({
  name: "cal-h-content-block",
  components: {
    CalImg: Cal_Img,
    CalVideo: Cal_Video,
  },
  props: [
    "image",
    "image_alt",
    "image_position",
    "subheading",
    "heading",
    "paragraph",
    "button_style",
    "button_text",
    "button_route",
    "is_video",
    "overlap",
    "width",
    "height",
  ],
  methods: {
    navigateToRoute(button_route) {
      if (button_route.startsWith("http")) {
        window.location.href = button_route;
      } else {
        this.$router.push(button_route);
      }
    },
  },
});

// CONCATENATED MODULE: ./src/vue-components/content-block/H-Content-Block.vue?vue&type=script&lang=js
 /* harmony default export */ var content_block_H_Content_Blockvue_type_script_lang_js = (H_Content_Blockvue_type_script_lang_js); 
// CONCATENATED MODULE: ./src/vue-components/content-block/H-Content-Block.vue





/* normalize component */

var H_Content_Block_component = normalizeComponent(
  content_block_H_Content_Blockvue_type_script_lang_js,
  H_Content_Blockvue_type_template_id_51b9e9be_render,
  H_Content_Blockvue_type_template_id_51b9e9be_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var H_Content_Block = (H_Content_Block_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"9d9ca11a-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/vue-components/hover-item/Hover-Item.vue?vue&type=template&id=ad07df1e
var Hover_Itemvue_type_template_id_ad07df1e_render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cal-hover-item group"},[_c('a',{staticClass:"cal-hover-item-overlay",attrs:{"href":_vm.url}},[_c('cal-img',{attrs:{"src":_vm.image,"alt":_vm.alt,"customClass":`cal-hover-item-image${_vm.hover ? ' cal-hover-item-image-hover' : ''}`,"width":_vm.width,"height":_vm.height}})],1),_c('div',{staticClass:"cal-hover-item-text-container"},[_c('span',{staticClass:"cal-hover-item-text"},[_vm._v(_vm._s(_vm.text))])])])
}
var Hover_Itemvue_type_template_id_ad07df1e_staticRenderFns = []


// CONCATENATED MODULE: ./src/vue-components/hover-item/Hover-Item.vue?vue&type=template&id=ad07df1e

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/vue-components/hover-item/Hover-Item.vue?vue&type=script&lang=js



/* harmony default export */ var Hover_Itemvue_type_script_lang_js = ({
  name: "cal-hover-item",
  components: {
    CalImg: Cal_Img,
  },
  props: {
    image: {
      type: String,
      required: true,
    },
    alt: {
      type: String,
    },
    text: {
      type: String,
    },
    hover: {
      type: Boolean,
      default: true,
    },
    url: {
      type: String,
    },
    width: {
      type: Number,
    },
    height: {
      type: Number,
    },
  },
});

// CONCATENATED MODULE: ./src/vue-components/hover-item/Hover-Item.vue?vue&type=script&lang=js
 /* harmony default export */ var hover_item_Hover_Itemvue_type_script_lang_js = (Hover_Itemvue_type_script_lang_js); 
// CONCATENATED MODULE: ./src/vue-components/hover-item/Hover-Item.vue





/* normalize component */

var Hover_Item_component = normalizeComponent(
  hover_item_Hover_Itemvue_type_script_lang_js,
  Hover_Itemvue_type_template_id_ad07df1e_render,
  Hover_Itemvue_type_template_id_ad07df1e_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var Hover_Item = (Hover_Item_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"9d9ca11a-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/vue-components/faq-item/Faq-Item.vue?vue&type=template&id=404a7678
var Faq_Itemvue_type_template_id_404a7678_render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"cal-faq-item"},[_c('div',{staticClass:"cal-faq-item-question",on:{"click":_vm.showAnswer}},[(!_vm.textSize)?_c('h3',{staticClass:"cal-faq-item-question-text"},[_vm._v(" "+_vm._s(_vm.question)+" ")]):_c('h4',{staticClass:"cal-faq-item-question-text-sm"},[_vm._v(_vm._s(_vm.question))]),_c('svg',{staticClass:"cal-faq-item-question-img",attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"1.4em","height":"1.4em","viewBox":"0 0 30 30","fill":"none","stroke":"currentColor","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('line',{staticClass:"cal-faq-item-question-plus-icon",attrs:{"x1":"0","y1":"15","x2":"30","y2":"15"}}),_c('line',{staticClass:"cal-faq-item-question-plus-icon",style:(_vm.verticalLineTransform),attrs:{"x1":"15","y1":"0","x2":"15","y2":"30"}})])]),_c('transition',{style:({ height: _vm.height + 'px' }),on:{"enter":_vm.enter,"after-enter":_vm.afterEnter,"leave":_vm.leave,"after-leave":_vm.afterLeave}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isShowAnswer),expression:"isShowAnswer"}],ref:"answer",staticClass:"cal-faq-item-answer"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.answer)}}),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.videoUrl && _vm.isShowAnswer),expression:"videoUrl && isShowAnswer"}],staticClass:"cal-faq-item-video-wrapper"},[_c('cal-video',{attrs:{"src":_vm.videoUrl,"customClass":"cal-faq-item-video"}})],1)])])],1)])
}
var Faq_Itemvue_type_template_id_404a7678_staticRenderFns = []


// CONCATENATED MODULE: ./src/vue-components/faq-item/Faq-Item.vue?vue&type=template&id=404a7678

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/vue-components/faq-item/Faq-Item.vue?vue&type=script&lang=js



/* harmony default export */ var Faq_Itemvue_type_script_lang_js = ({
  name: "cal-faq-item",
  components: {
    CalVideo: Cal_Video,
  },
  data() {
    return {
      isShowAnswer: false,
      height: 0,
    };
  },
  computed: {
    verticalLineTransform() {
      return {
        transform: this.isShowAnswer ? "rotate(90deg)" : "rotate(0deg)",
        transition: "transform 0.4s ease",
        transformOrigin: "center",
      };
    },
  },
  methods: {
    showAnswer() {
      this.isShowAnswer = !this.isShowAnswer;
    },
    enter(el) {
      el.style.height = "0px";
      el.offsetHeight; // trigger reflow
      el.style.height = el.scrollHeight + "px";
    },
    afterEnter(el) {
      el.style.height = "auto";
    },
    leave(el) {
      el.style.height = el.scrollHeight + "px";
      el.offsetHeight; // trigger reflow
      el.style.height = "0px";
    },
    afterLeave(el) {
      el.style.height = "0px";
    },
  },
  props: {
    question: String,
    answer: String,
    icon: String,
    alt: String,
    textSize: String,
    videoUrl: {
      type: String,
      default: "",
    },
  },
});

// CONCATENATED MODULE: ./src/vue-components/faq-item/Faq-Item.vue?vue&type=script&lang=js
 /* harmony default export */ var faq_item_Faq_Itemvue_type_script_lang_js = (Faq_Itemvue_type_script_lang_js); 
// CONCATENATED MODULE: ./src/vue-components/faq-item/Faq-Item.vue





/* normalize component */

var Faq_Item_component = normalizeComponent(
  faq_item_Faq_Itemvue_type_script_lang_js,
  Faq_Itemvue_type_template_id_404a7678_render,
  Faq_Itemvue_type_template_id_404a7678_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var Faq_Item = (Faq_Item_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"9d9ca11a-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/vue-components/modal/Modal.vue?vue&type=template&id=4aacc622
var Modalvue_type_template_id_4aacc622_render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"modal",attrs:{"aria-labelledby":"modal-title","role":"dialog","aria-modal":"true"}},[_c('div',{staticClass:"modal-background modal-background-color",on:{"click":function($event){return _vm.$emit('close-modal')}}}),_c('div',{staticClass:"modal-body",on:{"click":function($event){$event.stopPropagation();}}},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-content-color",class:!_vm.resetPadding ? 'modal-content-in modal-content-in-padding' : 'modal-content-in'},[_c('div',{staticClass:"modal-close"},[(!_vm.hideClosebtn)?_c('button',{attrs:{"type":"button"},on:{"click":function($event){return _vm.$emit('close-modal')}}},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","fill":"none","viewBox":"0 0 24 24","stroke-width":"1.5","stroke":"currentColor","aria-hidden":"true"}},[_c('path',{attrs:{"stroke-linecap":"round","stroke-linejoin":"round","d":"M6 18L18 6M6 6l12 12"}})])]):_vm._e()]),_vm._t("default")],2)])])])
}
var Modalvue_type_template_id_4aacc622_staticRenderFns = []


// CONCATENATED MODULE: ./src/vue-components/modal/Modal.vue?vue&type=template&id=4aacc622

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/vue-components/modal/Modal.vue?vue&type=script&lang=js

/* harmony default export */ var Modalvue_type_script_lang_js = ({
  name: "cal-modal",
  props: {
    isShow: false,
    hideClosebtn: false,
    resetPadding: false,
  },
});

// CONCATENATED MODULE: ./src/vue-components/modal/Modal.vue?vue&type=script&lang=js
 /* harmony default export */ var modal_Modalvue_type_script_lang_js = (Modalvue_type_script_lang_js); 
// CONCATENATED MODULE: ./src/vue-components/modal/Modal.vue





/* normalize component */

var Modal_component = normalizeComponent(
  modal_Modalvue_type_script_lang_js,
  Modalvue_type_template_id_4aacc622_render,
  Modalvue_type_template_id_4aacc622_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var Modal = (Modal_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"9d9ca11a-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/vue-components/date-picker/Date-Picker.vue?vue&type=template&id=d6488c3c
var Date_Pickervue_type_template_id_d6488c3c_render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"date-picker-container"},[_c('div',{staticClass:"date-picker-menu"},[_c('button',{staticClass:"date-picker-button",attrs:{"type":"button","disabled":(_vm.month == _vm.nextAvailableDate.split('-')[1] && _vm.year == _vm.nextAvailableDate.split('-')[0]) ||
        (_vm.month < _vm.nextAvailableDate.split('-')[1] && _vm.year == _vm.nextAvailableDate.split('-')[0]) ||
        _vm.year < _vm.nextAvailableDate.split('-')[0]},on:{"click":_vm.movePreviousMonth}},[_c('span',{staticClass:"date-picker-button-span"},[_vm._v("Previous month")]),_c('svg',{staticClass:"date-picker-button-icon",attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 20 20","fill":"currentColor","aria-hidden":"true"}},[_c('path',{attrs:{"fill-rule":"evenodd","d":"M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z","clip-rule":"evenodd"}})])]),_c('div',{staticClass:"date-picker-month date-picker-month-mobile"},[_vm._v(" "+_vm._s(_vm.getMonthLabel(_vm.month - 1))+" "+_vm._s(_vm.year)+" ")]),(!_vm.singleMonth)?_c('div',{staticClass:"date-picker-month date-picker-month-desktop"},[_vm._v(" "+_vm._s(_vm.getMonthLabel(_vm.month2 - 1))+" "+_vm._s(_vm.year2)+" ")]):_vm._e(),_c('button',{staticClass:"date-picker-button",attrs:{"type":"button","disabled":_vm.maxDate !== ''
          ? (_vm.month == _vm.maxDate.split('-')[1] && _vm.year == _vm.maxDate.split('-')[0]) ||
            (_vm.month > _vm.maxDate.split('-')[1] && _vm.year == _vm.maxDate.split('-')[0]) ||
            _vm.year > _vm.maxDate.split('-')[0]
          : false},on:{"click":_vm.moveNextMonth}},[_c('span',{staticClass:"date-picker-button-span"},[_vm._v("Next month")]),_c('svg',{staticClass:"date-picker-button-icon",attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 20 20","fill":"currentColor","aria-hidden":"true"}},[_c('path',{attrs:{"fill-rule":"evenodd","d":"M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z","clip-rule":"evenodd"}})])])]),_c('div',{class:[_vm.singleMonth ? 'date-picker-slide-container-single' : 'date-picker-slide-container']},[_c('div',{staticClass:"date-picker-slide"},[_c('div',{staticClass:"date-picker-weekdays"},_vm._l((_vm.weekdays),function(weekday,index){return _c('div',{key:index},[_vm._v(" "+_vm._s(weekday.label)+" ")])}),0),_c('div',{staticClass:"date-picker-weeks-container"},_vm._l((_vm.weeks(1)),function(week,index){return _c('div',{key:index,staticClass:"date-picker-weeks"},_vm._l((week),function(day,childIndex){return _c('div',{key:childIndex,staticClass:"date-picker-days",class:[
              _vm.isDateUnavailable(day, childIndex)
                ? 'date-picker-days-button-disabled'
                : 'date-picker-days-button-available',
              _vm.selectedDate === day.date && !_vm.isDateUnavailable(day, childIndex)
                ? 'date-picker-days-button-active'
                : '',
              !day.inMonth ? 'date-picker-days-button-hidden' : '',
              day.isFirstDay ? 'date-picker-days-button-first' : '',
              _vm.singleMonth ? 'date-picker-days-single' : '',
              (_vm.showOccasions && _vm.findOccasion(day)) || _vm.findCutoffCountdown(day)
                ? 'date-picker-days-occasions tooltip-container'
                : '',
            ],attrs:{"name":_vm.generateDateId(
                _vm.year,
                _vm.getMonthLabel(_vm.month - 1),
                day,
                _vm.isDateUnavailable(day, childIndex) ? 'disabled' : 'available'
              )},on:{"click":function($event){return _vm.setDate(day, childIndex)}}},[((_vm.showOccasions && _vm.findOccasion(day)) || _vm.findCutoffCountdown(day))?_c('button',{staticClass:"date-picker-days-occasions-button",attrs:{"type":"button","disabled":_vm.isDateUnavailable(day, childIndex)}},[_c('span',{staticClass:"tooltip",attrs:{"id":day.date}},[_vm._v(_vm._s(_vm.getCombinedTooltipText(day))+" ")]),_c('time',{staticClass:"date-picker-days-button",class:[
                  _vm.isDateUnavailable(day, childIndex)
                    ? 'date-picker-days-button-inner-disabled'
                    : 'date-picker-days-occasions-button',
                ],attrs:{"datetime":day.label}},[_vm._v(" "+_vm._s(day.label)+" ")])]):_c('button',{attrs:{"type":"button","disabled":_vm.isDateUnavailable(day, childIndex)}},[_c('time',{staticClass:"date-picker-days-button",class:[
                  _vm.isDateUnavailable(day, childIndex)
                    ? 'date-picker-days-button-inner-disabled'
                    : '',
                ],attrs:{"datetime":day.label}},[_vm._v(" "+_vm._s(day.label)+" ")])])])}),0)}),0)]),(!_vm.singleMonth)?_c('div',{staticClass:"date-picker-slide",class:[
        _vm.singleMonth ? 'date-picker-slide date-picker-slide-single' : 'date-picker-slide-second',
      ]},[_c('div',{staticClass:"date-picker-weekdays"},_vm._l((_vm.weekdays),function(weekday,index){return _c('div',{key:index},[_vm._v(" "+_vm._s(weekday.label)+" ")])}),0),_c('div',{staticClass:"date-picker-weeks-container"},_vm._l((_vm.weeks(2)),function(week,index){return _c('div',{key:index,staticClass:"date-picker-weeks"},_vm._l((week),function(day,childIndex){return _c('div',{key:childIndex,staticClass:"date-picker-days",class:[
              day.isBeforeAvailableDate ||
              ((_vm.unavailableDates.includes(day.date) || _vm.closedDays.includes(childIndex)) &&
                !_vm.availableDates.includes(day.date))
                ? 'date-picker-days-button-disabled'
                : 'date-picker-days-button-available',
              _vm.selectedDate === day.date &&
              !day.isBeforeAvailableDate &&
              ((!_vm.unavailableDates.includes(day.date) && !_vm.closedDays.includes(childIndex)) ||
                _vm.availableDates.includes(day.date))
                ? 'date-picker-days-button-active'
                : '',
              !day.inMonth ? 'date-picker-days-button-hidden' : '',
              day.isFirstDay ? 'date-picker-days-button-first' : '',
              (_vm.showOccasions && _vm.findOccasion(day)) || _vm.findCutoffCountdown(day)
                ? 'date-picker-days-occasions tooltip-container'
                : '',
            ],attrs:{"name":_vm.generateDateId(
                _vm.year,
                _vm.getMonthLabel(_vm.month - 1),
                day,
                _vm.isDateUnavailable(day, childIndex) ? 'disabled' : 'available'
              )},on:{"click":function($event){return _vm.setDate(day, childIndex)}}},[((_vm.showOccasions && _vm.findOccasion(day)) || _vm.findCutoffCountdown(day))?_c('button',{staticClass:"date-picker-days-occasions-button",attrs:{"type":"button","disabled":_vm.isDateUnavailable(day, childIndex)}},[_c('span',{staticClass:"tooltip",attrs:{"id":day.date}},[_vm._v(_vm._s(_vm.getCombinedTooltipText(day))+" ")]),_c('time',{staticClass:"date-picker-days-button",class:[
                  _vm.isDateUnavailable(day, childIndex)
                    ? 'date-picker-days-button-inner-disabled'
                    : 'date-picker-days-occasions-button',
                ],attrs:{"datetime":day.label}},[_vm._v(" "+_vm._s(day.label)+" ")])]):_c('button',{attrs:{"type":"button","disabled":_vm.isDateUnavailable(day, childIndex)}},[_c('time',{staticClass:"date-picker-days-button",class:[
                  _vm.isDateUnavailable(day, childIndex)
                    ? 'date-picker-days-button-inner-disabled'
                    : '',
                ],attrs:{"datetime":day.label}},[_vm._v(" "+_vm._s(day.label)+" ")])])])}),0)}),0)]):_vm._e()])])
}
var Date_Pickervue_type_template_id_d6488c3c_staticRenderFns = []


// CONCATENATED MODULE: ./src/vue-components/date-picker/Date-Picker.vue?vue&type=template&id=d6488c3c

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/vue-components/date-picker/Date-Picker.vue?vue&type=script&lang=js

/* harmony default export */ var Date_Pickervue_type_script_lang_js = ({
  name: "DatePicker",
  data() {
    return {
      selectedDate: "",
      daysInMonths: [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31],
      weekdayLabels: ["S", "M", "T", "W", "T", "F", "S"],
      weekdayLabelsFr: ["D", "L", "M", "M", "J", "V", "S"],
      weekdayLength: 3,
      weekdayCasing: "title",
      monthLabels: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ],
      monthLabelsFr: [
        "janvier",
        "février",
        "mars",
        "avril",
        "mai",
        "juin",
        "juillet",
        "août",
        "septembre",
        "octobre",
        "novembre",
        "décembre",
      ],
      monthCasing: "title",
      year: new Date().getFullYear(),
      year2: new Date().getFullYear(),
      month: new Date().getMonth() + 1,
      month2: new Date().getMonth() + 2,
      day: new Date().getDate(),
      longPressActivateTime: 400,
      tooltipVisible: false,
      timer: null,
      isMobile: window.innerWidth <= 768,
    };
  },
  created() {
    if (new Date().getMonth() + 1 === 12) {
      this.year2++;
      this.month2 = 1;
    }

    if (this.onSelectedDate !== "") {
      this.selectedDate = this.onSelectedDate;
      this.year = new Date(this.selectedDate).getFullYear();
      this.month = new Date(this.selectedDate).getMonth() + 1;
      this.day = new Date(this.selectedDate).getDate();
    } else if (this.nextAvailableDate !== "") {
      this.year = new Date(this.nextAvailableDate).getFullYear();
      // get month without a timezone
      this.month = new Date(this.nextAvailableDate).getUTCMonth() + 1;
      this.day = new Date(this.nextAvailableDate).getDate();
      this.year2 = new Date(this.nextAvailableDate).getFullYear();
      this.month2 = new Date(this.nextAvailableDate).getUTCMonth() + 2;
    }
  },
  props: {
    showOccasions: {
      default: false,
    },
    occasions: {
      default() {
        return [];
      },
    },
    onSelectedDate: {
      default: "",
    },
    nextAvailableDate: {
      default: "",
    },
    availableDates: {
      default() {
        return [];
      },
    },
    unavailableDates: {
      default() {
        return [];
      },
    },
    closedDays: {
      default() {
        return [];
      },
    },
    locale: {
      default: "en-ca",
      type: String,
    },
    singleMonth: {
      dafault: false,
    },
    maxDate: {
      default: "",
    },
    cutoffCountdown: {
      default() {
        return [];
      },
    },
  },
  methods: {
    findOccasion(day) {
      let result = this.occasions.find((element) => {
        const providedDate = new Date(day.date);
        const occasionDate = new Date(element.date.split("T")[0]);

        if (providedDate.getTime() === occasionDate.getTime()) {
          return element;
        }
      });
      return result;
    },
    getOccasionText(occasion) {
      return occasion && occasion.title ? occasion.title : "";
    },
    getCombinedTooltipText(day) {
      let text = "";

      // Add cutoff countdown info if it exists
      const cutoff = this.findCutoffCountdown(day);
      if (cutoff && cutoff.timeLeft) {
        text = cutoff.timeLeft;
      }

      // Add occasion text if it exists
      const occasion = this.findOccasion(day);
      if (occasion && this.getOccasionText(occasion)) {
        if (text) text += "\n";
        text += this.getOccasionText(occasion);
      }

      return text;
    },
    findCutoffCountdown(day) {
      if (!this.cutoffCountdown || this.cutoffCountdown.length === 0) return null;

      const countdown = this.cutoffCountdown.find((item) => item.date === day.date);
      return countdown && countdown.timeLeft ? countdown : null;
    },
    setDate(v, day) {
      // listens to the 'input' event for changes
      if (
        !v.isBeforeAvailableDate &&
        ((!this.unavailableDates.includes(v.date) && !this.closedDays.includes(day)) ||
          this.availableDates.includes(v.date))
      ) {
        this.selectedDate = v.date;
        // this.value = v.date;
        // this.$emit("input", v.date);
        this.$emit("dateChange", this.selectedDate);
      }

      // Remove tooltip after 3 sec
      let mobElement = document.getElementById(v.date);
      if (mobElement && this.isMobile) {
        mobElement.style.display = "block";
        setTimeout(() => {
          mobElement.style.display = "none";
        }, 3000);
      }
    },
    generateDateId(year, month, day, lable) {
      if (day.dayString == "00") {
        return `date-empty`;
      }
      return `date-${lable}`;
    },
    isDateUnavailable(day, index) {
      return (
        day.isBeforeAvailableDate ||
        ((this.unavailableDates.includes(day.date) || this.closedDays.includes(index)) &&
          !this.availableDates.includes(day.date)) ||
        day.isBeforeAvailableMaxDate
      );
    },
    getMonthLabel(index) {
      if (this.locale && this.locale.toLowerCase() === "fr-ca") {
        return this.monthLabelsFr[index];
      } else {
        return this.monthLabels[index];
      }
    },
    transformLabel(label, length, casing) {
      label = length <= 0 ? label : label.substring(0, length);
      if (casing.toLowerCase() === "lower") return label.toLowerCase();
      if (casing.toLowerCase() === "upper") return label.toUpperCase();
      return label;
    },
    moveNextMonth() {
      if (this.month < 12) {
        this.month++;
      } else {
        this.month = 1;
        this.year++;
      }
      if (this.month2 < 12) {
        this.month2++;
      } else {
        this.month2 = 1;
        this.year2++;
      }
    },
    movePreviousMonth() {
      if (this.month > 1) {
        this.month--;
      } else {
        this.month = 12;
        this.year--;
      }
      if (this.month2 > 1) {
        this.month2--;
      } else {
        this.month2 = 12;
        this.year2--;
      }
    },
    firstWeekdayInMonth(month) {
      if (month !== 2) {
        return new Date(this.year, this.monthIndex, 1).getDay() + 1;
      } else {
        return new Date(this.year2, this.monthIndex2, 1).getDay() + 1;
      }
    },
    daysInMonth(month) {
      // Check for February in a leap year
      let currentMonth = this.month;
      let currentYear = this.year;
      let currentIndex = this.monthIndex;
      if (month == 2) {
        currentMonth = this.month2;
        currentYear = this.year2;
        currentIndex = this.monthIndex2;
      }
      const isFebruary = currentMonth === 2;
      const isLeapYear = (currentYear % 4 == 0 && currentYear % 100 != 0) || currentYear % 400 == 0;
      if (isFebruary && isLeapYear) return 29;
      // ...Just a normal month
      return this.daysInMonths[currentIndex];
    },
    weeks(month) {
      const weeks = [];
      let monthStarted = false,
        monthEnded = false;
      let monthDay = 0;
      // Cycle through each week of the month, up to 6 total
      for (let w = 1; w <= 6 && !monthEnded; w++) {
        // Cycle through each weekday
        const week = [];
        for (let d = 1; d <= 7; d++) {
          // We need to know when to start counting actual month days
          if (!monthStarted && d >= this.firstWeekdayInMonth(month)) {
            // Initialize day counter
            monthDay = 1;
            // ...and flag we're tracking actual month days
            monthStarted = true;
            // Still in the middle of the month (hasn't ended yet)
          } else if (monthStarted && !monthEnded) {
            // Increment the day counter
            monthDay += 1;
          }
          // Append day info for the current week
          // Note: this might or might not be an actual month day
          //  We don't know how the UI wants to display various days,
          //  so we'll supply all the data we can

          let datePart1 = `${this.year}-${
            this.month < 10 ? "0" + this.month.toString() : this.month
          }`;
          if (month === 2)
            datePart1 = `${this.year2}-${
              this.month2 < 10 ? "0" + this.month2.toString() : this.month2
            }`;

          // TODO refactor with dayjs plugin
          const month1 = this.month < 10 ? "0" + this.month : this.month;
          const month2 = this.month2 < 10 ? "0" + this.month2 : this.month2;
          const monthDayNew = monthDay < 10 ? "0" + monthDay : monthDay;

          week.push({
            label: monthDay ? monthDay.toString() : "",
            dayString: monthDay < 10 ? "0" + monthDay.toString() : monthDay,
            weekdayNumber: d,
            weekNumber: w,
            beforeMonth: !monthStarted,
            afterMonth: monthEnded,
            inMonth: monthDay > 0,
            isToday: false,
            isBeforeAvailableDate:
              new Date(this.nextAvailableDate).getTime() >
              new Date(
                month === 1
                  ? this.year + "-" + month1 + "-" + monthDayNew
                  : this.year2 + "-" + month2 + "-" + monthDayNew
              ).getTime(),
            isBeforeAvailableMaxDate:
              this.maxDate !== ""
                ? new Date(this.maxDate).getTime() >
                  new Date(
                    `${datePart1}-${
                      monthDay < 10 && monthDay > 0 ? "0" + monthDay.toString() : monthDay
                    }`
                  ).getTime()
                  ? false
                  : true
                : false,
            isFirstDay: monthDay === 1,
            isLastDay: monthDay === this.daysInMonth(month),
            isAvailable: true,
            date: `${datePart1}-${
              monthDay < 10 && monthDay > 0 ? "0" + monthDay.toString() : monthDay
            }`,
          });

          // Trigger end of month on the last day
          if (monthStarted && !monthEnded && monthDay >= this.daysInMonth(month)) {
            monthDay = 0;
            monthEnded = true;
          }
        }
        // Append week info for the month
        weeks.push(week);
      }

      return weeks;
    },
    handleTouchStart() {
      if (this.isMobile) {
        this.timer = setTimeout(() => {
          this.tooltipVisible = true;
        }, this.longPressActivateTime);
      }
    },
    handleTouchEnd() {
      clearTimeout(this.timer);
      if (this.isMobile) {
        this.tooltipVisible = false;
      }
    },
  },
  watch: {
    onSelectedDate() {
      this.selectedDate = this.onSelectedDate;
      if (this.selectedDate != "") {
        this.year = new Date(this.selectedDate).getFullYear();
        this.month = new Date(this.selectedDate).getMonth() + 1;
        this.day = new Date(this.selectedDate).getDate();
      }
    },
    nextAvailableDate() {
      if (this.selectedDate == "") {
        this.year = new Date(this.nextAvailableDate).getFullYear();
        // get month without a timezone
        this.month = new Date(this.nextAvailableDate).getUTCMonth() + 1;
        this.day = new Date(this.nextAvailableDate).getDate();
      }
    },
  },
  computed: {
    // Our component exposes month as 1-based, but sometimes we need 0-based
    monthIndex() {
      return this.month - 1;
    },
    monthIndex2() {
      return this.month2 - 1;
    },
    // State referenced by header (no dependencies yet...)
    months() {
      return this.monthLabels.map((ml, i) => ({
        label: this.transformLabel(ml, this.monthLength, this.monthCasing),
        number: i + 1,
      }));
    },
    // State for weekday header (no dependencies yet...)
    weekdays() {
      let weekdayLabels = this.weekdayLabels;
      if (this.locale && this.locale === "fr-ca") {
        weekdayLabels = this.weekdayLabelsFr;
      }
      return weekdayLabels.map((wl, i) => {
        return {
          label: this.transformLabel(wl, this.weekdayLength, this.weekdayCasing),
          number: i + 1,
        };
      });
    },
  },
});

// CONCATENATED MODULE: ./src/vue-components/date-picker/Date-Picker.vue?vue&type=script&lang=js
 /* harmony default export */ var date_picker_Date_Pickervue_type_script_lang_js = (Date_Pickervue_type_script_lang_js); 
// CONCATENATED MODULE: ./src/vue-components/date-picker/Date-Picker.vue





/* normalize component */

var Date_Picker_component = normalizeComponent(
  date_picker_Date_Pickervue_type_script_lang_js,
  Date_Pickervue_type_template_id_d6488c3c_render,
  Date_Pickervue_type_template_id_d6488c3c_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var Date_Picker = (Date_Picker_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"9d9ca11a-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/vue-components/text-area/Text-Area.vue?vue&type=template&id=e6040c9c
var Text_Areavue_type_template_id_e6040c9c_render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cal-text-area"},[_c('textarea',_vm._b({directives:[{name:"model",rawName:"v-model",value:(_vm.localValue),expression:"localValue"}],attrs:{"name":_vm.name,"cols":_vm.cols,"rows":_vm.rows,"placeholder":_vm.placeholder,"required":_vm.required,"disabled":_vm.disable},domProps:{"value":(_vm.localValue)},on:{"input":function($event){if($event.target.composing)return;_vm.localValue=$event.target.value}}},'textarea',_vm.$attrs,false))])
}
var Text_Areavue_type_template_id_e6040c9c_staticRenderFns = []


// CONCATENATED MODULE: ./src/vue-components/text-area/Text-Area.vue?vue&type=template&id=e6040c9c

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/vue-components/text-area/Text-Area.vue?vue&type=script&lang=js

/* harmony default export */ var Text_Areavue_type_script_lang_js = ({
  name: "cal-text-area",
  props: ["rows", "cols", "name", "placeholder", "required", "value", "disable"],
  data() {
    return {
      localValue: "",
    };
  },
  created() {
    this.localValue = this.value;
    this.$watch("localValue", (value) => {
      this.$emit("input", value);
    });
  },
});

// CONCATENATED MODULE: ./src/vue-components/text-area/Text-Area.vue?vue&type=script&lang=js
 /* harmony default export */ var text_area_Text_Areavue_type_script_lang_js = (Text_Areavue_type_script_lang_js); 
// CONCATENATED MODULE: ./src/vue-components/text-area/Text-Area.vue





/* normalize component */

var Text_Area_component = normalizeComponent(
  text_area_Text_Areavue_type_script_lang_js,
  Text_Areavue_type_template_id_e6040c9c_render,
  Text_Areavue_type_template_id_e6040c9c_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var Text_Area = (Text_Area_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"9d9ca11a-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/vue-components/carousel/cal-card-carousel.vue?vue&type=template&id=12b090c4
var cal_card_carouselvue_type_template_id_12b090c4_render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cal-carousel"},[_c('div',{staticClass:"cal-carousel-body"},[_c('div',{staticClass:"cal-carousel-mobile"},[(_vm.slider === 'review-card')?_c('ReviewCard',{attrs:{"slide":_vm.mobSlideset[_vm.activeMobindex],"altText":_vm.altText}}):_c('SlideCard',{attrs:{"slide":_vm.mobSlideset[_vm.activeMobindex],"altText":_vm.altText}})],1),_c('div',{staticClass:"cal-carousel-tab"},[_c('div',{staticClass:"cal-carousel-tab-body"},[(_vm.slider === 'review-card')?_c('ReviewCard',{attrs:{"slide":_vm.tabSlideset[_vm.activeTabindex][0],"altText":_vm.altText}}):_c('SlideCard',{attrs:{"slide":_vm.tabSlideset[_vm.activeTabindex][0],"altText":_vm.altText}}),(_vm.slider === 'review-card')?_c('ReviewCard',{attrs:{"slide":_vm.tabSlideset[_vm.activeTabindex][1],"altText":_vm.altText}}):_c('SlideCard',{attrs:{"slide":_vm.tabSlideset[_vm.activeTabindex][1],"altText":_vm.altText}})],1)]),_c('div',{staticClass:"cal-carousel-web"},[_c('div',{staticClass:"cal-carousel-web-body"},[(_vm.slider === 'review-card')?_c('ReviewCard',{attrs:{"slide":_vm.baseSlideset[_vm.activeBaseindex][0],"altText":_vm.altText}}):_c('SlideCard',{attrs:{"slide":_vm.baseSlideset[_vm.activeBaseindex][0],"altText":_vm.altText}}),(_vm.slider === 'review-card')?_c('ReviewCard',{attrs:{"slide":_vm.baseSlideset[_vm.activeBaseindex][1],"altText":_vm.altText}}):_c('SlideCard',{attrs:{"slide":_vm.baseSlideset[_vm.activeBaseindex][1],"altText":_vm.altText}}),(_vm.slider === 'review-card')?_c('ReviewCard',{attrs:{"slide":_vm.baseSlideset[_vm.activeBaseindex][2],"altText":_vm.altText}}):_c('SlideCard',{attrs:{"slide":_vm.baseSlideset[_vm.activeBaseindex][2],"altText":_vm.altText}})],1)])]),_c('div',{staticClass:"cal-carousel-footer"},[_vm._l((_vm.mobSlideset),function(sl,ind){return _c('div',{key:`mob-${ind}`,staticClass:"cal-carousel-footer-mobile"},[_c('button',{staticClass:"cal-carousel-footer-btn",class:[
          ind === _vm.activeMobindex
            ? 'cal-carousel-footer-btn-primary'
            : 'cal-carousel-footer-btn-secondary',
        ],on:{"click":function($event){return _vm.changeActiveIndex('mob', ind)}}})])}),_vm._l((_vm.tabSlideset),function(sl,ind){return _c('div',{key:`tab-${ind}`,staticClass:"cal-carousel-footer-tab"},[_c('button',{staticClass:"cal-carousel-footer-btn",class:[
          ind === _vm.activeTabindex
            ? 'cal-carousel-footer-btn-primary'
            : 'cal-carousel-footer-btn-secondary',
        ],on:{"click":function($event){return _vm.changeActiveIndex('tab', ind)}}})])}),_vm._l((_vm.baseSlideset),function(sl,ind){return _c('div',{key:`base-${ind}`,staticClass:"cal-carousel-footer-web"},[_c('button',{staticClass:"cal-carousel-footer-btn",class:[
          ind === _vm.activeBaseindex
            ? 'cal-carousel-footer-btn-primary'
            : 'cal-carousel-footer-btn-secondary',
        ],on:{"click":function($event){return _vm.changeActiveIndex('web', ind)}}})])})],2)])
}
var cal_card_carouselvue_type_template_id_12b090c4_staticRenderFns = []


// CONCATENATED MODULE: ./src/vue-components/carousel/cal-card-carousel.vue?vue&type=template&id=12b090c4

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/vue-components/carousel/cal-card-carousel.vue?vue&type=script&lang=js

/* harmony default export */ var cal_card_carouselvue_type_script_lang_js = ({
  name: "cal-card-carousel",
  props: {
    slides: {
      default: [],
      type: Array,
    },
    slider: {
      default: "review-card",
      type: String,
    },
    altText: {
      default: "Alternative card image",
      type: String,
    },
  },
  data() {
    return {
      activeBaseindex: 0,
      activeMobindex: 0,
      activeTabindex: 0,
    };
  },
  created() {
    this.initSlideset();
  },
  methods: {
    initSlideset() {
      this.baseSlideset = [];
      this.tabSlideset = [];
      this.mobSlideset = [];

      for (let i = 0; i < this.slides.length; i += 1) {
        this.mobSlideset.push(this.slides[i]);
      }
      for (let i = 0; i < this.slides.length; i += 2) {
        this.tabSlideset.push(this.slides.slice(i, i + 2));
      }
      for (let i = 0; i < this.slides.length; i += 3) {
        this.baseSlideset.push(this.slides.slice(i, i + 3));
      }
    },
    changeActiveIndex(type, index) {
      type === "mob"
        ? (this.activeMobindex = index)
        : type === "tab"
        ? (this.activeTabindex = index)
        : (this.activeBaseindex = index);
    },
    next(reset = false) {
      const first = this.slides.shift();
      this.slides = this.slides.concat(first);
    },
    previous(reset = false) {
      const last = this.slides.pop();
      this.slides = [last].concat(this.slides);
    },
  },
});

// CONCATENATED MODULE: ./src/vue-components/carousel/cal-card-carousel.vue?vue&type=script&lang=js
 /* harmony default export */ var carousel_cal_card_carouselvue_type_script_lang_js = (cal_card_carouselvue_type_script_lang_js); 
// CONCATENATED MODULE: ./src/vue-components/carousel/cal-card-carousel.vue





/* normalize component */

var cal_card_carousel_component = normalizeComponent(
  carousel_cal_card_carouselvue_type_script_lang_js,
  cal_card_carouselvue_type_template_id_12b090c4_render,
  cal_card_carouselvue_type_template_id_12b090c4_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var cal_card_carousel = (cal_card_carousel_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"9d9ca11a-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/vue-components/carousel/cal-review-card.vue?vue&type=template&id=80e252ec
var cal_review_cardvue_type_template_id_80e252ec_render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cal-review-card"},[_c('div',{staticClass:"cal-review-card-wrapper"},[_c('cal-img',{attrs:{"src":_vm.slide['img'],"alt":_vm.altText,"customClass":"cal-review-card-img","width":_vm.width,"height":_vm.height}})],1),_c('div',{staticClass:"cal-review-card-content"},[_c('div',{staticClass:"cal-review-card-content-name"},[_vm._v(_vm._s(_vm.slide["name"]))]),_c('div',{staticClass:"cal-review-card-content-city"},[_vm._v(_vm._s(_vm.slide["city"]))]),_c('div',{staticClass:"cal-review-card-content-text",domProps:{"innerHTML":_vm._s(_vm.slide['content'])}})])])
}
var cal_review_cardvue_type_template_id_80e252ec_staticRenderFns = []


// CONCATENATED MODULE: ./src/vue-components/carousel/cal-review-card.vue?vue&type=template&id=80e252ec

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/vue-components/carousel/cal-review-card.vue?vue&type=script&lang=js



/* harmony default export */ var cal_review_cardvue_type_script_lang_js = ({
  name: "cal-review-card",
  components: {
    CalImg: Cal_Img,
  },
  props: {
    slide: {
      default: {},
      type: Object,
    },
    altText: {
      default: "Alternative review image",
      type: String,
    },
    width: {
      type: Number,
    },
    height: {
      type: Number,
    },
  },
});

// CONCATENATED MODULE: ./src/vue-components/carousel/cal-review-card.vue?vue&type=script&lang=js
 /* harmony default export */ var carousel_cal_review_cardvue_type_script_lang_js = (cal_review_cardvue_type_script_lang_js); 
// CONCATENATED MODULE: ./src/vue-components/carousel/cal-review-card.vue





/* normalize component */

var cal_review_card_component = normalizeComponent(
  carousel_cal_review_cardvue_type_script_lang_js,
  cal_review_cardvue_type_template_id_80e252ec_render,
  cal_review_cardvue_type_template_id_80e252ec_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var cal_review_card = (cal_review_card_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"9d9ca11a-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/vue-components/carousel/cal-slide-card.vue?vue&type=template&id=69e1911e
var cal_slide_cardvue_type_template_id_69e1911e_render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cal-slide-card"},[_c('cal-img',{attrs:{"src":_vm.slide['img'],"alt":_vm.slide['image_alt'],"customClass":"cal-slide-card-img","width":_vm.width,"height":_vm.height}}),_c('div',{staticClass:"cal-slide-card-content"},[_c('a',{attrs:{"href":_vm.slide['link'],"target":"_blank"}},[_vm._v(" "+_vm._s(_vm.slide["name"])+" ")])])],1)
}
var cal_slide_cardvue_type_template_id_69e1911e_staticRenderFns = []


// CONCATENATED MODULE: ./src/vue-components/carousel/cal-slide-card.vue?vue&type=template&id=69e1911e

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/vue-components/carousel/cal-slide-card.vue?vue&type=script&lang=js



/* harmony default export */ var cal_slide_cardvue_type_script_lang_js = ({
  name: "cal-slide-card",
  components: {
    CalImg: Cal_Img,
  },
  props: {
    slide: {
      default: {},
      type: Object,
    },
    altText: {
      default: "Alternative slide image",
      type: String,
    },
    width: {
      type: Number,
    },
    height: {
      type: Number,
    },
  },
});

// CONCATENATED MODULE: ./src/vue-components/carousel/cal-slide-card.vue?vue&type=script&lang=js
 /* harmony default export */ var carousel_cal_slide_cardvue_type_script_lang_js = (cal_slide_cardvue_type_script_lang_js); 
// CONCATENATED MODULE: ./src/vue-components/carousel/cal-slide-card.vue





/* normalize component */

var cal_slide_card_component = normalizeComponent(
  carousel_cal_slide_cardvue_type_script_lang_js,
  cal_slide_cardvue_type_template_id_69e1911e_render,
  cal_slide_cardvue_type_template_id_69e1911e_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var cal_slide_card = (cal_slide_card_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"9d9ca11a-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/vue-components/product-tile/Product-Tile.vue?vue&type=template&id=e74a99ca
var Product_Tilevue_type_template_id_e74a99ca_render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cal-product-tile",attrs:{"id":_vm.id ? _vm.id : _vm.product.title}},[_c('div',{staticClass:"cal-product-tile-header",on:{"click":function($event){return _vm.selectProduct()}}},[(_vm.product.badge && _vm.product.badge !== '')?_c('div',{staticClass:"cal-product-tile-badge"},[_vm._v(" "+_vm._s(_vm.product.badge)+" ")]):_vm._e(),_c('cal-img',{attrs:{"src":_vm.product.displayImgIndex ? _vm.product.images[_vm.product.displayImgIndex] : _vm.product.images[0],"alt":_vm.product.displayTitle,"customClass":_vm.product.images.length > 1
          ? 'cal-product-tile-img cal-product-tile-img-with-hover'
          : 'cal-product-tile-img',"width":_vm.width,"height":_vm.height}}),(_vm.product.images.length > 1)?_c('cal-img',{attrs:{"src":_vm.product.hoverImgIndex ? _vm.product.images[_vm.product.hoverImgIndex] : _vm.product.images[0],"alt":_vm.product.displayTitle,"customClass":"cal-product-tile-img cal-product-tile-img-overright","width":_vm.width,"height":_vm.height}}):_vm._e(),(!_vm.hideQuickView)?_c('div',{staticClass:"cal-product-tile-quickview-wrapper"},[_c('button',{staticClass:"cal-product-tile-quickview-wrapper-btn",on:{"click":function($event){return _vm.toggleQuickView($event)}}},[_vm._v(" Quick View ")]),_c('Modal',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],on:{"close-modal":function($event){_vm.show = false}}},[_c('Quickview',{attrs:{"product":_vm.product,"headerTexts":_vm.headerTexts}})],1)],1):_vm._e()],1),_c('h3',{staticClass:"cal-product-tile-title",domProps:{"innerHTML":_vm._s(_vm.product.displayTitle)},on:{"click":_vm.selectProduct}}),(_vm.para)?_c('div',{staticClass:"cal-product-tile-para"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.para)}})]):_vm._e(),_c('div',{class:_vm.product.useAltPriceText
        ? 'cal-product-tile-alt-text-wrapper'
        : 'cal-product-tile-bottom-wrapper'},[(_vm.product.useAltPriceText)?_c('div',{staticClass:"cal-product-tile-variant-price-summary",domProps:{"innerHTML":_vm._s(_vm.product.priceText)}}):(_vm.startingPrice && _vm.availableProducts.length > 1)?_c('div',{staticClass:"cal-product-tile-variant-price-summary"},[_c('div',{staticClass:"cal-product-tile-variant-price-item"},[_c('p',{staticClass:"cal-product-tile-price cal-product-tile-price-starting"},[_vm._v(" "+_vm._s(_vm.startingPrice)+" ")]),_c('p',{staticClass:"cal-product-tile-price",class:{
            'cal-product-tile-price-has-sale': _vm.availableProducts[0].itemSalesPrice !== undefined,
          }},[_vm._v(" "+_vm._s(_vm.availableProducts[0].itemPrice)+" ")]),(_vm.availableProducts[0].itemSalesPrice !== undefined)?_c('p',{staticClass:"cal-product-tile-sale-price"},[_vm._v(" "+_vm._s(_vm.availableProducts[0].itemSalesPrice)+" ")]):_vm._e()])]):_c('div',{staticClass:"cal-product-tile-variant-price-summary"},_vm._l((_vm.availableProducts),function(variant,i){return _c('div',{key:i,staticClass:"cal-product-tile-variant-price-item"},[_c('p',{staticClass:"cal-product-tile-price",class:{
            'cal-product-tile-price-has-sale': variant.itemSalesPrice !== undefined,
          }},[_vm._v(" "+_vm._s(variant.itemPrice)+" ")]),(variant.itemSalesPrice !== undefined)?_c('p',{staticClass:"cal-product-tile-sale-price"},[_vm._v(" "+_vm._s(variant.itemSalesPrice)+" ")]):_vm._e(),(i !== _vm.availableProducts.length - 1)?_c('p',{staticClass:"cal-product-tile-variant-separator"},[_vm._v(" | ")]):_vm._e()])}),0)]),(_vm.product.topBadge && _vm.product.topBadge !== '')?_c('MarketingBadge',{attrs:{"badgeText":_vm.product.topBadge}}):_vm._e()],1)
}
var Product_Tilevue_type_template_id_e74a99ca_staticRenderFns = []


// CONCATENATED MODULE: ./src/vue-components/product-tile/Product-Tile.vue?vue&type=template&id=e74a99ca

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"9d9ca11a-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/vue-components/product-tile/Quickview.vue?vue&type=template&id=20e6664c
var Quickviewvue_type_template_id_20e6664c_render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cal-quickview"},[_c('div',{staticClass:"cal-quickview-header"},[_c('cal-img',{attrs:{"src":_vm.product.images[0],"alt":_vm.product.image_alt,"customClass":"cal-quickview-img","width":_vm.width,"height":_vm.height}})],1),_c('div',{staticClass:"cal-quickview-body"},[_c('div',{staticClass:"cal-quickview-title"},[_vm._v(" "+_vm._s(_vm.product.displayTitle)+" ")]),_c('div',{staticClass:"cal-quickview-description"},[_vm._v(" "+_vm._s(_vm.product.short_description)+" ")]),_c('div',{staticClass:"cal-quickview-variants"},_vm._l((_vm.product.variants),function(variant,i){return _c('button',{key:i,class:!(_vm.product.variants.length === 1 || _vm.selectedIndex === i)
            ? 'cal-quickview-variant '
            : 'cal-quickview-variant cal-quickview-variant-select',on:{"click":function($event){return _vm.selectVariant(i)}}},[_c('div',{staticClass:"cal-quickview-variant-title"},[_vm._v(" "+_vm._s(variant.displayTitle)+" ")]),_c('div',{staticClass:"cal-quickview-variant-bottom"},[_c('div',{staticClass:"cal-quickview-variant-info"},[_vm._v(" "+_vm._s(variant.bqSizeTag)+" ")]),_c('div',{staticClass:"cal-quickview-variant-price"},[_c('div',{staticClass:"cal-product-tile-variants-wrapper"},[_c('span',{staticClass:"cal-product-tile-price",class:variant.itemSalesPrice !== undefined ? 'cal-product-tile-price-has-sale' : ''},[_vm._v(" "+_vm._s(variant.itemPrice)+" ")]),(variant.itemSalesPrice !== undefined)?_c('span',{staticClass:"cal-product-tile-sale-price"},[_vm._v(" "+_vm._s(variant.itemSalesPrice)+" ")]):_vm._e()])])])])}),0),(_vm.headerTexts && _vm.headerTexts.btnText)?_c('Button',{staticClass:"cal-quickview-primary-button",attrs:{"disabled":!(_vm.selectedIndex >= 0 || _vm.product.variants.length === 1),"btnText":_vm.headerTexts && _vm.headerTexts.btnText ? _vm.headerTexts.btnText : '',"curved":true},on:{"click":function($event){return _vm.addTobasket(_vm.variant)}}}):_vm._e(),(_vm.headerTexts && _vm.headerTexts.viewFullDetails)?_c('button',{staticClass:"cal-quickview-secondary-button",on:{"click":function($event){return _vm.selectProductDetails()}}},[_vm._v(" "+_vm._s(_vm.headerTexts.viewFullDetails)+" ")]):_vm._e()],1)])
}
var Quickviewvue_type_template_id_20e6664c_staticRenderFns = []


// CONCATENATED MODULE: ./src/vue-components/product-tile/Quickview.vue?vue&type=template&id=20e6664c

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/vue-components/product-tile/Quickview.vue?vue&type=script&lang=js




/* harmony default export */ var Quickviewvue_type_script_lang_js = ({
  name: "cal-quickview",
  components: {
    Button: Button,
    CalImg: Cal_Img,
  },
  props: ["product", "headerTexts", "width", "height"],
  data() {
    return {
      selectedIndex: -1,
    };
  },
  methods: {
    selectProductDetails() {
      this.$emit("close-modal");
      this.$emit("product-select", this.product);
    },
    selectVariant(index) {
      this.selectedIndex = index;
    },
    addTobasket(variant) {
      this.$emit("close-modal");
      this.$emit("add-to-basket", variant);
    },
  },
});

// CONCATENATED MODULE: ./src/vue-components/product-tile/Quickview.vue?vue&type=script&lang=js
 /* harmony default export */ var product_tile_Quickviewvue_type_script_lang_js = (Quickviewvue_type_script_lang_js); 
// CONCATENATED MODULE: ./src/vue-components/product-tile/Quickview.vue





/* normalize component */

var Quickview_component = normalizeComponent(
  product_tile_Quickviewvue_type_script_lang_js,
  Quickviewvue_type_template_id_20e6664c_render,
  Quickviewvue_type_template_id_20e6664c_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var Quickview = (Quickview_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/vue-components/product-tile/Product-Tile.vue?vue&type=script&lang=js





/* harmony default export */ var Product_Tilevue_type_script_lang_js = ({
  name: "cal-product-tile",
  components: {
    Modal: Modal,
    Quickview: Quickview,
    CalImg: Cal_Img,
  },
  props: [
    "product",
    "hideQuickView",
    "headerTexts",
    "showUnavailable",
    "id",
    "startingPrice",
    "para",
    "width",
    "height",
  ],
  data() {
    return {
      show: false,
    };
  },
  computed: {
    availableProducts() {
      return this.showUnavailable
        ? this.product.variants
        : this.product.variants.filter((product) => product.availableForSale);
    },
  },
  methods: {
    toggleQuickView(event) {
      this.show = !this.show;
      event.stopPropagation();
    },
    selectProduct() {
      this.$emit("product-description", this.product);
    },
  },
});

// CONCATENATED MODULE: ./src/vue-components/product-tile/Product-Tile.vue?vue&type=script&lang=js
 /* harmony default export */ var product_tile_Product_Tilevue_type_script_lang_js = (Product_Tilevue_type_script_lang_js); 
// CONCATENATED MODULE: ./src/vue-components/product-tile/Product-Tile.vue





/* normalize component */

var Product_Tile_component = normalizeComponent(
  product_tile_Product_Tilevue_type_script_lang_js,
  Product_Tilevue_type_template_id_e74a99ca_render,
  Product_Tilevue_type_template_id_e74a99ca_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var Product_Tile = (Product_Tile_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"9d9ca11a-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/vue-components/product-tile/Product-Tile-V2.vue?vue&type=template&id=fb88c7ea
var Product_Tile_V2vue_type_template_id_fb88c7ea_render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cal-product-tile-v2",attrs:{"id":_vm.id ? _vm.id : _vm.product.title}},[_c('div',{staticClass:"cal-product-tile-v2-header",on:{"click":function($event){return _vm.selectProduct()}}},[(_vm.product.badge && _vm.product.badge !== '')?_c('div',{staticClass:"cal-product-tile-v2-badge"},[_vm._v(" "+_vm._s(_vm.product.badge)+" ")]):_vm._e(),_c('cal-img',{attrs:{"src":_vm.product.displayImgIndex ? _vm.product.images[_vm.product.displayImgIndex] : _vm.product.images[0],"alt":_vm.product.displayTitle,"customClass":_vm.product.images.length > 1
          ? 'cal-product-tile-v2-img cal-product-tile-v2-img-with-hover'
          : 'cal-product-tile-v2-img',"width":_vm.width,"height":_vm.height}}),(_vm.product.images.length > 1)?_c('cal-img',{attrs:{"src":_vm.product.hoverImgIndex ? _vm.product.images[_vm.product.hoverImgIndex] : _vm.product.images[0],"alt":_vm.product.displayTitle,"customClass":"cal-product-tile-v2-img cal-product-tile-v2-img-overright","width":_vm.width,"height":_vm.height}}):_vm._e(),(!_vm.hideQuickView)?_c('div',{staticClass:"cal-product-tile-v2-quickview-wrapper"},[_c('button',{staticClass:"cal-product-tile-v2-quickview-wrapper-btn",on:{"click":function($event){return _vm.toggleQuickView($event)}}},[_vm._v(" Quick View ")]),_c('Modal',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],on:{"close-modal":function($event){_vm.show = false}}},[_c('Quickview',{attrs:{"product":_vm.product,"headerTexts":_vm.headerTexts}})],1)],1):_vm._e()],1),_c('div',{staticClass:"cal-product-tile-v2-container",style:({ padding: _vm.padding ? _vm.padding : '0' })},[_c('div',{staticClass:"cal-product-tile-v2-content",class:_vm.contentHeight},[_c('div',{staticClass:"flex w-full items-start",class:_vm.isMobile ? 'flex-col justify-start' : 'justify-between'},[_c('h3',{staticClass:"cal-product-tile-v2-title",domProps:{"innerHTML":_vm._s(_vm.product.displayTitle)},on:{"click":_vm.selectProduct}}),(!_vm.hideRating)?_c('div',{staticClass:"flex items-center",class:_vm.isMobile ? 'mr-2' : 'ml-2'},[_c('div',{staticClass:"flex items-center"},_vm._l((5),function(i){return _c('span',{key:i,staticClass:"relative mr-[2px] text-[0.85rem] sm:text-[1.1rem]",style:(_vm.getStarStyle(i))},[_c('i',{staticClass:"fa-solid fa-star w-[0.85rem] sm:w-[1.1rem] text-xs sm:text-sm"})])}),0),(_vm.product && _vm.product.rating && _vm.product.rating > 0)?_c('div',{staticClass:"font-family open-sans text-primary !text-[13px] sm:!text-[15px]",staticStyle:{"margin-top":"0.1rem","margin-left":"0.25rem"}},[_vm._v(" "+_vm._s(_vm.product.rating)+" ")]):_vm._e()]):_vm._e()]),(_vm.product && _vm.product.hereUntilText)?_c('div',{staticClass:"w-full",class:_vm.isMobile ? 'mt-2' : 'mt-1'},[_c('div',{staticClass:"cal-product-tile-v2-para !text-[11px] sm:!text-[12px]"},[_vm._v(" "+_vm._s(_vm.product.hereUntilText)+" ")])]):_vm._e(),_c('hr',{staticClass:"w-full",staticStyle:{"margin-top":"0.25rem","margin-bottom":"0.5rem"}}),(_vm.showVariants)?_c('div',{staticClass:"w-full"},[_c('div',{staticClass:"cal-product-tile-v2-close-button-container"},[_c('button',{staticClass:"cal-product-tile-v2-close-button",on:{"click":_vm.close}},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":_vm.isMobile ? '1em' : '1.25em',"height":_vm.isMobile ? '1em' : '1.25em',"viewBox":"0 0 24 24","fill":"none","stroke":"currentColor","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round","aria-hidden":"true"}},[_c('path',{attrs:{"stroke-linecap":"round","stroke-linejoin":"round","d":"M6 18L18 6M6 6l12 12"}})])])]),_c('div',{staticClass:"cal-product-tile-v2-variant-buttons pb-3",class:{ 'grid-cols-2': _vm.isMobile, 'grid-cols-2': !_vm.isMobile }},_vm._l((_vm.availableProducts),function(variant,i){return _c('div',{key:i,staticClass:"w-full",class:[
              (variant.displayTitle && variant.displayTitle.length >= _vm.maxCharPerVariant) ||
              (i === _vm.availableProducts.length - 1 && _vm.availableProducts.length % 2 !== 0)
                ? 'col-span-2'
                : 'col-span-1',
            ]},[_c('button',{staticClass:"cal-product-tile-v2-button",class:_vm.selectedVariant && _vm.selectedVariant.displayTitle == variant.displayTitle
                  ? ''
                  : 'cal-product-tile-v2-button-clear',staticStyle:{"width":"100% !important"},on:{"click":function($event){return _vm.selectVariant(variant)}}},[_vm._v(" "+_vm._s(variant.displayTitle)+" ")])])}),0)]):_vm._e(),_c('div',{staticClass:"flex grow items-end w-full"},[_c('div',{staticClass:"flex items-center w-full justify-between"},[(_vm.availableProducts.length > 0)?_c('div',{staticClass:"cal-product-tile-v2-variant-price-summary mb-0 sm:mb-1"},[_c('div',{staticClass:"cal-product-tile-v2-variant-price-item"},[(_vm.selectedVariant == null)?_c('p',{staticClass:"cal-product-tile-v2-price cal-product-tile-v2-price-starting"},[_vm._v(" "+_vm._s(_vm.getStartingPrice())+" ")]):_c('div',{staticClass:"flex"},[_c('p',{staticClass:"cal-product-tile-v2-price",class:{
                    'cal-product-tile-v2-price-has-sale':
                      _vm.selectedVariant.itemSalesPrice !== undefined,
                  }},[_vm._v(" "+_vm._s(_vm.selectedVariant.itemPrice)+" ")]),(_vm.selectedVariant.itemSalesPrice !== undefined)?_c('p',{staticClass:"cal-product-tile-v2-sale-price"},[_vm._v(" "+_vm._s(_vm.selectedVariant.itemSalesPrice)+" ")]):_vm._e()])])]):_vm._e(),(!_vm.showVariants)?_c('button',{staticClass:"cal-product-tile-v2-button",staticStyle:{"padding-left":"0.5rem !important","padding-right":"0.5rem !important"},on:{"click":_vm.open}},[_vm._v(" "+_vm._s("Add")+" ")]):_c('button',{staticClass:"cal-product-tile-v2-button",class:{
              'cal-product-tile-v2-button-disabled': _vm.selectedVariant == null,
            },staticStyle:{"padding-left":"0.5rem !important","padding-right":"0.5rem !important"},attrs:{"disabled":_vm.selectedVariant == null},on:{"click":_vm.addToBasket}},[_vm._v(" "+_vm._s(_vm.selectedVariant == null ? _vm.locale == "fr-ca" ? "Taille" : "Select size" : _vm.locale == "fr-ca" ? "Ajouter" : "Add to basket")+" ")])])])])]),(_vm.product.topBadge && _vm.product.topBadge !== '')?_c('MarketingBadge',{attrs:{"badgeText":_vm.product.topBadge}}):_vm._e()],1)
}
var Product_Tile_V2vue_type_template_id_fb88c7ea_staticRenderFns = []


// CONCATENATED MODULE: ./src/vue-components/product-tile/Product-Tile-V2.vue?vue&type=template&id=fb88c7ea

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/vue-components/product-tile/Product-Tile-V2.vue?vue&type=script&lang=js






/* harmony default export */ var Product_Tile_V2vue_type_script_lang_js = ({
  name: "cal-product-tile-v2",
  components: {
    Modal: Modal,
    Quickview: Quickview,
    CalImg: Cal_Img,
    Button: Button,
  },
  props: [
    "product",
    "hideQuickView",
    "headerTexts",
    "showUnavailable",
    "id",
    "startingPrice",
    "width",
    "height",
    "variantCols",
    "padding",
    "contentHeight",
    "locale",
    "skipVariantSelection",
    "hideRating",
  ],
  data() {
    return {
      show: false,
      numberOfStars: 5,
      selectedVariant: null,
      showVariants: false,
    };
  },
  computed: {
    availableProducts() {
      return this.showUnavailable
        ? this.product.variants
        : this.product.variants.filter((product) => product.availableForSale);
    },
    isMobile() {
      return window.matchMedia("(max-width: 768px)").matches;
    },
  },
  methods: {
    getStarStyle(index) {
      const rating =
        this.product && this.product.rating && this.product.rating > 0 ? this.product.rating : 5;
      const starValue = index - 1;
      const fill = Math.min(Math.max((rating - starValue) * 100, 0), 100);

      return {
        background: `linear-gradient(90deg, #0A9EA5 ${fill}%, #e5e5e5 ${fill}%)`,
        WebkitBackgroundClip: "text",
        WebkitTextFillColor: "transparent",
        display: "inline-block",
      };
    },
    close() {
      this.$emit("show-variants", false);
      this.showVariants = false;
      this.selectedVariant = null;
    },
    open() {
      if (this.skipVariantSelection) {
        this.selectedVariant = this.availableProducts[0];
        this.addToBasket();
      } else {
        this.$emit("show-variants", true);
        this.showVariants = true;
      }
    },
    toggleQuickView(event) {
      this.show = !this.show;
      event.stopPropagation();
    },
    selectVariant(variant) {
      this.selectedVariant = variant;
    },
    getStartingPrice() {
      if (this.availableProducts.length == 0) {
        return "";
      }

      if (this.locale == "fr-ca") {
        return "À partir de " + this.findLowestPrice();
      } else {
        return "Starting at " + this.findLowestPrice();
      }
    },
    findLowestPrice() {
      if (this.availableProducts.length === 0) {
        return "";
      }

      const parsePrice = (priceStr) => {
        if (!priceStr) return Infinity;
        return parseFloat(priceStr.replace(/[^0-9.]/g, ""));
      };

      let lowestPriceProd = this.availableProducts[0];
      for (let i = 1; i < this.availableProducts.length; i++) {
        const currentPrice = parsePrice(this.availableProducts[i].itemPrice);
        const lowestPrice = parsePrice(lowestPriceProd.itemPrice);

        if (currentPrice < lowestPrice) {
          lowestPriceProd = this.availableProducts[i];
        }
      }

      const finalPrice = lowestPriceProd.itemSalesPrice || lowestPriceProd.itemPrice;
      return finalPrice;
    },
    addToBasket() {
      this.$emit("add-to-basket", this.product, this.selectedVariant);
    },
    selectProduct() {
      this.$emit("product-description", this.product);
    },
  },
});

// CONCATENATED MODULE: ./src/vue-components/product-tile/Product-Tile-V2.vue?vue&type=script&lang=js
 /* harmony default export */ var product_tile_Product_Tile_V2vue_type_script_lang_js = (Product_Tile_V2vue_type_script_lang_js); 
// CONCATENATED MODULE: ./src/vue-components/product-tile/Product-Tile-V2.vue





/* normalize component */

var Product_Tile_V2_component = normalizeComponent(
  product_tile_Product_Tile_V2vue_type_script_lang_js,
  Product_Tile_V2vue_type_template_id_fb88c7ea_render,
  Product_Tile_V2vue_type_template_id_fb88c7ea_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var Product_Tile_V2 = (Product_Tile_V2_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"9d9ca11a-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/vue-components/add-on/Add-On.vue?vue&type=template&id=963deaa2
var Add_Onvue_type_template_id_963deaa2_render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cal-add-on",class:{ 'cal-add-on-selected': _vm.selected || _vm.quantity > 0 },attrs:{"id":_vm.id},on:{"click":_vm.selectAddon}},[_c('cal-img',{attrs:{"src":_vm.image,"alt":_vm.imageAlt,"customClass":"cal-add-on-img","width":_vm.width,"height":_vm.height}}),_c('div',{staticClass:"cal-add-on-title"},[_c('h3',[_vm._v(_vm._s(_vm.title))])]),_c('div',{staticClass:"cal-add-on-price-wrapper"},[(_vm.salePrice !== undefined)?_c('span',{staticClass:"cal-add-on-sale-price"},[_vm._v(" "+_vm._s(_vm.salePrice)+" ")]):_vm._e(),_c('span',{staticClass:"cal-add-on-price",class:{ 'cal-add-on-has-sale': _vm.salePrice !== undefined }},[_vm._v(" "+_vm._s(_vm.price)+" ")])]),(_vm.hasSlot('read-more'))?_c('button',{staticClass:"cal-add-on-read-more",attrs:{"id":`${_vm.id}_read_more`},on:{"click":_vm.handleReadMoreClick}},[_vm._v(" "+_vm._s(_vm.readmore)+" ")]):_vm._e(),(_vm.useQuantitySelector)?_c('div',{staticClass:"cal-add-on-quantity-selector"},[_c('div',{staticClass:"cal-add-on-quantity-selector-wrapper"},[_c('div',{staticClass:"cal-add-on-quantity-selector-decrement-button"},[_c('button',{attrs:{"disabled":_vm.quantity <= 0,"id":`${_vm.id}_decrement`},on:{"click":function($event){return _vm.decrementQuantity($event)}}},[_vm._v(" - ")])]),_c('div',{staticClass:"cal-add-on-quantity-selector-input"},[_c('input',{attrs:{"id":`${_vm.id}_input_qty`,"type":"number"},domProps:{"value":_vm.quantity},on:{"input":(event) => _vm.updateQuantity(event.target.value)}})]),_c('div',{staticClass:"cal-add-on-quantity-selector-decrement-button"},[_c('button',{attrs:{"disabled":_vm.quantity >= 10,"id":`${_vm.id}_increment`},on:{"click":function($event){return _vm.incrementQuantity($event)}}},[_vm._v(" + ")])])])]):_vm._e(),(_vm.badge !== undefined && _vm.badge.length > 0)?_c('div',{staticClass:"cal-add-on-badge"},[_c('span',{staticClass:"cal-add-on-badge-s2"}),_c('span',{staticClass:"cal-add-on-badge-s1"}),_c('div',{staticClass:"cal-add-on-badge-bottom"}),_vm._v(" "+_vm._s(_vm.badge)+" ")]):_vm._e()],1)
}
var Add_Onvue_type_template_id_963deaa2_staticRenderFns = []


// CONCATENATED MODULE: ./src/vue-components/add-on/Add-On.vue?vue&type=template&id=963deaa2

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/vue-components/add-on/Add-On.vue?vue&type=script&lang=js




/* harmony default export */ var Add_Onvue_type_script_lang_js = ({
  name: "cal-add-on",
  components: {
    Modal: Modal,
    CalImg: Cal_Img,
  },
  props: {
    index: {
      type: Number,
      required: false,
    },
    image: {
      type: String,
      required: true,
    },
    imageAlt: {
      type: String,
    },
    title: {
      type: String,
      required: true,
    },
    price: {
      type: String,
      required: true,
    },
    salePrice: {
      type: String,
    },
    badge: {
      type: String,
    },
    readmore: {
      type: String,
    },
    useQuantitySelector: {
      type: Boolean,
      default: false,
    },
    addOnSelected: {
      type: [],
    },
    maxQuantity: {
      type: Number,
      default: 10,
    },
    addOnData: {
      type: Object,
      required: true,
    },
    id: {
      type: String,
    },
    productType: {
      type: String,
    },
    width: {
      type: Number,
    },
    height: {
      type: Number,
    },
  },
  data() {
    return {
      quantity: 0,
      showReadMore: false,
      selected: false,
    };
  },
  computed: {
    selectedAddons() {
      return this.addOnSelected;
    },
  },
  watch: {
    quantity() {
      if (this.productType !== "Vase") {
        this.$emit("updateQuantity", {
          quantity: this.quantity,
          title: this.title,
          index: this.index,
          addon: this.addOnData,
        });
      }
    },
    selectedAddons() {
      if (this.selectedAddons) {
        const enable = Object.values(this.selectedAddons).filter((item) => {
          return item.addon && item.addon.id === this.addOnData.id;
        });
        if (enable.length !== 0 && enable[0].addon.id) {
          this.selected = true;
          this.quantity = enable[0].quantity;
        } else {
          this.selected = false;
          this.quantity = 0;
        }
      }
    },
  },
  methods: {
    decrementQuantity(event) {
      event.stopPropagation();
      if (this.quantity > 0) {
        this.quantity--;
      }
    },
    incrementQuantity(event) {
      event.stopPropagation();
      if (this.quantity < this.maxQuantity) {
        this.quantity++;
      }
    },
    updateQuantity(value) {
      const num = parseInt(value);
      if (num > this.maxQuantity) {
        this.quantity = this.maxQuantity;
      } else if (num < 0) {
        this.quantity = 0;
      } else {
        this.quantity = num;
      }

      if (this.productType === "Vase") {
        this.$emit("updateQuantity", {
          quantity: this.quantity,
          title: this.title,
          index: this.index,
          addon: this.addOnData,
        });
      }
      this.$forceUpdate();
    },
    selectAddon() {
      if (this.useQuantitySelector) return;

      if (this.selected) {
        this.selected = false;
        this.updateQuantity(0);
      } else {
        this.selected = true;
        this.updateQuantity(1);
      }
    },
    handleReadMoreClick(event) {
      event.stopPropagation();
      this.showReadMore = !this.showReadMore;
      this.$emit("openReadMore", this.addOnData);
    },
    hasSlot(name = "default") {
      return !!this.$slots[name] || !!this.$scopedSlots[name];
    },
  },
});

// CONCATENATED MODULE: ./src/vue-components/add-on/Add-On.vue?vue&type=script&lang=js
 /* harmony default export */ var add_on_Add_Onvue_type_script_lang_js = (Add_Onvue_type_script_lang_js); 
// CONCATENATED MODULE: ./src/vue-components/add-on/Add-On.vue





/* normalize component */

var Add_On_component = normalizeComponent(
  add_on_Add_Onvue_type_script_lang_js,
  Add_Onvue_type_template_id_963deaa2_render,
  Add_Onvue_type_template_id_963deaa2_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var Add_On = (Add_On_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"9d9ca11a-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/vue-components/slide-over/Slide-Over.vue?vue&type=template&id=ba6b7cd4
var Slide_Overvue_type_template_id_ba6b7cd4_render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cal-slide-over"},[_c('Transition',{attrs:{"name":"cal-slide-over-overlay"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"cal-slide-over-overlay",on:{"click":_vm.close}})]),_c('Transition',{attrs:{"name":"cal-slide-over-panel"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],class:_vm.sliderSize === '1/1'
          ? 'cal-slide-over-panel-full'
          : _vm.sliderSize === '1/4'
          ? 'cal-slide-over-panel-quater'
          : _vm.sliderSize === '3/4'
          ? 'cal-slide-over-panel-three-quater'
          : 'cal-slide-over-panel'},[_c('section',{staticClass:"cal-slide-over-header"},[_vm._t("header"),_c('button',{staticClass:"cal-slide-over-close-button",on:{"click":_vm.close}},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":_vm.isMobile ? '1.05em' : '1.5em',"height":_vm.isMobile ? '1.05em' : '1.5em',"viewBox":"0 0 24 24","fill":"none","stroke":"currentColor","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round","aria-hidden":"true"}},[_c('path',{attrs:{"stroke-linecap":"round","stroke-linejoin":"round","d":"M6 18L18 6M6 6l12 12"}})])])],2),_vm._t("content")],2)])],1)
}
var Slide_Overvue_type_template_id_ba6b7cd4_staticRenderFns = []


// CONCATENATED MODULE: ./src/vue-components/slide-over/Slide-Over.vue?vue&type=template&id=ba6b7cd4

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/vue-components/slide-over/Slide-Over.vue?vue&type=script&lang=js

/* harmony default export */ var Slide_Overvue_type_script_lang_js = ({
  name: "cal-slide-over",
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    sliderSize: {
      type: String,
      default: "1/2",
    },
  },
  emits: ["close"],
  watch: {
    show(newVal, oldVal) {
      let element = document.getElementsByTagName("body")[0];
      if (this.show) {
        element.style.overflow = "hidden";
      } else {
        element.style.overflow = "auto";
      }
    },
  },
  methods: {
    close() {
      this.$emit("close");
    },
  },
  computed: {
    sizeVars() {
      return {
        "--slide-over-width": this.sliderSize,
      };
    },
    isMobile() {
      return window.matchMedia("(max-width: 768px)").matches;
    },
  },
});

// CONCATENATED MODULE: ./src/vue-components/slide-over/Slide-Over.vue?vue&type=script&lang=js
 /* harmony default export */ var slide_over_Slide_Overvue_type_script_lang_js = (Slide_Overvue_type_script_lang_js); 
// CONCATENATED MODULE: ./src/vue-components/slide-over/Slide-Over.vue





/* normalize component */

var Slide_Over_component = normalizeComponent(
  slide_over_Slide_Overvue_type_script_lang_js,
  Slide_Overvue_type_template_id_ba6b7cd4_render,
  Slide_Overvue_type_template_id_ba6b7cd4_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var Slide_Over = (Slide_Over_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"9d9ca11a-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/vue-components/item-list/Item-List.vue?vue&type=template&id=71c00e06
var Item_Listvue_type_template_id_71c00e06_render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.alignment === 'vertical')?_c('div',{staticClass:"cal-item-list"},_vm._l((_vm.availableItems),function(item,index){return _c('Item',{key:index,attrs:{"id":`${_vm.id}_${index}`,"displayTitle":item.displayTitle,"itemPrice":item.itemPrice,"itemSalesPrice":item.itemSalesPrice,"selected":item == _vm.selectedItem || _vm.isPreSelected(item) || (_vm.availableItems.length === 1 && _vm.autoSelect),"itemType":_vm.itemType,"perBouquetPrice":item.perBouquetPrice},nativeOn:{"click":function($event){return _vm.select(item)}}})}),1):_c('div',{staticClass:"cal-hr-item-list"},_vm._l((_vm.availableItems),function(item,index){return _c('HItem',{key:index,attrs:{"id":`${_vm.id}_${index}`,"displayTitle":item.displayTitle,"itemPrice":item.itemPrice,"itemSalesPrice":item.itemSalesPrice,"selected":item == _vm.selectedItem || _vm.isPreSelected(item) || (_vm.availableItems.length === 1 && _vm.autoSelect),"itemType":_vm.itemType,"perBouquetPrice":item.perBouquetPrice,"bqSizeTag":item.bqSizeTag,"disableSection":_vm.disableSection,"TitlePriceAligned":_vm.TitlePriceAligned},nativeOn:{"click":function($event){return _vm.select(item)}}})}),1)
}
var Item_Listvue_type_template_id_71c00e06_staticRenderFns = []


// CONCATENATED MODULE: ./src/vue-components/item-list/Item-List.vue?vue&type=template&id=71c00e06

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"9d9ca11a-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/vue-components/item-list/Item.vue?vue&type=template&id=556ce656
var Itemvue_type_template_id_556ce656_render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cal-item-list-item",class:[{ 'cal-item-list-item-selected': _vm.selected }, `cal-item-list-item-${_vm.itemType}`],attrs:{"id":_vm.id}},[_c('div',{class:_vm.perBouquetPrice === ''
        ? 'cal-item-list-item-leading'
        : 'cal-item-list-item-leading-extra-sales-price'},[_c('div',[_c('span',{staticClass:"cal-item-list-item-title",class:`cal-item-list-item-title-${_vm.itemType}`},[_vm._v(" "+_vm._s(_vm.displayTitle)+" ")])])]),(_vm.perBouquetPrice === '')?_c('div',[_c('span',{staticClass:"cal-item-list-item-price",class:[
        { 'cal-item-list-item-price-has-sale': _vm.itemSalesPrice !== undefined },
        `cal-item-list-item-title-${_vm.itemType}`,
      ]},[_vm._v(" "+_vm._s(_vm.itemPrice)+" ")]),(_vm.itemSalesPrice !== undefined)?_c('span',{staticClass:"cal-item-list-item-sale-price"},[_vm._v(" "+_vm._s(_vm.itemSalesPrice)+" ")]):_vm._e()]):_c('div',{staticClass:"cal-item-list-item-leading cal-item-list-extra-sales-price-text"},[_c('div',[_c('span',{staticClass:"cal-item-list-item-price",class:[
          {
            'cal-item-list-item-price-has-sale': _vm.itemSalesPrice !== undefined,
          },
          `cal-item-list-item-title-${_vm.itemType}`,
        ]},[_vm._v(" "+_vm._s(_vm.itemPrice)+" ")]),(_vm.itemSalesPrice !== undefined)?_c('span',{staticClass:"cal-item-list-item-sale-price"},[_vm._v(" "+_vm._s(_vm.itemSalesPrice)+" ")]):_vm._e()]),_c('div',[_c('div',{domProps:{"innerHTML":_vm._s(_vm.perBouquetPrice)}})])])])
}
var Itemvue_type_template_id_556ce656_staticRenderFns = []


// CONCATENATED MODULE: ./src/vue-components/item-list/Item.vue?vue&type=template&id=556ce656

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/vue-components/item-list/Item.vue?vue&type=script&lang=js

/* harmony default export */ var Itemvue_type_script_lang_js = ({
  name: "cal-item",
  props: {
    displayTitle: {
      type: String,
      required: true,
    },
    itemPrice: {
      type: String,
      required: true,
    },
    itemSalesPrice: {
      type: String,
    },
    selected: {
      type: Boolean,
      default: false,
    },
    itemType: {
      type: String,
      default: "variant",
    },
    perBouquetPrice: {
      type: String,
      default: "",
    },
    id: {
      type: String,
    },
  },
});

// CONCATENATED MODULE: ./src/vue-components/item-list/Item.vue?vue&type=script&lang=js
 /* harmony default export */ var item_list_Itemvue_type_script_lang_js = (Itemvue_type_script_lang_js); 
// CONCATENATED MODULE: ./src/vue-components/item-list/Item.vue





/* normalize component */

var Item_component = normalizeComponent(
  item_list_Itemvue_type_script_lang_js,
  Itemvue_type_template_id_556ce656_render,
  Itemvue_type_template_id_556ce656_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var Item = (Item_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"9d9ca11a-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/vue-components/item-list/H-Item.vue?vue&type=template&id=67cbd34c
var H_Itemvue_type_template_id_67cbd34c_render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[
    { 'cal-hr-item-list-disabled': _vm.disableSection },
    { 'cal-hr-item-list-item-selected': _vm.selected },
    'cal-hr-item-list-item',
  ],attrs:{"id":_vm.id}},[(_vm.TitlePriceAligned)?_c('div',{staticClass:"flex justify-center items-center"},[_c('div',[_c('div',{staticClass:"cal-hr-item-list-item-display-title",staticStyle:{"margin-right":"0.25rem"}},[_vm._v(" "+_vm._s(_vm.displayTitle)+" ")])]),(_vm.perBouquetPrice === '')?_c('div',[_c('span',{staticClass:"cal-hr-item-list-item-item-price",class:[
          { 'cal-item-list-item-price-has-sale': _vm.itemSalesPrice !== undefined },
          `cal-item-list-item-title-${_vm.itemType}`,
        ],domProps:{"innerHTML":_vm._s(_vm.itemPrice)}}),(_vm.itemSalesPrice !== undefined)?_c('span',{staticClass:"cal-item-list-item-sale-price"},[_vm._v(" "+_vm._s(_vm.itemSalesPrice)+" ")]):_vm._e()]):_c('div',{staticClass:"cal-item-list-item-leading"},[_c('div',[_c('span',{staticClass:"cal-hr-item-list-item-item-price",class:[
            {
              'cal-item-list-item-price-has-sale': _vm.itemSalesPrice !== undefined,
            },
            `cal-item-list-item-title-${_vm.itemType}`,
          ]},[_vm._v(" "+_vm._s(_vm.itemPrice)+" ")]),(_vm.itemSalesPrice !== undefined)?_c('span',{staticClass:"cal-item-list-item-sale-price"},[_vm._v(" "+_vm._s(_vm.itemSalesPrice)+" ")]):_vm._e()]),_c('div',[_c('div',{domProps:{"innerHTML":_vm._s(_vm.perBouquetPrice)}})])])]):_c('div',[_c('div',[_c('div',{staticClass:"cal-hr-item-list-item-display-title"},[_vm._v(" "+_vm._s(_vm.displayTitle)+" ")])]),(_vm.perBouquetPrice === '')?_c('div',[_c('span',{staticClass:"cal-hr-item-list-item-item-price",class:[
          { 'cal-item-list-item-price-has-sale': _vm.itemSalesPrice !== undefined },
          `cal-item-list-item-title-${_vm.itemType}`,
        ],domProps:{"innerHTML":_vm._s(_vm.itemPrice)}}),(_vm.itemSalesPrice !== undefined)?_c('span',{staticClass:"cal-item-list-item-sale-price"},[_vm._v(" "+_vm._s(_vm.itemSalesPrice)+" ")]):_vm._e()]):_c('div',{staticClass:"cal-item-list-item-leading"},[_c('div',[_c('span',{staticClass:"cal-hr-item-list-item-item-price",class:[
            {
              'cal-item-list-item-price-has-sale': _vm.itemSalesPrice !== undefined,
            },
            `cal-item-list-item-title-${_vm.itemType}`,
          ]},[_vm._v(" "+_vm._s(_vm.itemPrice)+" ")]),(_vm.itemSalesPrice !== undefined)?_c('span',{staticClass:"cal-item-list-item-sale-price"},[_vm._v(" "+_vm._s(_vm.itemSalesPrice)+" ")]):_vm._e()]),_c('div',[_c('div',{domProps:{"innerHTML":_vm._s(_vm.perBouquetPrice)}})])])]),_c('div',{staticClass:"cal-hr-item-list-item-bq-size"},[_vm._v(" "+_vm._s(_vm.bqSizeTag)+" ")])])
}
var H_Itemvue_type_template_id_67cbd34c_staticRenderFns = []


// CONCATENATED MODULE: ./src/vue-components/item-list/H-Item.vue?vue&type=template&id=67cbd34c

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/vue-components/item-list/H-Item.vue?vue&type=script&lang=js

/* harmony default export */ var H_Itemvue_type_script_lang_js = ({
  name: "cal-h-item",
  props: {
    displayTitle: {
      type: String,
      required: true,
    },
    itemPrice: {
      type: String,
      required: true,
    },
    itemSalesPrice: {
      type: String,
    },
    selected: {
      type: Boolean,
      default: false,
    },
    itemType: {
      type: String,
      default: "variant",
    },
    perBouquetPrice: {
      type: String,
      default: "",
    },
    id: {
      type: String,
    },
    bqSizeTag: {
      type: String,
    },
    disableSection: {
      type: Boolean,
    },
    TitlePriceAligned: {
      type: Boolean,
      default: false,
    },
  },
});

// CONCATENATED MODULE: ./src/vue-components/item-list/H-Item.vue?vue&type=script&lang=js
 /* harmony default export */ var item_list_H_Itemvue_type_script_lang_js = (H_Itemvue_type_script_lang_js); 
// CONCATENATED MODULE: ./src/vue-components/item-list/H-Item.vue





/* normalize component */

var H_Item_component = normalizeComponent(
  item_list_H_Itemvue_type_script_lang_js,
  H_Itemvue_type_template_id_67cbd34c_render,
  H_Itemvue_type_template_id_67cbd34c_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var H_Item = (H_Item_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/vue-components/item-list/Item-List.vue?vue&type=script&lang=js




/* harmony default export */ var Item_Listvue_type_script_lang_js = ({
  name: "cal-item-list",
  components: {
    Item: Item,
    HItem: H_Item,
  },
  props: {
    items: {
      type: Array,
      required: true,
    },
    itemType: {
      type: String,
    },
    id: {
      type: String,
      default: "itemlist",
    },
    autoSelect: {
      type: Boolean,
      default: true,
    },
    showUnavailable: {
      type: Boolean,
      default: false,
    },
    alignment: {
      type: String,
      default: "vertical",
    },
    bqSizeTag: {
      type: String,
      default: "",
    },
    btnDisabled: {
      type: Boolean,
      default: true,
    },
    TitlePriceAligned: {
      type: Boolean,
      default: false,
    },
    preSelectedVariant: {
      type: String,
      required: false,
      default: "",
    },
  },
  emits: ["select"],
  data() {
    return {
      selectedItem: null,
      disableSection: true,
    };
  },
  computed: {
    availableItems() {
      return this.showUnavailable ? this.items : this.items.filter((item) => item.availableForSale);
    },
  },
  methods: {
    select(selectedItem) {
      this.selectedItem = selectedItem;
      this.$emit("select", this.selectedItem);
    },
    isPreSelected(variant) {
      return (
        this.selectedItem == null &&
        variant.title &&
        this.preSelectedVariant &&
        variant.title.toLowerCase() === this.preSelectedVariant.toLowerCase()
      );
    },
  },
  watch: {
    btnDisabled: {
      immediate: true,
      handler(newVal) {
        this.disableSection = newVal;
      },
    },
  },
});

// CONCATENATED MODULE: ./src/vue-components/item-list/Item-List.vue?vue&type=script&lang=js
 /* harmony default export */ var item_list_Item_Listvue_type_script_lang_js = (Item_Listvue_type_script_lang_js); 
// CONCATENATED MODULE: ./src/vue-components/item-list/Item-List.vue





/* normalize component */

var Item_List_component = normalizeComponent(
  item_list_Item_Listvue_type_script_lang_js,
  Item_Listvue_type_template_id_71c00e06_render,
  Item_Listvue_type_template_id_71c00e06_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var Item_List = (Item_List_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"9d9ca11a-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/vue-components/wedding-product-card/Badge.vue?vue&type=template&id=268fe3a1
var Badgevue_type_template_id_268fe3a1_render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"badge",class:_vm.badgeType},[_c('h2',{staticClass:"badge-text",domProps:{"innerHTML":_vm._s(_vm.title)}})])
}
var Badgevue_type_template_id_268fe3a1_staticRenderFns = []


// CONCATENATED MODULE: ./src/vue-components/wedding-product-card/Badge.vue?vue&type=template&id=268fe3a1

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/vue-components/wedding-product-card/Badge.vue?vue&type=script&lang=js

/* harmony default export */ var Badgevue_type_script_lang_js = ({
  name: "cal-badge",
  props: {
    title: "",
    color: "",
  },
  computed: {
    badgeType() {
      switch (this.color) {
        case "primary":
          return "badge-color-primary";
        case "gradient":
          return "badge-color-gradient";
        default:
          return "badge-color-primary";
      }
    },
  },
});

// CONCATENATED MODULE: ./src/vue-components/wedding-product-card/Badge.vue?vue&type=script&lang=js
 /* harmony default export */ var wedding_product_card_Badgevue_type_script_lang_js = (Badgevue_type_script_lang_js); 
// CONCATENATED MODULE: ./src/vue-components/wedding-product-card/Badge.vue





/* normalize component */

var Badge_component = normalizeComponent(
  wedding_product_card_Badgevue_type_script_lang_js,
  Badgevue_type_template_id_268fe3a1_render,
  Badgevue_type_template_id_268fe3a1_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var Badge = (Badge_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"9d9ca11a-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/vue-components/wedding-product-card/Wedding-Product-Card.vue?vue&type=template&id=7e9c1b9e
var Wedding_Product_Cardvue_type_template_id_7e9c1b9e_render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cal-wedding-product-card"},[(_vm.isImgCarousel)?_c('div',{staticClass:"relative inline-block w-full"},[_c('ImageCarousel',{attrs:{"images":_vm.carouselImgs}})],1):_c('div',{staticClass:"relative inline-block"},[_c('img',{staticClass:"cal-wedding-product-card-img",attrs:{"src":_vm.image,"alt":_vm.imageAlt}})]),_c('Badge',{directives:[{name:"show",rawName:"v-show",value:(_vm.badge),expression:"badge"}],attrs:{"color":_vm.badgeColor,"title":_vm.badge}}),_c('div',{staticClass:"cal-wedding-product-card-title"},[_c('h3',[_vm._v(_vm._s(_vm.title))])]),(_vm.subTitleHeading)?_c('div',{staticClass:"cal-wedding-product-card-sub-title"},[_c('p',[_vm._v(_vm._s(_vm.subTitleHeading))])]):_vm._e(),(!_vm.salesPrice)?_c('div',{staticClass:"cal-wedding-product-card-price-wrapper"},[_c('span',{staticClass:"cal-wedding-product-card-price"},[_vm._v(" "+_vm._s(_vm.price)+" ")])]):_c('div',{staticClass:"cal-wedding-product-card-sales-price-wrapper"},[_c('p',{staticClass:"cal-wedding-product-card-price cal-wedding-product-card-price-has-sale"},[_vm._v(" "+_vm._s(_vm.price)+" ")]),_c('p',{staticClass:"cal-wedding-product-card-sales-price"},[_vm._v(" "+_vm._s(_vm.salesPrice)+" ")])]),(_vm.hasSlot('more-details'))?_c('button',{staticClass:"cal-wedding-product-card-read-more",on:{"click":function($event){_vm.showMoreSection = !_vm.showMoreSection}}},[_vm._v(" "+_vm._s(_vm.moreDetailsTitle)+" ")]):_vm._e(),_c('ReadMoreModal',{directives:[{name:"show",rawName:"v-show",value:(_vm.showMoreSection),expression:"showMoreSection"}],attrs:{"smallModal":_vm.smallModal},on:{"close-read-more":function($event){_vm.showMoreSection = false}}},[_vm._t("more-details")],2),(_vm.singleProduct)?_c('div',[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.hasVariants),expression:"hasVariants"}],staticClass:"cal-wedding-product-card-drop-down"},[_c('SelectInput',{attrs:{"label":_vm.variantSelectorLabel,"required":"","options":_vm.variants},model:{value:(_vm.selectedVariant),callback:function ($$v) {_vm.selectedVariant=$$v},expression:"selectedVariant"}})],1),_c('div',{staticClass:"cal-wedding-product-card-quantity-selector"},[_c('div',{staticClass:"cal-wedding-product-card-quantity-selector-wrapper"},[_c('div',{staticClass:"cal-wedding-product-card-quantity-selector-decrement-button"},[_c('button',{attrs:{"disabled":_vm.singleQuantity <= 0},on:{"click":function($event){return _vm.updateSingleQuantity($event, 'dec')}}},[_vm._v(" - ")])])]),_c('span',{staticClass:"cal-wedding-product-card-quantity-selector-value"},[_vm._v(_vm._s(_vm.singleQuantity))]),_c('div',{staticClass:"cal-wedding-product-card-quantity-selector-wrapper"},[_c('div',{staticClass:"cal-wedding-product-card-quantity-selector-decrement-button"},[_c('button',{attrs:{"disabled":_vm.singleQuantity >= _vm.maxQty},on:{"click":function($event){return _vm.updateSingleQuantity($event, 'inc')}}},[_vm._v(" + ")])])])])]):_vm._l((_vm.multiQuantity),function(item,index){return _c('div',{key:item.id},[_c('span',{staticClass:"cal-wedding-product-card-quantity-selector-value"},[_vm._v(_vm._s(item.title))]),_c('div',{staticClass:"cal-wedding-product-card-quantity-selector"},[_c('div',{staticClass:"cal-wedding-product-card-quantity-selector-wrapper"},[_c('div',{staticClass:"cal-wedding-product-card-quantity-selector-decrement-button"},[_c('button',{attrs:{"disabled":item.quantity <= 0},on:{"click":function($event){return _vm.updateMultiQuantity($event, 'dec', index)}}},[_vm._v(" - ")])])]),_c('span',{staticClass:"cal-wedding-product-card-quantity-selector-value"},[_vm._v(_vm._s(item.quantity))]),_c('div',{staticClass:"cal-wedding-product-card-quantity-selector-wrapper"},[_c('div',{staticClass:"cal-wedding-product-card-quantity-selector-decrement-button"},[_c('button',{attrs:{"disabled":item.quantity >= _vm.maxQty},on:{"click":function($event){return _vm.updateMultiQuantity($event, 'inc', index)}}},[_vm._v(" + ")])])])])])})],2)
}
var Wedding_Product_Cardvue_type_template_id_7e9c1b9e_staticRenderFns = []


// CONCATENATED MODULE: ./src/vue-components/wedding-product-card/Wedding-Product-Card.vue?vue&type=template&id=7e9c1b9e

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"9d9ca11a-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/vue-components/modal/ReadMoreModal.vue?vue&type=template&id=9bdeb86a&scoped=true
var ReadMoreModalvue_type_template_id_9bdeb86a_scoped_true_render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"read-more-modal",attrs:{"aria-labelledby":"modal-title","role":"dialog","aria-modal":"true"}},[_c('div',{staticClass:"read-more-modal-background read-more-modal-background-color",on:{"click":function($event){return _vm.$emit('close-read-more')}}}),_c('div',{staticClass:"read-more-modal-body",on:{"click":function($event){$event.stopPropagation();}}},[_c('div',{staticClass:"read-more-modal-content"},[_c('div',{staticClass:"read-more-modal-content-color",class:!_vm.resetPadding
            ? _vm.smallModal
              ? 'read-more-modal-content-in modal-content-in-padding'
              : 'read-more-modal-content-in-lg modal-content-in-padding'
            : _vm.smallModal
            ? 'read-more-modal-content-in'
            : 'read-more-modal-content-in-lg'},[_c('div',{staticClass:"read-more-modal-close"},[(!_vm.hideClosebtn)?_c('button',{attrs:{"type":"button"},on:{"click":function($event){return _vm.$emit('close-read-more')}}},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","fill":"none","viewBox":"0 0 24 24","stroke-width":"1.5","stroke":"currentColor","aria-hidden":"true"}},[_c('path',{attrs:{"stroke-linecap":"round","stroke-linejoin":"round","d":"M6 18L18 6M6 6l12 12"}})])]):_vm._e()]),_vm._t("default")],2)])])])
}
var ReadMoreModalvue_type_template_id_9bdeb86a_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/vue-components/modal/ReadMoreModal.vue?vue&type=template&id=9bdeb86a&scoped=true

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/vue-components/modal/ReadMoreModal.vue?vue&type=script&lang=js

/* harmony default export */ var ReadMoreModalvue_type_script_lang_js = ({
  name: "ReadMoreModal",
  props: {
    isShow: false,
    hideClosebtn: false,
    smallModal: true,
    resetPadding: false,
  },
});

// CONCATENATED MODULE: ./src/vue-components/modal/ReadMoreModal.vue?vue&type=script&lang=js
 /* harmony default export */ var modal_ReadMoreModalvue_type_script_lang_js = (ReadMoreModalvue_type_script_lang_js); 
// CONCATENATED MODULE: ./src/vue-components/modal/ReadMoreModal.vue





/* normalize component */

var ReadMoreModal_component = normalizeComponent(
  modal_ReadMoreModalvue_type_script_lang_js,
  ReadMoreModalvue_type_template_id_9bdeb86a_scoped_true_render,
  ReadMoreModalvue_type_template_id_9bdeb86a_scoped_true_staticRenderFns,
  false,
  null,
  "9bdeb86a",
  null
  
)

/* harmony default export */ var ReadMoreModal = (ReadMoreModal_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"9d9ca11a-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/vue-components/wedding-product-card/Image-Carousel.vue?vue&type=template&id=ecb32b94
var Image_Carouselvue_type_template_id_ecb32b94_render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"touch",rawName:"v-touch:swipe",value:(_vm.onSwipe),expression:"onSwipe",arg:"swipe"}]},[(_vm.images.length > 0)?_c('div',{staticClass:"img-carousel"},[_c('div',{staticClass:"img-carousel-wrapper"},[(_vm.images.length > 1)?_c('div',{staticClass:"img-carousel-direction-btn"},[_c('button',{on:{"click":function($event){return _vm.previous(true)}}},[_c('svg',{staticClass:"img-carousel-svg",attrs:{"viewBox":"0 0 24 24"}},[_c('path',{attrs:{"fill":"currentColor","d":"M22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2A10,10 0 0,1 22,12M14,7L9,12L14,17V7Z"}})])])]):_vm._e(),_c('div',{staticClass:"img-carousel-img-transition"},_vm._l((_vm.images),function(image,index){return _c('transition',{key:index,attrs:{"name":_vm.vaiantslider,"mode":"out-in"}},[(index === _vm.currentIndex)?_c('div',{staticClass:"vaiantslider"},[_c('cal-img',{attrs:{"src":image,"alt":"wedding-img-slider","customClass":"sm:px-2 aspect-[1/1]","width":_vm.width,"height":_vm.height}})],1):_vm._e()])}),1),(_vm.images.length > 1)?_c('div',{staticClass:"img-carousel-direction-btn"},[_c('button',{on:{"click":function($event){return _vm.next(true)}}},[_c('svg',{staticClass:"img-carousel-svg",attrs:{"viewBox":"0 0 24 24"}},[_c('path',{attrs:{"fill":"currentColor","d":"M2,12A10,10 0 0,1 12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12M10,17L15,12L10,7V17Z"}})])])]):_vm._e()]),(_vm.images.length > 1)?_c('div',{staticClass:"img-carousel-index-btn-wrapper"},_vm._l((_vm.images),function(sl,ind){return _c('div',{key:ind,staticClass:"img-carousel-index"},[_c('button',{staticClass:"img-carousel-index-btn",class:ind === _vm.currentIndex ? 'bg-complementary ' : 'bg-transparent ',on:{"click":function($event){return _vm.changeActiveIndex(ind)}}})])}),0):_vm._e()]):_c('div',[_vm._m(0)])])
}
var Image_Carouselvue_type_template_id_ecb32b94_staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"img-carousel-skeleton-wrapper"},[_c('div',{staticClass:"img-carousel-skeleton"})])
}]


// CONCATENATED MODULE: ./src/vue-components/wedding-product-card/Image-Carousel.vue?vue&type=template&id=ecb32b94

// EXTERNAL MODULE: ./node_modules/hammerjs/hammer.js
var hammer = __webpack_require__("c8b5");
var hammer_default = /*#__PURE__*/__webpack_require__.n(hammer);

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/vue-components/wedding-product-card/Image-Carousel.vue?vue&type=script&lang=js



/* harmony default export */ var Image_Carouselvue_type_script_lang_js = ({
  name: "img-carousel",
  props: ["images", "width", "height"],
  components: {
    CalImg: Cal_Img,
  },
  data() {
    return {
      currentIndex: 0,
      activeSlideDot: 0,
      vaiantslider: "vaiantslider-left-to-right",
    };
  },
  methods: {
    next() {
      this.vaiantslider = "vaiantslider-left-to-right";
      if (this.currentIndex < this.images.length - 1) {
        this.currentIndex++;
      } else {
        this.currentIndex = 0;
      }
    },
    previous() {
      this.vaiantslider = "vaiantslider-right-to-left";
      if (this.currentIndex <= this.images.length - 1 && this.currentIndex > 0) {
        this.currentIndex--;
      } else {
        this.currentIndex = this.images.length - 1;
      }
    },
    onSwipe(event) {
      if (event.direction === hammer_default.a.DIRECTION_LEFT) {
        this.previous();
      } else if (event.direction === hammer_default.a.DIRECTION_RIGHT) {
        this.next();
      }
    },
    changeActiveIndex(index) {
      this.currentIndex = index;
    },
  },
  mounted() {
    this.hammer = new hammer_default.a(this.$el);
    this.hammer.on("swipe", this.onSwipe);
  },
});

// CONCATENATED MODULE: ./src/vue-components/wedding-product-card/Image-Carousel.vue?vue&type=script&lang=js
 /* harmony default export */ var wedding_product_card_Image_Carouselvue_type_script_lang_js = (Image_Carouselvue_type_script_lang_js); 
// EXTERNAL MODULE: ./src/vue-components/wedding-product-card/Image-Carousel.vue?vue&type=style&index=0&id=ecb32b94&prod&lang=css
var Image_Carouselvue_type_style_index_0_id_ecb32b94_prod_lang_css = __webpack_require__("818a");

// CONCATENATED MODULE: ./src/vue-components/wedding-product-card/Image-Carousel.vue






/* normalize component */

var Image_Carousel_component = normalizeComponent(
  wedding_product_card_Image_Carouselvue_type_script_lang_js,
  Image_Carouselvue_type_template_id_ecb32b94_render,
  Image_Carouselvue_type_template_id_ecb32b94_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var Image_Carousel = (Image_Carousel_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/vue-components/wedding-product-card/Wedding-Product-Card.vue?vue&type=script&lang=js





/* harmony default export */ var Wedding_Product_Cardvue_type_script_lang_js = ({
  name: "cal-wedding-product-card",
  components: {
    ReadMoreModal: ReadMoreModal,
    Badge: Badge,
    ImageCarousel: Image_Carousel,
  },
  props: {
    image: {
      type: String,
      required: true,
    },
    singleQty: {
      type: Number,
      default: 0,
    },
    imageAlt: {
      type: String,
    },
    title: {
      type: String,
      required: true,
    },
    price: {
      type: String,
      required: true,
    },
    salesPrice: {
      type: String,
    },
    badge: {
      type: String,
    },
    badgeColor: {
      type: String,
    },
    moreDetailsTitle: {
      type: String,
    },
    variants: {
      type: Array,
      required: true,
    },
    singleProduct: {
      type: Boolean,
      required: true,
    },
    defaultVariant: {
      type: String,
    },
    smallModal: {
      type: Boolean,
    },
    variantSelectorLabel: {
      type: String,
      default: "Select size",
    },
    multiQty: {
      type: Object,
    },
    isImgCarousel: {
      type: Boolean,
    },
    carouselImgs: {
      type: Array,
    },
    maxQty: {
      type: Number,
      default: 99,
    },
    subTitleHeading: {
      type: String,
    },
  },
  data() {
    return {
      singleQuantity: 0,
      selectedVariant: this.defaultVariant,
      showMoreSection: false,
      multiQuantity: Array.from(this.variants, (element, index) => ({
        id: `variant_${index + 1}`,
        title: element,
        quantity: 0,
      })),
    };
  },
  computed: {
    hasVariants() {
      return this.variants && this.variants.length > 0;
    },
  },
  watch: {
    selectedVariant() {
      this.$emit("updateVariant", {
        selectedVariant: this.selectedVariant,
      });
    },
    singleQty: {
      immediate: true,
      handler(newVal) {
        this.singleQuantity = newVal;
      },
    },
    multiQty: {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          this.multiQuantity = Array.from(this.variants, (element, index) => ({
            id: `variant_${index + 1}`,
            title: element,
            quantity: newVal.quantities[index],
          }));
        }
      },
    },
  },
  methods: {
    updateSingleQuantity(event, type) {
      event.stopPropagation();
      type === "inc" ? this.singleQuantity++ : this.singleQuantity--;

      this.$emit("updateSingleQuantity", {
        quantity: this.singleQuantity,
        title: this.title,
        variant: this.selectedVariant,
        type: type,
      });
    },
    updateMultiQuantity(event, type, index) {
      event.stopPropagation();
      type === "inc" ? this.multiQuantity[index].quantity++ : this.multiQuantity[index].quantity--;

      this.$emit("updateMultiQuantity", {
        quantity: this.multiQuantity[index].quantity,
        title: this.multiQuantity[index].title,
        index: index,
        type: type,
      });
    },
    hasSlot(name = "default") {
      return !!this.$slots[name] || !!this.$scopedSlots[name];
    },
  },
});

// CONCATENATED MODULE: ./src/vue-components/wedding-product-card/Wedding-Product-Card.vue?vue&type=script&lang=js
 /* harmony default export */ var wedding_product_card_Wedding_Product_Cardvue_type_script_lang_js = (Wedding_Product_Cardvue_type_script_lang_js); 
// CONCATENATED MODULE: ./src/vue-components/wedding-product-card/Wedding-Product-Card.vue





/* normalize component */

var Wedding_Product_Card_component = normalizeComponent(
  wedding_product_card_Wedding_Product_Cardvue_type_script_lang_js,
  Wedding_Product_Cardvue_type_template_id_7e9c1b9e_render,
  Wedding_Product_Cardvue_type_template_id_7e9c1b9e_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var Wedding_Product_Card = (Wedding_Product_Card_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"9d9ca11a-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/vue-components/section-divider/Section-Divider.vue?vue&type=template&id=5fc037af
var Section_Dividervue_type_template_id_5fc037af_render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"cal-section-divider"},[_c('h2',{staticClass:"cal-section-divider-content",domProps:{"innerHTML":_vm._s(_vm.content)}}),(_vm.subContent)?_c('p',{staticClass:"cal-section-divider-subcontent",domProps:{"innerHTML":_vm._s(_vm.subContent)}}):_vm._e(),(_vm.btntext)?_c('div',{staticClass:"cal-section-divider-btn"},[_c('Button',{attrs:{"btnText":_vm.btntext},on:{"click":_vm.btnaction}})],1):_vm._e()])])
}
var Section_Dividervue_type_template_id_5fc037af_staticRenderFns = []


// CONCATENATED MODULE: ./src/vue-components/section-divider/Section-Divider.vue?vue&type=template&id=5fc037af

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/vue-components/section-divider/Section-Divider.vue?vue&type=script&lang=js

/* harmony default export */ var Section_Dividervue_type_script_lang_js = ({
  name: "cal-section-divider",
  props: {
    content: {
      type: String,
      default: "",
    },
    subContent: {
      type: String,
      default: "",
    },
    btntext: {
      type: String,
      default: "",
    },
    btnaction: {
      type: Function,
      default: null,
    },
  },
});

// CONCATENATED MODULE: ./src/vue-components/section-divider/Section-Divider.vue?vue&type=script&lang=js
 /* harmony default export */ var section_divider_Section_Dividervue_type_script_lang_js = (Section_Dividervue_type_script_lang_js); 
// CONCATENATED MODULE: ./src/vue-components/section-divider/Section-Divider.vue





/* normalize component */

var Section_Divider_component = normalizeComponent(
  section_divider_Section_Dividervue_type_script_lang_js,
  Section_Dividervue_type_template_id_5fc037af_render,
  Section_Dividervue_type_template_id_5fc037af_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var Section_Divider = (Section_Divider_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"9d9ca11a-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/vue-components/add-on/Full-Addon.vue?vue&type=template&id=4d4890e6
var Full_Addonvue_type_template_id_4d4890e6_render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cal-add-on",class:_vm.isActive ? 'cal-add-on-selected' : 'cal-add-on-gray-border'},[_c('cal-img',{attrs:{"src":_vm.image,"alt":_vm.imageAlt,"customClass":"cal-add-on-img","width":_vm.width,"height":_vm.height}}),_c('div',{staticClass:"cal-add-on-image-main-title-wrapper"},[_c('h3',{staticClass:"cal-add-on-image-main-title-wrapper-text"},[_vm._v(_vm._s(_vm.title))])]),_c('div',{staticClass:"cal-add-on-img-addon-details",domProps:{"innerHTML":_vm._s(_vm.productDetails)}}),(_vm.hasSlot('read-more'))?_c('button',{staticClass:"cal-add-on-read-more",on:{"click":function($event){_vm.showReadMore = !_vm.showReadMore}}},[_vm._v(" "+_vm._s(_vm.readmore)+" ")]):_vm._e(),(_vm.upgradeNow)?_c('div',{staticClass:"cal-add-on-update-now-wrapper"},[_c('button',{staticClass:"cal-btn",on:{"click":_vm.selectAddon}},[_vm._v(" "+_vm._s(_vm.upgradeNow)+" ")])]):_vm._e(),_c('Modal',{directives:[{name:"show",rawName:"v-show",value:(_vm.showReadMore),expression:"showReadMore"}],on:{"close-modal":function($event){_vm.showReadMore = false}}},[_vm._t("read-more")],2)],1)
}
var Full_Addonvue_type_template_id_4d4890e6_staticRenderFns = []


// CONCATENATED MODULE: ./src/vue-components/add-on/Full-Addon.vue?vue&type=template&id=4d4890e6

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/vue-components/add-on/Full-Addon.vue?vue&type=script&lang=js




/* harmony default export */ var Full_Addonvue_type_script_lang_js = ({
  name: "cal-full-addon",
  components: {
    Modal: Modal,
    CalImg: Cal_Img,
  },
  props: {
    index: {
      type: Number,
      required: false,
    },
    image: {
      type: String,
      required: true,
    },
    imageAlt: {
      type: String,
    },
    title: {
      type: String,
      required: true,
    },
    readmore: {
      type: String,
    },
    upgradeNow: {
      type: String,
    },
    addOnSelected: {
      type: [],
    },
    addOnData: {
      type: Object,
      required: true,
    },
    productDetails: {
      type: String,
    },
    isAddonSelected: {
      type: Boolean,
      default: false,
    },
    width: {
      type: Number,
    },
    height: {
      type: Number,
    },
  },
  data() {
    return {
      quantity: 0,
      showReadMore: false,
      selected: false,
    };
  },
  computed: {
    selectedAddons() {
      return this.addOnSelected;
    },
    isActive() {
      return this.isAddonSelected;
    },
  },
  watch: {
    quantity() {
      this.$emit("updateQuantity", {
        quantity: this.quantity,
        title: this.title,
        index: this.index,
        addon: this.addOnData,
      });
    },
    selectedAddons() {
      if (this.selectedAddons) {
        const enable = Object.values(this.selectedAddons).filter((item) => {
          return item.addon && item.addon.id === this.addOnData.id;
        });
        if (enable.length !== 0 && enable[0].addon.id) {
          this.selected = true;
        } else {
          this.selected = false;
        }
      }
    },
  },
  methods: {
    decrementQuantity(event) {
      event.stopPropagation();
      if (this.quantity > 0) {
        this.quantity--;
      }
    },
    incrementQuantity(event) {
      event.stopPropagation();
      if (this.quantity < this.maxQuantity) {
        this.quantity++;
      }
    },
    updateQuantity(value) {
      const num = parseInt(value);
      if (num > this.maxQuantity) {
        this.quantity = this.maxQuantity;
      } else if (num < 0) {
        this.quantity = 0;
      } else {
        this.quantity = num;
      }
      this.$forceUpdate();
    },
    selectAddon() {
      if (this.selected) {
        this.selected = false;
        this.updateQuantity(0);
      } else {
        this.selected = true;
        this.updateQuantity(1);
      }
      this.$emit("toggleEvent", {
        quantity: this.quantity,
        title: this.title,
        index: this.index,
        addon: this.addOnData,
      });
    },
    hasSlot(name = "default") {
      return !!this.$slots[name] || !!this.$scopedSlots[name];
    },
  },
});

// CONCATENATED MODULE: ./src/vue-components/add-on/Full-Addon.vue?vue&type=script&lang=js
 /* harmony default export */ var add_on_Full_Addonvue_type_script_lang_js = (Full_Addonvue_type_script_lang_js); 
// CONCATENATED MODULE: ./src/vue-components/add-on/Full-Addon.vue





/* normalize component */

var Full_Addon_component = normalizeComponent(
  add_on_Full_Addonvue_type_script_lang_js,
  Full_Addonvue_type_template_id_4d4890e6_render,
  Full_Addonvue_type_template_id_4d4890e6_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var Full_Addon = (Full_Addon_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"9d9ca11a-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/vue-components/add-on/Add-On-V2.vue?vue&type=template&id=a9094f46
var Add_On_V2vue_type_template_id_a9094f46_render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cal-add-on-v2",class:{ 'cal-add-on-v2-selected': _vm.selected || _vm.quantity > 0 },attrs:{"id":_vm.id},on:{"click":_vm.selectAddon}},[_c('div',{staticClass:"cal-add-on-v2-container relative"},[_c('div',{staticClass:"cal-add-on-v2-img-div"},[_c('cal-img',{attrs:{"src":_vm.image,"alt":_vm.imageAlt,"customClass":"cal-add-on-v2-img","width":_vm.width,"height":_vm.height}})],1),_c('div',{staticClass:"flex flex-col cal-add-on-v2-wording-div"},[_c('div',{staticClass:"cal-add-on-v2-title"},[_c('div',[_vm._v(_vm._s(_vm.editedTitle))])]),_c('div',{staticClass:"cal-add-on-v2-price-wrapper flex mr-1"},[(_vm.salePrice !== undefined)?_c('span',{staticClass:"cal-add-on-v2-sale-price"},[_vm._v(" "+_vm._s(_vm.salePrice)+" ")]):_vm._e(),_c('span',{staticClass:"cal-add-on-v2-price",class:{ 'cal-add-on-v2-has-sale': _vm.salePrice !== undefined }},[_vm._v(" "+_vm._s(_vm.price)+" ")])]),_c('div',{staticClass:"cal-add-on-v2-readmore-div flex"},[_c('button',{staticClass:"cal-add-on-v2-read-more",attrs:{"id":`${_vm.id}_read_more`},on:{"click":_vm.handleReadMoreClick}},[_vm._v(" "+_vm._s(_vm.readmore)+" ")])])])]),_c('div',[(!_vm.useQuantitySelector)?_c('div',{class:_vm.selected ? 'cal-add-on-v2-checkbox-active' : 'cal-add-on-v2-checkbox'},[_c('i',{staticClass:"fas fa-check checkmark cal-add-on-v2-checkbox-checkmark text-base"})]):_c('div',[_c('div',{class:_vm.selected ? 'cal-add-on-v2-checkbox-active' : 'cal-add-on-v2-checkbox',staticStyle:{"text-align":"center","align-content":"center"}}),(_vm.quantity >= 1)?_c('div',[_c('SimpleSelectInput',{staticClass:"cal-add-on-v2-dropdown",attrs:{"options":_vm.quantityOptions},model:{value:(_vm.quantity),callback:function ($$v) {_vm.quantity=$$v},expression:"quantity"}})],1):_vm._e()])]),(_vm.badge !== undefined && _vm.badge.length > 0)?_c('div',{staticClass:"cal-add-on-v2-badge"},[_c('span',{staticClass:"cal-add-on-v2-badge-s2"}),_c('span',{staticClass:"cal-add-on-v2-badge-s1"}),_c('div',{staticClass:"cal-add-on-v2-badge-bottom"}),_vm._v(" "+_vm._s(_vm.badge)+" ")]):_vm._e()])
}
var Add_On_V2vue_type_template_id_a9094f46_staticRenderFns = []


// CONCATENATED MODULE: ./src/vue-components/add-on/Add-On-V2.vue?vue&type=template&id=a9094f46

// EXTERNAL MODULE: ./node_modules/@fortawesome/fontawesome-free/css/all.css
var css_all = __webpack_require__("15f5");

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/vue-components/add-on/Add-On-V2.vue?vue&type=script&lang=js





/* harmony default export */ var Add_On_V2vue_type_script_lang_js = ({
  name: "cal-add-on-v2",
  components: {
    Modal: Modal,
    CalImg: Cal_Img,
  },
  props: {
    index: {
      type: Number,
      required: false,
    },
    image: {
      type: String,
      required: true,
    },
    imageAlt: {
      type: String,
    },
    title: {
      type: String,
      required: true,
    },
    price: {
      type: String,
      required: true,
    },
    salePrice: {
      type: String,
    },
    badge: {
      type: String,
    },
    readmore: {
      type: String,
    },
    useQuantitySelector: {
      type: Boolean,
      default: false,
    },
    addOnSelected: {
      type: [],
    },
    maxQuantity: {
      type: Number,
      default: 10,
    },
    addOnData: {
      type: Object,
      required: true,
    },
    id: {
      type: String,
    },
    productType: {
      type: String,
    },
    width: {
      type: String,
    },
    height: {
      type: String,
    },
    maxTitleLength: {
      type: Number,
      default: 25,
    },
  },
  data() {
    return {
      quantity: 0,
      showReadMore: false,
      selected: false,
    };
  },
  computed: {
    selectedAddons() {
      return this.addOnSelected;
    },
    editedTitle() {
      return this.title && this.title.length > 0
        ? this.title.length > this.maxTitleLength
          ? `${this.title.substring(0, this.maxTitleLength)}...`
          : this.title
        : "";
    },
    quantityOptions() {
      return Array.from({ length: this.maxQuantity + 1 }, (_, i) => i.toString());
    },
  },
  watch: {
    quantity() {
      if (this.productType !== "Vase" && this.quantity !== "") {
        this.$emit("updateQuantity", {
          quantity: this.quantity,
          title: this.title,
          index: this.index,
          addon: this.addOnData,
        });
        if (this.quantity == 0) {
          this.selected = false;
        }
      }
    },
    selectedAddons() {
      if (this.selectedAddons) {
        const enable = Object.values(this.selectedAddons).filter((item) => {
          return item.addon && item.addon.id === this.addOnData.id;
        });
        if (enable.length !== 0 && enable[0].addon.id) {
          this.selected = true;
          this.quantity = enable[0].quantity;
        } else {
          this.selected = false;
          this.quantity = 0;
        }
      }
    },
  },
  methods: {
    decrementQuantity(event) {
      event.stopPropagation();
      if (this.quantity > 0) {
        this.quantity--;
      }
    },
    incrementQuantity(event) {
      event.stopPropagation();
      if (this.quantity < this.maxQuantity) {
        this.quantity++;
      }
    },
    updateQuantity(value) {
      const num = parseInt(value);
      if (num > this.maxQuantity) {
        this.quantity = this.maxQuantity;
      } else if (num < 0) {
        this.quantity = 0;
      } else {
        this.quantity = num;
      }

      if (this.productType === "Vase") {
        this.$emit("updateQuantity", {
          quantity: this.quantity,
          title: this.title,
          index: this.index,
          addon: this.addOnData,
        });
      }
      this.$forceUpdate();
    },
    selectAddon() {
      if (this.useQuantitySelector && !this.selected) {
        this.selected = true;
        this.updateQuantity(1);
      } else if (!this.useQuantitySelector && this.selected) {
        this.selected = false;
        this.updateQuantity(0);
      } else if (!this.useQuantitySelector && !this.selected) {
        this.selected = true;
        this.updateQuantity(1);
      }
    },
    handleReadMoreClick(event) {
      event.stopPropagation();
      this.showReadMore = !this.showReadMore;
      this.$emit("openReadMore", this.addOnData);
    },
    hasSlot(name = "default") {
      return !!this.$slots[name] || !!this.$scopedSlots[name];
    },
  },
});

// CONCATENATED MODULE: ./src/vue-components/add-on/Add-On-V2.vue?vue&type=script&lang=js
 /* harmony default export */ var add_on_Add_On_V2vue_type_script_lang_js = (Add_On_V2vue_type_script_lang_js); 
// CONCATENATED MODULE: ./src/vue-components/add-on/Add-On-V2.vue





/* normalize component */

var Add_On_V2_component = normalizeComponent(
  add_on_Add_On_V2vue_type_script_lang_js,
  Add_On_V2vue_type_template_id_a9094f46_render,
  Add_On_V2vue_type_template_id_a9094f46_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var Add_On_V2 = (Add_On_V2_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"9d9ca11a-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/vue-components/product-tile/Marketing-Badge.vue?vue&type=template&id=45aa452a&scoped=true
var Marketing_Badgevue_type_template_id_45aa452a_scoped_true_render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cal-marketing-badge"},[_vm._v(" "+_vm._s(_vm.badgeText)+" ")])
}
var Marketing_Badgevue_type_template_id_45aa452a_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/vue-components/product-tile/Marketing-Badge.vue?vue&type=template&id=45aa452a&scoped=true

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/vue-components/product-tile/Marketing-Badge.vue?vue&type=script&lang=js

/* harmony default export */ var Marketing_Badgevue_type_script_lang_js = ({
  name: "cal-special-badge",
  props: ["badgeText"],
});

// CONCATENATED MODULE: ./src/vue-components/product-tile/Marketing-Badge.vue?vue&type=script&lang=js
 /* harmony default export */ var product_tile_Marketing_Badgevue_type_script_lang_js = (Marketing_Badgevue_type_script_lang_js); 
// CONCATENATED MODULE: ./src/vue-components/product-tile/Marketing-Badge.vue





/* normalize component */

var Marketing_Badge_component = normalizeComponent(
  product_tile_Marketing_Badgevue_type_script_lang_js,
  Marketing_Badgevue_type_template_id_45aa452a_scoped_true_render,
  Marketing_Badgevue_type_template_id_45aa452a_scoped_true_staticRenderFns,
  false,
  null,
  "45aa452a",
  null
  
)

/* harmony default export */ var Marketing_Badge = (Marketing_Badge_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"9d9ca11a-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/vue-components/error/Error-Banner.vue?vue&type=template&id=08700214
var Error_Bannervue_type_template_id_08700214_render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"error-banner-div"},[_c('p',{staticClass:"error-banner-p",attrs:{"id":"postalcode_error_msg"},domProps:{"innerHTML":_vm._s(_vm.errorHTML)}})])
}
var Error_Bannervue_type_template_id_08700214_staticRenderFns = []


// CONCATENATED MODULE: ./src/vue-components/error/Error-Banner.vue?vue&type=template&id=08700214

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/vue-components/error/Error-Banner.vue?vue&type=script&lang=js

/* harmony default export */ var Error_Bannervue_type_script_lang_js = ({
  name: "ErrorBanner",
  props: {
    errorHTML: {
      type: String,
      required: true,
    },
  },
});

// CONCATENATED MODULE: ./src/vue-components/error/Error-Banner.vue?vue&type=script&lang=js
 /* harmony default export */ var error_Error_Bannervue_type_script_lang_js = (Error_Bannervue_type_script_lang_js); 
// CONCATENATED MODULE: ./src/vue-components/error/Error-Banner.vue





/* normalize component */

var Error_Banner_component = normalizeComponent(
  error_Error_Bannervue_type_script_lang_js,
  Error_Bannervue_type_template_id_08700214_render,
  Error_Bannervue_type_template_id_08700214_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var Error_Banner = (Error_Banner_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"9d9ca11a-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/vue-components/form-input/Input.vue?vue&type=template&id=c76f9314
var Inputvue_type_template_id_c76f9314_render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"cal-input"},[((_vm.type)==='checkbox')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.localValue),expression:"localValue"}],staticClass:"cal-input-text",attrs:{"id":_vm.id,"placeholder":_vm.label,"disabled":_vm.disabled,"required":_vm.required,"error-message":_vm.errorMessage,"aria-required":_vm.required,"aria-invalid":_vm.errorMessage,"maxlength":_vm.maxLength,"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.localValue)?_vm._i(_vm.localValue,null)>-1:(_vm.localValue)},on:{"change":function($event){var $$a=_vm.localValue,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.localValue=$$a.concat([$$v]))}else{$$i>-1&&(_vm.localValue=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.localValue=$$c}}}}):((_vm.type)==='radio')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.localValue),expression:"localValue"}],staticClass:"cal-input-text",attrs:{"id":_vm.id,"placeholder":_vm.label,"disabled":_vm.disabled,"required":_vm.required,"error-message":_vm.errorMessage,"aria-required":_vm.required,"aria-invalid":_vm.errorMessage,"maxlength":_vm.maxLength,"type":"radio"},domProps:{"checked":_vm._q(_vm.localValue,null)},on:{"change":function($event){_vm.localValue=null}}}):_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.localValue),expression:"localValue"}],staticClass:"cal-input-text",attrs:{"id":_vm.id,"placeholder":_vm.label,"disabled":_vm.disabled,"required":_vm.required,"error-message":_vm.errorMessage,"aria-required":_vm.required,"aria-invalid":_vm.errorMessage,"maxlength":_vm.maxLength,"type":_vm.type},domProps:{"value":(_vm.localValue)},on:{"input":function($event){if($event.target.composing)return;_vm.localValue=$event.target.value}}}),_vm._m(0)]),_c('p',{staticClass:"cal-input-error"},[_vm._v(_vm._s(_vm.errorMessage))])])
}
var Inputvue_type_template_id_c76f9314_staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('label',{staticClass:"cal-input-label",attrs:{"for":_vm.id}},[_vm._v(_vm._s(_vm.label))])
}]


// CONCATENATED MODULE: ./src/vue-components/form-input/Input.vue?vue&type=template&id=c76f9314

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/vue-components/form-input/Input.vue?vue&type=script&lang=js

/* harmony default export */ var Inputvue_type_script_lang_js = ({
  name: "cal-input",
  props: {
    type: {
      type: String,
      default: "text",
      required: true,
      validator(value) {
        return ["text", "number", "email", "password", "tel"].includes(value);
      },
    },
    value: {
      type: [String, Number],
    },
    label: {
      type: String,
      required: true,
    },
    required: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    error: {
      type: Function,
    },
    maxLength: {
      type: Number,
      default: 2500,
    },
  },
  data() {
    return {
      localValue: this.value,
      errorMessage: null,
    };
  },
  created() {
    this.$nuxt.$on("runInputFieldsValidation", () => {
      this.errorValidation(this.localValue);
    });
  },
  computed: {
    id() {
      return this.label
        ? this.label.toLowerCase().replace(/\s+/g, "-") +
            "-" +
            Math.floor(1000 + Math.random() * 9000)
        : this.label;
    },
  },
  watch: {
    localValue(text) {
      this.$emit("input", text);
      this.errorValidation(text);
    },
    value: {
      handler(text) {
        this.localValue = text;
      },
      deep: true,
    },
  },
  methods: {
    errorValidation(text) {
      if (this.error) {
        this.errorMessage = this.error(text) || null;
      }
    },
  },
  beforeUnmount() {
    this.$nuxt.$off("runInputFieldsValidation");
  },
});

// CONCATENATED MODULE: ./src/vue-components/form-input/Input.vue?vue&type=script&lang=js
 /* harmony default export */ var form_input_Inputvue_type_script_lang_js = (Inputvue_type_script_lang_js); 
// CONCATENATED MODULE: ./src/vue-components/form-input/Input.vue





/* normalize component */

var Input_component = normalizeComponent(
  form_input_Inputvue_type_script_lang_js,
  Inputvue_type_template_id_c76f9314_render,
  Inputvue_type_template_id_c76f9314_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var Input = (Input_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"9d9ca11a-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/vue-components/form-input/DateInput.vue?vue&type=template&id=8185ebb2
var DateInputvue_type_template_id_8185ebb2_render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"cal-input"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.localValue),expression:"localValue"}],staticClass:"cal-input-text",attrs:{"id":_vm.id,"type":"text","placeholder":_vm.label,"disabled":_vm.disabled,"required":_vm.required,"error-message":_vm.errorMessage,"aria-required":_vm.required,"aria-invalid":_vm.errorMessage},domProps:{"value":(_vm.localValue)},on:{"click":function($event){$event.preventDefault();_vm.showDatePicker = true},"blur":function($event){return _vm.$emit('blur', $event)},"input":function($event){if($event.target.composing)return;_vm.localValue=$event.target.value}}}),_vm._m(0)]),_c('p',{staticClass:"cal-input-error"},[_vm._v(_vm._s(_vm.errorMessage))]),_c('Modal',{directives:[{name:"show",rawName:"v-show",value:(_vm.showDatePicker),expression:"showDatePicker"}],on:{"close-modal":function($event){_vm.showDatePicker = false}}},[_c('DatePicker',{attrs:{"nextAvailableDate":_vm.nextAvailableDate,"singleMonth":"true"},on:{"dateChange":_vm.dateChange}})],1)],1)
}
var DateInputvue_type_template_id_8185ebb2_staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('label',{staticClass:"cal-input-label",attrs:{"for":_vm.id}},[_vm._v(_vm._s(_vm.label))])
}]


// CONCATENATED MODULE: ./src/vue-components/form-input/DateInput.vue?vue&type=template&id=8185ebb2

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/vue-components/form-input/DateInput.vue?vue&type=script&lang=js



/* harmony default export */ var DateInputvue_type_script_lang_js = ({
  name: "cal-date-input",
  components: { Modal: Modal, DatePicker: Date_Picker },
  props: {
    value: {
      type: [String, Number],
    },
    label: {
      type: String,
      required: true,
    },
    required: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    error: {
      type: Function,
    },
  },
  data() {
    return {
      localValue: !isNaN(Date.parse(this.value))
        ? new Date(this.value).toISOString().slice(0, 10)
        : new Date().toISOString().slice(0, 10),
      errorMessage: null,
      showDatePicker: false,
      nextAvailableDate: new Date().toISOString().slice(0, 10),
    };
  },
  created() {
    this.$nuxt.$on("runInputFieldsValidation", () => {
      this.errorValidation(this.localValue);
    });
  },
  computed: {
    id() {
      return this.label
        ? this.label.toLowerCase().replace(/\s+/g, "-") +
            "-" +
            Math.floor(1000 + Math.random() * 9000)
        : this.label;
    },
  },
  methods: {
    dateChange(date) {
      this.localValue = date;
    },
    errorValidation(date) {
      if (this.error) {
        this.errorMessage = this.error(date) || null;
      }
    },
  },
  watch: {
    localValue(date) {
      this.$emit("input", date);
      this.errorValidation(date);
    },
    value: {
      handler(text) {
        this.localValue = text;
      },
      deep: true,
    },
  },
  beforeUnmount() {
    this.$nuxt.$off("runInputFieldsValidation");
  },
});

// CONCATENATED MODULE: ./src/vue-components/form-input/DateInput.vue?vue&type=script&lang=js
 /* harmony default export */ var form_input_DateInputvue_type_script_lang_js = (DateInputvue_type_script_lang_js); 
// CONCATENATED MODULE: ./src/vue-components/form-input/DateInput.vue





/* normalize component */

var DateInput_component = normalizeComponent(
  form_input_DateInputvue_type_script_lang_js,
  DateInputvue_type_template_id_8185ebb2_render,
  DateInputvue_type_template_id_8185ebb2_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var DateInput = (DateInput_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"9d9ca11a-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/vue-components/form-input/TextAreaInput.vue?vue&type=template&id=0a920412
var TextAreaInputvue_type_template_id_0a920412_render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"cal-input"},[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.localValue),expression:"localValue"}],staticClass:"cal-input-text",attrs:{"id":_vm.id,"type":_vm.type,"placeholder":_vm.label,"rows":_vm.rows,"cols":_vm.cols,"maxlength":_vm.maxLength,"disabled":_vm.disabled,"required":_vm.required,"error-message":_vm.errorMessage,"aria-required":_vm.required,"aria-invalid":_vm.errorMessage},domProps:{"value":(_vm.localValue)},on:{"input":function($event){if($event.target.composing)return;_vm.localValue=$event.target.value}}}),_vm._m(0)]),_c('p',{staticClass:"cal-input-error"},[_vm._v(_vm._s(_vm.errorMessage))])])
}
var TextAreaInputvue_type_template_id_0a920412_staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('label',{staticClass:"cal-input-label",attrs:{"for":_vm.id}},[_vm._v(_vm._s(_vm.label))])
}]


// CONCATENATED MODULE: ./src/vue-components/form-input/TextAreaInput.vue?vue&type=template&id=0a920412

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/vue-components/form-input/TextAreaInput.vue?vue&type=script&lang=js

/* harmony default export */ var TextAreaInputvue_type_script_lang_js = ({
  name: "cal-textarea-input",
  props: {
    value: {
      type: [String, Number],
    },
    label: {
      type: String,
      required: true,
    },
    required: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    error: {
      type: Function,
    },
    rows: {
      type: Number,
      default: 5,
    },
    cols: {
      type: Number,
      default: 20,
    },
    maxLength: {
      type: Number,
      default: 5000,
    },
  },
  data() {
    return {
      localValue: this.value,
      errorMessage: null,
    };
  },
  created() {
    this.$nuxt.$on("runInputFieldsValidation", () => {
      this.errorValidation(this.localValue);
    });
  },
  computed: {
    id() {
      return this.label
        ? this.label.toLowerCase().replace(/\s+/g, "-") +
            "-" +
            Math.floor(1000 + Math.random() * 9000)
        : this.label;
    },
  },
  watch: {
    localValue(text) {
      this.$emit("input", text);
      this.errorValidation(text);
    },
    value: {
      handler(text) {
        this.localValue = text;
      },
      deep: true,
    },
  },
  methods: {
    errorValidation(text) {
      if (this.error) {
        this.errorMessage = this.error(text) || null;
      }
    },
  },
  beforeUnmount() {
    this.$nuxt.$off("runInputFieldsValidation");
  },
});

// CONCATENATED MODULE: ./src/vue-components/form-input/TextAreaInput.vue?vue&type=script&lang=js
 /* harmony default export */ var form_input_TextAreaInputvue_type_script_lang_js = (TextAreaInputvue_type_script_lang_js); 
// CONCATENATED MODULE: ./src/vue-components/form-input/TextAreaInput.vue





/* normalize component */

var TextAreaInput_component = normalizeComponent(
  form_input_TextAreaInputvue_type_script_lang_js,
  TextAreaInputvue_type_template_id_0a920412_render,
  TextAreaInputvue_type_template_id_0a920412_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var TextAreaInput = (TextAreaInput_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"9d9ca11a-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/vue-components/form-input/SelectInput.vue?vue&type=template&id=7dce5028
var SelectInputvue_type_template_id_7dce5028_render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"cal-input"},[(!_vm.isMobile)?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.localValue),expression:"localValue"}],staticClass:"cal-input-text cal-input-dropdown",attrs:{"id":_vm.id,"aria-haspopup":"listbox","aria-expanded":_vm.isOpen,"aria-activedescendant":_vm.activeDescendant,"aria-required":_vm.required,"aria-invalid":_vm.errorMessage,"role":"combobox","placeholder":_vm.label,"disabled":_vm.disabled,"required":_vm.required,"error-message":_vm.errorMessage},domProps:{"value":(_vm.localValue)},on:{"click":function($event){_vm.isOpen = !_vm.isOpen},"focusout":function($event){_vm.isOpen = false},"input":function($event){if($event.target.composing)return;_vm.localValue=$event.target.value}}}):_vm._e(),(!_vm.isMobile)?_c('span',{staticClass:"cal-input-dropdown-icon",class:_vm.isOpen ? 'cal-input-dropdown-icon-up' : 'cal-input-dropdown-icon-down',on:{"click":function($event){_vm.isOpen = !_vm.isOpen}}},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16","viewBox":"0 0 32 32"}},[_c('path',{attrs:{"fill":"none","stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"2","d":"M30 12L16 24L2 12"}})])]):_vm._e(),(!_vm.isMobile)?_c('ul',{staticClass:"cal-input-dropdown-list",attrs:{"is-open":_vm.isOpen,"role":"listbox"}},_vm._l((_vm.options),function(option,index){return _c('li',{key:index,staticClass:"cal-input-dropdown-list-item",attrs:{"id":'option-' + index,"aria-selected":option === _vm.localValue,"role":"option"},on:{"mousedown":function($event){$event.stopPropagation();$event.preventDefault();return _vm.handleSelectOption(option)}}},[_vm._v(" "+_vm._s(option)+" ")])}),0):_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.localValue),expression:"localValue"}],staticClass:"cal-input-text cal-input-select",attrs:{"name":_vm.label,"disabled":_vm.disabled,"required":_vm.required,"error-message":_vm.errorMessage},on:{"click":function($event){_vm.isOpen = !_vm.isOpen},"focusout":function($event){_vm.isOpen = false},"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.localValue=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"hidden":"","disabled":"","value":""}}),_vm._l((_vm.options),function(option,index){return _c('option',{key:index,on:{"touchstart":function($event){$event.stopPropagation();$event.preventDefault();return _vm.handleSelectOption(option)}}},[_vm._v(" "+_vm._s(option)+" ")])})],2),_vm._m(0)]),_c('p',{staticClass:"cal-input-error"},[_vm._v(_vm._s(_vm.errorMessage))])])
}
var SelectInputvue_type_template_id_7dce5028_staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('label',{staticClass:"cal-input-label",attrs:{"for":_vm.id}},[_vm._v(_vm._s(_vm.label))])
}]


// CONCATENATED MODULE: ./src/vue-components/form-input/SelectInput.vue?vue&type=template&id=7dce5028

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/vue-components/form-input/SelectInput.vue?vue&type=script&lang=js

/* harmony default export */ var SelectInputvue_type_script_lang_js = ({
  name: "cal-select-input",
  props: {
    value: {
      type: [String, Number],
    },
    label: {
      type: String,
      required: true,
    },
    required: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    error: {
      type: Function,
    },
    options: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      localValue: this.value,
      errorMessage: null,
      isOpen: false,
      selectedOptionId: "option-0",
    };
  },
  created() {
    this.$nuxt.$on("runInputFieldsValidation", () => {
      this.validation(this.localValue);
    });
  },
  methods: {
    handleSelectOption(option) {
      this.localValue = option;
      this.isOpen = false;
    },
    validation(option) {
      let indexOf = this.options.indexOf(option);
      if (indexOf === -1) {
        this.localValue = "";
      } else {
        this.selectedOptionId = "option-" + indexOf;
      }
      this.$emit("input", this.localValue);
      if (this.error) {
        this.errorMessage = this.error(this.localValue) || null;
      }
    },
  },
  watch: {
    localValue(option) {
      this.validation(option);
    },
    value: {
      handler(text) {
        this.localValue = text;
      },
      deep: true,
    },
  },
  computed: {
    activeDescendant() {
      return this.isOpen ? this.selectedOptionId : "";
    },
    isMobile() {
      const regex = /Mobi|Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;
      return regex.test(navigator.userAgent);
    },
    id() {
      return this.label
        ? this.label.toLowerCase().replace(/\s+/g, "-") +
            "-" +
            Math.floor(1000 + Math.random() * 9000)
        : this.label;
    },
  },
  beforeUnmount() {
    this.$nuxt.$off("runInputFieldsValidation");
  },
});

// CONCATENATED MODULE: ./src/vue-components/form-input/SelectInput.vue?vue&type=script&lang=js
 /* harmony default export */ var form_input_SelectInputvue_type_script_lang_js = (SelectInputvue_type_script_lang_js); 
// CONCATENATED MODULE: ./src/vue-components/form-input/SelectInput.vue





/* normalize component */

var SelectInput_component = normalizeComponent(
  form_input_SelectInputvue_type_script_lang_js,
  SelectInputvue_type_template_id_7dce5028_render,
  SelectInputvue_type_template_id_7dce5028_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var SelectInput = (SelectInput_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"9d9ca11a-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/vue-components/form-input/SimpleSelectInput.vue?vue&type=template&id=7b23c028
var SimpleSelectInputvue_type_template_id_7b23c028_render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"cal-simple-input"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.localValue),expression:"localValue"}],staticClass:"cal-simple-input-text cal-simple-input-select",attrs:{"name":_vm.label,"disabled":_vm.disabled,"required":_vm.required,"error-message":_vm.errorMessage},on:{"click":function($event){_vm.isOpen = !_vm.isOpen},"focusout":function($event){_vm.isOpen = false},"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.localValue=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"hidden":"","disabled":"","value":""}}),_vm._l((_vm.options),function(option,index){return _c('option',{key:index,on:{"touchstart":function($event){$event.stopPropagation();$event.preventDefault();return _vm.handleSelectOption(option)}}},[_vm._v(" "+_vm._s(option)+" ")])})],2),_vm._m(0)]),_c('p',{staticClass:"cal-simple-input-error"},[_vm._v(_vm._s(_vm.errorMessage))])])
}
var SimpleSelectInputvue_type_template_id_7b23c028_staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('label',{staticClass:"cal-simple-input-label",attrs:{"for":_vm.id}},[_vm._v(_vm._s(_vm.label))])
}]


// CONCATENATED MODULE: ./src/vue-components/form-input/SimpleSelectInput.vue?vue&type=template&id=7b23c028

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/vue-components/form-input/SimpleSelectInput.vue?vue&type=script&lang=js

/* harmony default export */ var SimpleSelectInputvue_type_script_lang_js = ({
  name: "cal-simple-select-input",
  props: {
    value: {
      type: [String, Number],
    },
    label: {
      type: String,
      required: false,
    },
    required: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    error: {
      type: Function,
    },
    options: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      localValue: this.value,
      errorMessage: null,
      isOpen: false,
      selectedOptionId: "option-0",
    };
  },
  created() {
    console.log(this.value);
    this.$nuxt.$on("runInputFieldsValidation", () => {
      this.validation(this.localValue);
    });
  },
  methods: {
    handleSelectOption(option) {
      this.localValue = option;
      this.isOpen = false;
    },
    validation(option) {
      let indexOf = this.options.indexOf(option);
      if (indexOf === -1) {
        this.localValue = "";
      } else {
        this.selectedOptionId = "option-" + indexOf;
      }
      this.$emit("input", this.localValue);
      if (this.error) {
        this.errorMessage = this.error(this.localValue) || null;
      }
    },
  },
  watch: {
    localValue(option) {
      this.validation(option);
    },
    value: {
      handler(text) {
        this.localValue = text;
      },
      deep: true,
    },
  },
  computed: {
    activeDescendant() {
      return this.isOpen ? this.selectedOptionId : "";
    },
    isMobile() {
      const regex = /Mobi|Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;
      return regex.test(navigator.userAgent);
    },
    id() {
      return this.label
        ? this.label.toLowerCase().replace(/\s+/g, "-") +
            "-" +
            Math.floor(1000 + Math.random() * 9000)
        : this.label;
    },
  },
  beforeUnmount() {
    this.$nuxt.$off("runInputFieldsValidation");
  },
});

// CONCATENATED MODULE: ./src/vue-components/form-input/SimpleSelectInput.vue?vue&type=script&lang=js
 /* harmony default export */ var form_input_SimpleSelectInputvue_type_script_lang_js = (SimpleSelectInputvue_type_script_lang_js); 
// CONCATENATED MODULE: ./src/vue-components/form-input/SimpleSelectInput.vue





/* normalize component */

var SimpleSelectInput_component = normalizeComponent(
  form_input_SimpleSelectInputvue_type_script_lang_js,
  SimpleSelectInputvue_type_template_id_7b23c028_render,
  SimpleSelectInputvue_type_template_id_7b23c028_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var SimpleSelectInput = (SimpleSelectInput_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"9d9ca11a-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/vue-components/loved-by/Loved-By.vue?vue&type=template&id=19fafeda
var Loved_Byvue_type_template_id_19fafeda_render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cal-loved-by"},[_c('h2',{staticClass:"cal-loved-by-text"},[_vm._v(" "+_vm._s(_vm.text)+" ")]),_c('div',{staticClass:"cal-loved-by-icons"},_vm._l((5),function(index){return _c('svg',{staticClass:"cal-loved-by-icon",attrs:{"xmlns":"http://www.w3.org/2000/svg","fill":"#0A9EA5","viewBox":"0 0 32 32","version":"1.1"}},[_c('g',[_c('title',[_vm._v("Star")]),_c('path',{attrs:{"d":"M3.488 13.184l6.272 6.112-1.472 8.608 7.712-4.064 7.712 4.064-1.472-8.608 6.272-6.112-8.64-1.248-3.872-7.808-3.872 7.808z"}})])])}),0)])
}
var Loved_Byvue_type_template_id_19fafeda_staticRenderFns = []


// CONCATENATED MODULE: ./src/vue-components/loved-by/Loved-By.vue?vue&type=template&id=19fafeda

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/vue-components/loved-by/Loved-By.vue?vue&type=script&lang=js

/* harmony default export */ var Loved_Byvue_type_script_lang_js = ({
  name: "cal-loved-by",
  props: ["text"],
});

// CONCATENATED MODULE: ./src/vue-components/loved-by/Loved-By.vue?vue&type=script&lang=js
 /* harmony default export */ var loved_by_Loved_Byvue_type_script_lang_js = (Loved_Byvue_type_script_lang_js); 
// CONCATENATED MODULE: ./src/vue-components/loved-by/Loved-By.vue





/* normalize component */

var Loved_By_component = normalizeComponent(
  loved_by_Loved_Byvue_type_script_lang_js,
  Loved_Byvue_type_template_id_19fafeda_render,
  Loved_Byvue_type_template_id_19fafeda_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var Loved_By = (Loved_By_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"9d9ca11a-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/vue-components/marketing-showcase/Marketing-Showcase.vue?vue&type=template&id=ab203310
var Marketing_Showcasevue_type_template_id_ab203310_render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cal-marketing-showcase"},[_c('h2',{staticClass:"cal-marketing-showcase-header"},[_vm._v(_vm._s(_vm.header))]),_c('div',{staticClass:"cal-marketing-showcase-list"},_vm._l((_vm.images),function(image,index){return _c('img',{key:`showcase_${index}`,staticClass:"cal-marketing-showcase-image",attrs:{"src":image.src,"alt":image.alt}})}),0)])
}
var Marketing_Showcasevue_type_template_id_ab203310_staticRenderFns = []


// CONCATENATED MODULE: ./src/vue-components/marketing-showcase/Marketing-Showcase.vue?vue&type=template&id=ab203310

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/vue-components/marketing-showcase/Marketing-Showcase.vue?vue&type=script&lang=js

/* harmony default export */ var Marketing_Showcasevue_type_script_lang_js = ({
  name: "cal-marketing-showcase",
  props: {
    header: "",
    images: [],
  },
});

// CONCATENATED MODULE: ./src/vue-components/marketing-showcase/Marketing-Showcase.vue?vue&type=script&lang=js
 /* harmony default export */ var marketing_showcase_Marketing_Showcasevue_type_script_lang_js = (Marketing_Showcasevue_type_script_lang_js); 
// CONCATENATED MODULE: ./src/vue-components/marketing-showcase/Marketing-Showcase.vue





/* normalize component */

var Marketing_Showcase_component = normalizeComponent(
  marketing_showcase_Marketing_Showcasevue_type_script_lang_js,
  Marketing_Showcasevue_type_template_id_ab203310_render,
  Marketing_Showcasevue_type_template_id_ab203310_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var Marketing_Showcase = (Marketing_Showcase_component.exports);
// CONCATENATED MODULE: ./src/vue-components/index.js









































// CONCATENATED MODULE: ./src/index.js


const install = (Vue, config = {}) => {
  Object.entries(vue_components_namespaceObject).forEach(([name, component]) => {
    Vue.component(`${name}`, component);
  });
};

if (typeof window !== "undefined" && window.Vue) {
  install(window.Vue);
}

/* harmony default export */ var src_0 = (install);


// CONCATENATED MODULE: ./node_modules/@vue/cli-service/lib/commands/build/entry-lib.js


/* harmony default export */ var entry_lib = __webpack_exports__["default"] = (src_0);



/***/ }),

/***/ "fe30":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ })

/******/ });
});
//# sourceMappingURL=calliaui.umd.js.map